{
  "% к прошлой неделе": "% өткен аптамен салыстырғанда",
  ". STEOS ID и финансовые квитанции сохраняются.": ". STEOS ID және қаржылық түбіртектер сақталады.",
  ". Готовые голоса доступны в разделе «Озвучка» → «Мои».": ". Дайын дауыстар «Дыбыстау» → «Менікі» бөлімінде қолжетімді.",
  ". Он не меняет голос озвучки чата.": ". Ол чаттағы дыбыстау дауысын өзгертпейді.",
  ". После подтверждения обновите профиль.": ". Расталғаннан кейін профильді жаңартыңыз.",
  ". Проверьте папку «Спам».": ". «Спам» қалтасын тексеріңіз.",
  "Circle каждый месяц по подписке": "Circle ай сайын жазылым бойынша",
  "Circle по подписке на этот месяц потрачены": "Осы айдағы жазылым Circle-дары жұмсалды",
  "STEOS ID · {0}": "STEOS ID · {0}",
  "STEOS ID · Не подключён": "STEOS ID · Қосылмаған",
  "Telegram ID скопирован.": "Telegram ID көшірілді.",
  "{0} {1} C сгорят {2}": "{0} {1} C {2} күні күйеді",
  "{0} из {1}": "{1} ішінен {0}",
  "{0} фото хватит для сходства": "Ұқсастық үшін {0} фото жеткілікті",
  "{0}: {1} работ": "{0}: {1} жұмыс",
  "{0}: пока недоступно": "{0}: әзірше қолжетімсіз",
  "· Вы и варианты": "· Сіз және нұсқалар",
  "· Новое": "· Жаңа",
  "· занято": "· бос емес",
  "· отменена": "· күші жойылды",
  "». Обучение начнётся после отдельного нажатия «Повторить обработку» в карточке.": "». Үйрету карточкадағы «Қайта өңдеу» түймесін бөлек басқаннан кейін басталады.",
  "Автовоспроизведение примеров": "Мысалдарды автоматты ойнату",
  "Аккаунт": "Аккаунт",
  "Аккаунт подключён": "Аккаунт қосылды",
  "Архив недоступен или срок ссылки истёк. Можно запросить новую выгрузку.": "Мұрағат қолжетімсіз немесе сілтеменің мерзімі аяқталған. Жаңа экспорт сұрауға болады.",
  "Бабушка": "Әже",
  "Баланс и вывод доступны в STEOS ID.": "Баланс пен қаражатты шығару STEOS ID ішінде қолжетімді.",
  "Баланс и награды": "Баланс және марапаттар",
  "Без имени": "Атаусыз",
  "Бесплатный план": "Тегін жоспар",
  "Ближайшие": "Жақындағылар",
  "Близкие": "Жақындар",
  "Близкий исчезнет из профиля. Его фото больше не будут доступны для новых работ.": "Жақын адамыңыз профильден жоғалады. Оның фотолары жаңа жұмыстар үшін енді қолжетімсіз болады.",
  "Близкий удалён.": "Жақын адамыңыз жойылды.",
  "Близких пока нет.": "Әзірге жақын адамдарыңыз жоқ.",
  "Брат": "Аға-іні",
  "В Steos с": "Steos-та тіркелген күні",
  "В избранное": "Таңдаулыларға қосу",
  "Валюта": "Валюта",
  "Вариант будет удалён. Исходные фото и STEOS ID сохранятся.": "Нұсқа жойылады. Бастапқы фотолар мен STEOS ID сақталады.",
  "Вариантов: {0}": "Нұсқалар саны: {0}",
  "Варианты": "Нұсқалар",
  "Ваш собственный голос": "Өз дауысыңыз",
  "Введите УДАЛИТЬ": "УДАЛИТЬ деп енгізіңіз",
  "Введите пароль": "Құпиясөзді енгізіңіз",
  "Введите почту": "Электрондық поштаны енгізіңіз",
  "Вернуться ко входу": "Кіруге оралу",
  "Версия": "Нұсқа",
  "Версия согласия изменилась. Обновите страницу и подтвердите актуальный текст.": "Келісім нұсқасы өзгерді. Бетті жаңартып, қолданыстағы мәтінді растаңыз.",
  "Версия согласия изменилась. Обновите страницу.": "Келісім нұсқасы өзгерді. Бетті жаңартыңыз.",
  "Версия:": "Нұсқасы:",
  "Взрослый": "Ересек",
  "Включаем микрофон…": "Микрофон қосылып жатыр…",
  "Включено": "Қосулы",
  "Возраст": "Жас",
  "Войти": "Кіру",
  "Восстановить пароль": "Құпиясөзді қалпына келтіру",
  "Все Circle на балансе без срока": "Балансыңыздағы Circle мерзімсіз",
  "Вы": "Сіз",
  "Вы и близкие": "Сіз және жақындарыңыз",
  "Вы и варианты": "Сіз және нұсқаларыңыз",
  "Выберите голос": "Дауысты таңдаңыз",
  "Выберите инструмент и заполните его форму. Готовая работа сохранится в истории.": "Құралды таңдап, оның формасын толтырыңыз. Дайын жұмыс тарихта сақталады.",
  "Выбран": "Таңдалды",
  "Выбрать голос": "Дауысты таңдау",
  "Выбрать голос по умолчанию": "Әдепкі дауысты таңдау",
  "Выбрать из работ": "Жұмыстардан таңдау",
  "Выгрузить мои данные": "Деректерімді экспорттау",
  "Выгрузка:": "Экспорт:",
  "Выключено": "Өшірулі",
  "Голос": "Дауыс",
  "Голос готов. Он доступен на вкладке «Мои» в озвучке.": "Дауыс дайын. Оны дыбыстау бөліміндегі «Менікі» қойындысынан таба аласыз.",
  "Голос и клон": "Дауыс және клон",
  "Голос изменился. Данные обновлены — проверьте их перед сохранением.": "Дауыс өзгерді. Деректер жаңартылды — сақтамас бұрын тексеріңіз.",
  "Голос изменился. Проверьте обновлённые данные перед повторной обработкой.": "Дауыс өзгерді. Қайта өңдемес бұрын жаңартылған деректерді тексеріңіз.",
  "Голос исчезнет из вашего списка. Это действие нельзя отменить.": "Дауыс тізіміңізден жоғалады. Бұл әрекетті болдырмау мүмкін емес.",
  "Голос по умолчанию для создания:": "Жасауға арналған әдепкі дауыс:",
  "Голос принят в обработку. Здесь появится его статус.": "Дауыс өңдеуге жіберілді. Оның күйі осында көрсетіледі.",
  "Голос уже удалён или недоступен.": "Дауыс әлдеқашан жойылған немесе қолжетімсіз.",
  "Голос:": "Дауыс:",
  "Голоса не найдены. Откройте каталог или измените поиск.": "Дауыстар табылмады. Каталогты ашыңыз немесе іздеу шартын өзгертіңіз.",
  "Горизонтальное": "Көлденең",
  "Готов": "Дайын",
  "Готовим образцы": "Үлгілер дайындалуда",
  "Готово": "Дайын",
  "Готовые работы": "Дайын жұмыстар",
  "Далее": "Келесі",
  "Данные Telegram обновлены.": "Telegram деректері жаңартылды.",
  "Данные баланса временно недоступны": "Баланс деректері уақытша қолжетімсіз",
  "Данные переносятся в подтверждённый аккаунт. Старые сессии закрыты; квитанция позволяет продолжить проверку после перезагрузки.": "Деректер расталған аккаунтқа көшірілуде. Ескі сеанстар жабылды; түбіртек қайта жүктегеннен кейін тексеруді жалғастыруға мүмкіндік береді.",
  "Дедушка": "Ата",
  "До 5 фото: лицо крупно, при хорошем свете": "5 фотоға дейін: бет жақыннан, жарық жақсы болсын",
  "До пяти фото. Они будут использоваться как ваш образ.": "Бес фотоға дейін. Олар сіздің бейнеңіз ретінде пайдаланылады.",
  "Добавить близкого": "Жақын адамды қосу",
  "Добавить фото": "Фото қосу",
  "Добавьте ещё": "Тағы қосыңыз",
  "Добавьте от 2 секунд до 1,5 минуты вашей речи. Говорите естественно, без музыки и других голосов.": "2 секундтан 1,5 минутқа дейінгі сөйлеу жазбасын қосыңыз. Музыкасыз және басқа дауыстарсыз табиғи сөйлеңіз.",
  "Дочь": "Қыз",
  "Друг": "Дос",
  "Если аккаунт существует, ссылка для нового пароля отправлена на": "Егер аккаунт бар болса, жаңа құпиясөзге арналған сілтеме мына мекенжайға жіберілді:",
  "Ещё варианты": "Тағы нұсқалар",
  "Ещё операции": "Тағы операциялар",
  "Ещё работы": "Тағы жұмыстар",
  "Жена": "Әйелі",
  "ЗАМЕНА ОБРАЗЦОВ": "ҮЛГІЛЕРДІ АУЫСТЫРУ",
  "Забыли пароль?": "Құпиясөзді ұмыттыңыз ба?",
  "Загружаем аккаунт…": "Аккаунт жүктелуде…",
  "Загружаем варианты…": "Нұсқалар жүктелуде…",
  "Загружаем ваши голоса…": "Дауыстарыңыз жүктелуде…",
  "Загружаем голоса…": "Дауыстар жүктелуде…",
  "Загружаем настройки…": "Баптаулар жүктелуде…",
  "Загружаем обновления…": "Жаңартулар жүктелуде…",
  "Загружаем операции…": "Операциялар жүктелуде…",
  "Загружаем пример…": "Мысал жүктелуде…",
  "Загружаем работы…": "Жұмыстар жүктелуде…",
  "Загружаем фото…": "Фотолар жүктелуде…",
  "Загрузить аудиофайлы": "Аудиофайлдарды жүктеу",
  "Загрузить выбранные фото": "Таңдалған фотоларды жүктеу",
  "Загрузка ещё не подтверждена. Нажмите «Продолжить отправку»: сначала проверим прежнюю загрузку.": "Жүктеу әлі расталмады. «Жіберуді жалғастыру» түймесін басыңыз: алдымен алдыңғы жүктеуді тексереміз.",
  "Загрузка не подтверждена. Продолжение сначала проверит прежние загрузки.": "Жүктеу расталмады. Жалғастырғанда алдымен алдыңғы жүктеулер тексеріледі.",
  "Загрузка отклонена. Нажмите «Продолжить отправку», чтобы получить новую ссылку и загрузить образец.": "Жүктеуден бас тартылды. Жаңа сілтеме алып, үлгіні жүктеу үшін «Жіберуді жалғастыру» түймесін басыңыз.",
  "Закрыть": "Жабу",
  "Закрыть мастер": "Шеберді жабу",
  "Заменить образцы": "Үлгілерді ауыстыру",
  "Записать с микрофона": "Микрофоннан жазу",
  "Запись": "Жазба",
  "Запись здесь недоступна. Откройте приложение по HTTPS или загрузите аудиофайл.": "Мұнда жазу қолжетімді емес. Қолданбаны HTTPS арқылы ашыңыз немесе аудиофайл жүктеңіз.",
  "Запись прервалась. Попробуйте ещё раз или загрузите файл.": "Жазу үзіліп қалды. Қайталап көріңіз немесе файл жүктеңіз.",
  "Запись-{0}.{1}": "Жазба-{0}.{1}",
  "Запишите образец, дождитесь обучения и озвучивайте текст своим голосом.": "Үлгіні жазып, үйретудің аяқталуын күтіңіз, содан кейін мәтінді өз дауысыңызбен дыбыстаңыз.",
  "Запишите речь или загрузите аудиофайлы": "Сөйлеуді жазыңыз немесе аудиофайлдарды жүктеңіз",
  "Запишите свой голос один раз — используйте его в озвучке.": "Дауысыңызды бір рет жазып алыңыз — оны дыбыстауда пайдаланыңыз.",
  "Запрос сохранён. Продолжение проверит прежний запрос и не создаст второй голос.": "Сұрау сақталды. Жалғастырғанда алдыңғы сұрау тексеріліп, екінші дауыс жасалмайды.",
  "Запустить обработку": "Өңдеуді бастау",
  "Здесь появятся ваши работы": "Жұмыстарыңыз осында көрсетіледі",
  "Из них": "Оның ішінде",
  "Из них {0} C можно вывести": "Оның ішінде {0} C шығарып алуға болады",
  "Избранное": "Таңдаулылар",
  "Избранные работы": "Таңдаулы жұмыстар",
  "Изменение не подтверждено. Проверьте актуальную карточку перед повтором.": "Өзгеріс расталмады. Қайта әрекет жасамас бұрын қолданыстағы карточканы тексеріңіз.",
  "Изменить": "Өзгерту",
  "Изменить близкого": "Жақын адамды өзгерту",
  "Изменить вариант": "Нұсқаны өзгерту",
  "Изменить голос": "Дауысты өзгерту",
  "Изменить мои фото": "Фотоларымды өзгерту",
  "Имя близкого": "Жақын адамның аты",
  "Имя голоса": "Дауыс атауы",
  "Имя пользователя не задано": "Пайдаланушы аты көрсетілмеген",
  "Использовать как себя": "Өзім ретінде пайдалану",
  "Используем сохранённые образцы голоса «": "Сақталған дауыс үлгілерін пайдалану: «",
  "Используйте свои фото и фото близких в инструментах студии.": "Студия құралдарында өз фотоларыңыз бен жақындарыңыздың фотоларын пайдаланыңыз.",
  "История очищена: {0} работ, {1} заказов.": "Тарих тазартылды: {0} жұмыс, {1} тапсырыс.",
  "КЛОН ГОЛОСА": "ДАУЫС КЛОНЫ",
  "Каждый образец должен содержать хотя бы одну секунду речи.": "Әр үлгіде кемінде бір секунд сөйлеу болуы керек.",
  "Как в системе": "Жүйедегідей",
  "Как пользоваться": "Қалай пайдалану",
  "Как снимать": "Қалай түсіру керек",
  "Каталог голосов": "Дауыстар каталогы",
  "Квадрат": "Шаршы",
  "Кем приходится": "Туыстық қатынасы",
  "Ко входу": "Кіруге",
  "Количество вариантов пока недоступно": "Нұсқалар саны әзірше қолжетімсіз",
  "Конфиденциальность": "Құпиялылық",
  "Копирование недоступно. ID показан в карточке аккаунта.": "Көшіру қолжетімсіз. ID аккаунт карточкасында көрсетілген.",
  "Кружок с героем": "Кейіпкері бар бейнехабар",
  "Лимит {0} голосов выбран": "{0} дауыс лимиті таңдалды",
  "Лимит голосов выбран. Удалите ненужный голос, чтобы добавить новый.": "Дауыс лимитіне жеттіңіз. Жаңасын қосу үшін қажетсіз дауысты жойыңыз.",
  "Лимит:": "Лимит:",
  "Мама": "Ана",
  "Можно добавить до {0} образцов.": "{0} үлгіге дейін қосуға болады.",
  "Можно закрыть приложение. Статус обновится после обработки.": "Қолданбаны жабуға болады. Өңдеу аяқталғаннан кейін күйі жаңартылады.",
  "Мои варианты": "Менің нұсқаларым",
  "Мои голоса": "Менің дауыстарым",
  "Мои данные": "Менің деректерім",
  "Мои фото": "Менің фотоларым",
  "Моё": "Менікі",
  "Моё фото": "Менің фотом",
  "Муж": "Күйеуі",
  "НОВЫЙ ГОЛОС": "ЖАҢА ДАУЫС",
  "Награды": "Марапаттар",
  "Награды и задания": "Сыйақылар мен тапсырмалар",
  "Назад": "Артқа",
  "Название варианта": "Нұсқа атауы",
  "Назначить голос": "Дауысты тағайындау",
  "Настройки": "Баптаулар",
  "Настройки уже изменились. Показана актуальная версия.": "Баптаулар әлдеқашан өзгерген. Қолданыстағы нұсқа көрсетілген.",
  "Начните с 2 секунд речи в тихом месте.": "Тыныш жерде 2 секунд сөйлеуден бастаңыз.",
  "Не больше 5 фото JPEG или PNG, до 10 МБ каждое.": "Әрқайсысы 10 МБ-қа дейінгі 5 JPEG немесе PNG фотоға дейін.",
  "Не задано": "Көрсетілмеген",
  "Не короче 8 знаков": "Кемінде 8 таңба",
  "Не удалось включить микрофон. Разрешите доступ или загрузите файл.": "Микрофонды қосу мүмкін болмады. Қол жеткізуге рұқсат беріңіз немесе файл жүктеңіз.",
  "Не удалось войти. Откройте приложение из Telegram заново.": "Кіру мүмкін болмады. Қолданбаны Telegram ішінен қайта ашыңыз.",
  "Не удалось воспроизвести пример. Откройте карточку заново и попробуйте ещё раз.": "Мысалды ойнату мүмкін болмады. Карточканы қайта ашып, қайталап көріңіз.",
  "Не удалось загрузить варианты.": "Нұсқаларды жүктеу мүмкін болмады.",
  "Не удалось загрузить голоса. Измените поиск или вкладку, чтобы повторить.": "Дауыстарды жүктеу мүмкін болмады. Қайталау үшін іздеуді немесе қойындыны өзгертіңіз.",
  "Не удалось загрузить настройки. Попробуйте обновить.": "Баптауларды жүктеу мүмкін болмады. Жаңартып көріңіз.",
  "Не удалось загрузить работы.": "Жұмыстарды жүктеу мүмкін болмады.",
  "Не удалось загрузить следующую страницу.": "Келесі бетті жүктеу мүмкін болмады.",
  "Не удалось загрузить следующую страницу. Попробуйте ещё раз.": "Келесі бетті жүктеу мүмкін болмады. Қайталап көріңіз.",
  "Не удалось обновить данные из Telegram. Попробуйте позже.": "Telegram-нан деректерді жаңарту мүмкін болмады. Кейінірек қайталап көріңіз.",
  "Не удалось подтвердить изменение избранного. Обновите профиль.": "Таңдаулы өзгерісін растау мүмкін болмады. Профильді жаңартыңыз.",
  "Не удалось подтвердить операцию. Проверьте состояние аккаунта перед повтором.": "Операцияны растау мүмкін болмады. Қайталап көрмес бұрын аккаунт күйін тексеріңіз.",
  "Не удалось подтвердить сохранение. Обновите настройки перед повтором.": "Сақтауды растау мүмкін болмады. Қайталап көрмес бұрын баптауларды жаңартыңыз.",
  "Не удалось подтвердить удаление близкого. Обновите профиль.": "Жақын адамды жоюды растау мүмкін болмады. Профильді жаңартыңыз.",
  "Не удалось получить ответ. Попробуйте ещё раз — запрос продолжится с прежним ключом.": "Жауап алу мүмкін болмады. Қайталап көріңіз — сұрау бұрынғы кілтпен жалғасады.",
  "Не удалось проверить выгрузку. Обновите страницу: продолжим прежнюю операцию.": "Экспортты тексеру мүмкін болмады. Бетті жаңартыңыз: алдыңғы операция жалғасады.",
  "Не удалось прочитать запись.": "Жазбаны оқу мүмкін болмады.",
  "Не удалось создать голос. Откройте карточку, чтобы проверить статус или повторить обработку.": "Дауыс жасау мүмкін болмады. Күйін тексеру немесе өңдеуді қайталау үшін карточканы ашыңыз.",
  "Не удалось создать голос. Проверьте данные и образцы.": "Дауыс жасау мүмкін болмады. Деректер мен үлгілерді тексеріңіз.",
  "Не удалось сохранить просмотр. Можно закрыть и вернуться позже.": "Қаралған күйді сақтау мүмкін болмады. Қолданбаны жауып, кейінірек оралуға болады.",
  "Неверная почта или пароль": "Электрондық пошта немесе құпиясөз қате",
  "Нет работ": "Жұмыстар жоқ",
  "Новая выгрузка": "Жаңа экспорт",
  "Новости": "Жаңалықтар",
  "Новый вариант": "Жаңа нұсқа",
  "Новый голос": "Жаңа дауыс",
  "Новых публикаций пока нет.": "Әзірге жаңа жарияланымдар жоқ.",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме.": "Жалпы ұзақтығы 2 секундтан 1,5 минутқа дейінгі сөйлеу қажет.",
  "О приложении": "Қолданба туралы",
  "Обновить": "Жаңарту",
  "Обновить варианты": "Нұсқаларды жаңарту",
  "Обновить из Telegram": "Telegram-нан жаңарту",
  "Обновить настройки": "Баптауларды жаңарту",
  "Обновить профиль": "Профильді жаңарту",
  "Обновить работы": "Жұмыстарды жаңарту",
  "Обновления": "Жаңартулар",
  "Обновляем вход…": "Кіру жаңартылуда…",
  "Обрабатывается": "Өңделуде",
  "Образ готов": "Бейне дайын",
  "Образ ещё не собран": "Бейне әлі жасалмаған",
  "Образец {0}": "Үлгі {0}",
  "Образец голоса": "Дауыс үлгісі",
  "Образец ещё не проверен. Подождите и продолжите отправку.": "Үлгі әлі тексерілмеген. Күтіп, жіберуді жалғастырыңыз.",
  "Образец не прошёл проверку. Выберите другую запись.": "Үлгі тексеруден өтпеді. Басқа жазбаны таңдаңыз.",
  "Образцы готовы к повторной обработке.": "Үлгілер қайта өңдеуге дайын.",
  "Образцы для «": "Мынаған арналған үлгілер: «",
  "Образцы обновлены. Нажмите «Повторить обработку», чтобы обучить голос заново.": "Үлгілер жаңартылды. Дауысты қайта үйрету үшін «Қайта өңдеу» түймесін басыңыз.",
  "Обучаем голос": "Дауыс үйретілуде",
  "Общая длительность образцов не должна превышать 1,5 минуты.": "Үлгілердің жалпы ұзақтығы 1,5 минуттан аспауы керек.",
  "Объединение STEOS ID": "STEOS ID біріктіру",
  "Объединяем аккаунты": "Аккаунттар біріктірілуде",
  "Объём образцов": "Үлгілер ұзақтығы",
  "Один аккаунт для бота и сайта STEOS": "STEОS боты мен сайтына арналған бір аккаунт",
  "Озвучить текст голосом «": "Мына дауыспен мәтінді дыбыстау: «",
  "Операции": "Операциялар",
  "Операции в токенах STEOS ID": "STEOS ID токендеріндегі операциялар",
  "Операции временно недоступны.": "Операциялар уақытша қолжетімсіз.",
  "Операций пока нет.": "Әзірге операциялар жоқ.",
  "Операция не подтверждена. Повтор использует прежний ключ.": "Операция расталмады. Қайталау кезінде бұрынғы кілт пайдаланылады.",
  "Описание": "Сипаттама",
  "Описание и согласие": "Сипаттама және келісім",
  "Остановить запись ·": "Жазуды тоқтату ·",
  "Остаток Circle недоступен": "Circle қалдығы қолжетімсіз",
  "Отклик": "Діріл",
  "Откройте ссылку из письма и задайте новый пароль на id.steos.io. Потом войдите здесь.": "Хаттағы сілтемені ашып, id.steos.io сайтында жаңа құпиясөз орнатыңыз. Содан кейін осында кіріңіз.",
  "Откройте ссылку подтверждения для": "Мына мекенжай үшін растау сілтемесін ашыңыз:",
  "Открыть id.steos.io": "id.steos.io сайтын ашу",
  "Открыть историю": "Тарихты ашу",
  "Отмена": "Бас тарту",
  "Отметьте согласие с условиями": "Шарттармен келісетініңізді белгілеңіз",
  "Отправить ссылку": "Сілтемені жіберу",
  "Отправляем…": "Жіберілуде…",
  "Оформить подписку": "Жазылымды рәсімдеу",
  "Оформление": "Сыртқы көрініс",
  "Очистить историю": "Тарихты тазарту",
  "Очистить историю?": "Тарих тазартылсын ба?",
  "Очистка не подтверждена. Повтор проверит прежнюю операцию.": "Тазарту расталмады. Қайталау кезінде алдыңғы операция тексеріледі.",
  "Очищаем…": "Тазартылуда…",
  "Ошибка": "Қате",
  "Папа": "Әке",
  "Пароль": "Құпиясөз",
  "Переименовать вариант": "Нұсқаның атын өзгерту",
  "Перенос ещё не подтверждён. Квитанция сохранена; проверка продолжится.": "Тасымалдау әлі расталмады. Түбіртек сақталды; тексеру жалғасады.",
  "Перенос завершён, обновляем вход…": "Тасымалдау аяқталды, кіру жаңартылуда…",
  "Переносим данные в существующий STEOS ID. После переноса приложение обновит сессию. Не запускайте повторное объединение.": "Деректер бар STEOS ID аккаунтына тасымалдануда. Тасымалдаудан кейін қолданба сеансты жаңартады. Біріктіруді қайта бастамаңыз.",
  "Письмо отправлено": "Хат жіберілді",
  "Питомец": "Үй жануары",
  "Повторить загрузку": "Қайта жүктеу",
  "Повторить обработку": "Қайта өңдеу",
  "Подготовить ZIP для скачивания": "Жүктеп алу үшін ZIP дайындау",
  "Поддержка": "Қолдау қызметі",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже или откройте сайт STEOS ID.": "STEOS ID-ге қосылу қазір қолжетімсіз. Кейінірек қайталап көріңіз немесе STEOS ID сайтын ашыңыз.",
  "Подключён": "Қосылған",
  "Подключён:": "Қосылған:",
  "Подруга": "Құрбы",
  "Подтвердите почту": "Электрондық поштаңызды растаңыз",
  "Подтвердите согласие перед отправкой образцов.": "Үлгілерді жібермес бұрын келісімді растаңыз.",
  "Подтвердить очистку истории": "Тарихты тазартуды растау",
  "Подтвердить удаление": "Жоюды растау",
  "Подтвердить удаление аккаунта": "Аккаунтты жоюды растау",
  "Подтвердить удаление близкого": "Жақын адамды жоюды растау",
  "Подтвердить удаление варианта": "Нұсқаны жоюды растау",
  "Поиск голоса": "Дауысты іздеу",
  "Поиск по имени": "Аты бойынша іздеу",
  "Пока нет своих голосов": "Әзірге өз дауыстарыңыз жоқ",
  "Показать ещё": "Тағы көрсету",
  "Показать ещё голоса": "Тағы дауыстарды көрсету",
  "Показать пароль": "Құпиясөзді көрсету",
  "Пополнить": "Толықтыру",
  "Попробовать": "Байқап көру",
  "Портрет": "Портрет",
  "Пост": "Жазба",
  "Потрачено Circle:": "Жұмсалған Circle:",
  "Почта": "Электрондық пошта",
  "Почта уже занята": "Бұл электрондық пошта бос емес",
  "Почта уже занята, войдите с ней": "Бұл электрондық пошта бос емес, сол мекенжаймен кіріңіз",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Расскажу, как прошёл мой день, что меня порадовало и какие планы у меня на завтра. Продолжайте говорить своими словами не меньше тридцати секунд.": "Сәлем! Бұл — менің дауысым үшін жазылған үлгі. Мен досыммен сөйлескендей, сабырлы әрі қалыпты қарқынмен сөйлеймін. Күнімнің қалай өткенін, мені не қуантқанын және ертеңге қандай жоспарларым бар екенін айтып беремін. Кемінде отыз секунд бойы өз сөзіңізбен сөйлей беріңіз.",
  "Приглашайте друзей": "Достарды шақырыңыз",
  "Пример голоса {0}": "Дауыс мысалы {0}",
  "Принимаю": "Қабылдаймын",
  "Присылать готовые работы в чат": "Дайын жұмыстарды чатқа жіберу",
  "Проверен": "Тексерілді",
  "Проверить выгрузку": "Экспортты тексеру",
  "Проверить подтверждение": "Растауды тексеру",
  "Проверка голоса не пройдена. Запишите образец без музыки и других людей.": "Дауыс тексеруден өтпеді. Музыкасыз және басқа адамдардың дауысынсыз үлгі жазыңыз.",
  "Проверка образцов не пройдена. Попробуйте чистую запись одного голоса.": "Үлгілер тексеруден өтпеді. Бір адамның таза жазбасын пайдаланып көріңіз.",
  "Проверьте адрес": "Мекенжайды тексеріңіз",
  "Проверяем запись": "Жазба тексерілуде",
  "Проверяем образец {0} из {1}…": "{1} үлгінің {0}-сі тексерілуде…",
  "Проверяем состояние переноса…": "Тасымалдау күйі тексерілуде…",
  "Проверяем…": "Тексерілуде…",
  "Проверяйте остаток в профиле и получайте доступные награды.": "Қалған балансты профильден тексеріп, қолжетімді марапаттарды алыңыз.",
  "Продолжим проверку прежнего запроса, без повторного запуска.": "Алдыңғы сұрауды қайта іске қоспай, тексеруді жалғастырамыз.",
  "Продолжим сохранённый запрос с теми же данными.": "Сақталған сұрауды сол деректермен жалғастырамыз.",
  "Продолжить отправку": "Жіберуді жалғастыру",
  "Продолжить проверку": "Тексеруді жалғастыру",
  "Продолжить создание голоса": "Дауыс жасауды жалғастыру",
  "Продолжить сохранение": "Сақтауды жалғастыру",
  "Прослушать {0}": "{0} тыңдау",
  "Профиль": "Профиль",
  "Профиль «Вы» пока недоступен.": "«Сіз» профилі әзірше қолжетімсіз.",
  "Профиль уже изменился. Закройте форму и откройте актуальную версию.": "Профиль әлдеқашан өзгерген. Форманы жауып, қолданыстағы нұсқаны ашыңыз.",
  "Работ в этом списке пока нет.": "Бұл тізімде әзірге жұмыстар жоқ.",
  "Работа №": "№ жұмыс",
  "Работы и параметры заказов исчезнут из истории. Голоса, варианты «Вы» и близкие останутся. Финансовые квитанции сохраняются. Вернуть историю нельзя.": "Жұмыстар мен тапсырыс параметрлері тарихтан жойылады. Дауыстар, «Сіз» нұсқалары және жақындарыңыз сақталады. Қаржылық түбіртектер сақталады. Тарихты қалпына келтіру мүмкін емес.",
  "Работы по неделям": "Апталар бойынша жұмыстар",
  "Раздел профиля": "Профиль бөлімі",
  "Разделы профиля": "Профиль бөлімдері",
  "Размер каждого образца должен быть от 1 байта до 20 МБ.": "Әр үлгінің өлшемі 1 байттан 20 МБ-қа дейін болуы керек.",
  "Ребёнок": "Бала",
  "Результат обработки уточняется. Повторный запуск пока недоступен.": "Өңдеу нәтижесі нақтылануда. Әзірге қайта іске қосу қолжетімсіз.",
  "Русский": "Русский",
  "С": "Бастап",
  "Сбросить голос по умолчанию": "Әдепкі дауысты қалпына келтіру",
  "Светлая": "Жарық",
  "Свой аватар": "Жеке аватар",
  "Сгорят {0}, если не потратить": "Жұмсамасаңыз, {0} күйіп кетеді",
  "Сделать кружок": "Бейнехабар жасау",
  "Серия:": "Серия:",
  "Сестра": "Әпке-сіңлі",
  "Скачать ZIP": "ZIP жүктеп алу",
  "Скопировать Telegram ID": "Telegram ID көшіру",
  "Скорость речи": "Сөйлеу жылдамдығы",
  "Скрыть пароль": "Құпиясөзді жасыру",
  "Слишком много запросов. Подождите немного и попробуйте ещё раз.": "Сұраулар тым көп. Біраз күтіп, қайталап көріңіз.",
  "Слишком много попыток. Попробуйте позже.": "Әрекет тым көп. Кейінірек қайталап көріңіз.",
  "Снимайте лицо без фильтров и тёмных очков, при ровном освещении. Добавьте разные ракурсы. В кадре должен быть один человек.": "Бетті сүзгісіз және қара көзілдіріксіз, біркелкі жарықта түсіріңіз. Әртүрлі бұрыштан түсірілген фотоларды қосыңыз. Кадрда бір адам ғана болуы керек.",
  "Снять голос": "Дауысты жазу",
  "Снять фото": "Фото түсіру",
  "Согласие изменилось до начала обучения. Обновите страницу и подтвердите актуальную версию перед повторной обработкой.": "Үйрету басталғанға дейін келісім өзгерді. Бетті жаңартып, қайта өңдемес бұрын қолданыстағы нұсқаны растаңыз.",
  "Создавайте говорящие кружки с выбранным персонажем или своим образом.": "Таңдалған кейіпкермен немесе өз бейнеңізбен сөйлейтін дөңгелек видеолар жасаңыз.",
  "Создание": "Жасау",
  "Создание голосов временно недоступно. Образцы сохранены в этом окне.": "Дауыстарды жасау уақытша қолжетімсіз. Үлгілер осы терезеде сақталды.",
  "Создание новых голосов пока недоступно. Уже созданные голоса доступны ниже.": "Жаңа дауыстар жасау әзірше қолжетімсіз. Бұрын жасалған дауыстар төменде қолжетімді.",
  "Создано:": "Жасалған күні:",
  "Создан {0}": "Жасалған күні: {0}",
  "Создать аккаунт": "Аккаунт жасау",
  "Создать голос": "Дауыс жасау",
  "Создаём голос…": "Дауыс жасалуда…",
  "Сохранение настроек создания сейчас выключено.": "Жасау баптауларын сақтау қазір өшірулі.",
  "Сохранение не подтверждено. Закройте форму и проверьте актуальный профиль.": "Сақтау расталмады. Форманы жауып, қолданыстағы профильді тексеріңіз.",
  "Сохранение не подтверждено. Повтор создания использует прежний запрос.": "Сақтау расталмады. Жасауды қайталау кезінде бұрынғы сұрау пайдаланылады.",
  "Сохранение недоступно.": "Сақтау қолжетімсіз.",
  "Сохранено": "Сақталды",
  "Сохранить": "Сақтау",
  "Сохранить близкого": "Жақын адамды сақтау",
  "Сохранить вариант": "Нұсқаны сақтау",
  "Сохранить голос по умолчанию": "Әдепкі дауысты сақтау",
  "Сохранить мои фото": "Фотоларымды сақтау",
  "Сохранить образцы": "Үлгілерді сақтау",
  "Сохраняем образцы…": "Үлгілер сақталуда…",
  "Сохраняем…": "Сақталуда…",
  "Сохранённые варианты себя доступны в профиле и инструментах создания.": "Өзіңіздің сақталған нұсқаларыңыз профильде және жасау құралдарында қолжетімді.",
  "Сохранённых вариантов пока нет.": "Әзірге сақталған нұсқалар жоқ.",
  "Сроки партий Circle временно недоступны": "Circle топтарының мерзімі уақытша қолжетімсіз",
  "Старший": "Үлкен",
  "Статистика": "Статистика",
  "Статистика по неделям временно недоступна.": "Апталар бойынша статистика уақытша қолжетімсіз.",
  "Статус удаления временно недоступен. Квитанция сохранена в этой вкладке.": "Жою күйі уақытша қолжетімсіз. Түбіртек осы қойындыда сақталды.",
  "Сторис": "Стористер",
  "Сын": "Ұл",
  "Тариф": "Тариф",
  "Текст для чтения": "Оқуға арналған мәтін",
  "Тема": "Тақырып",
  "Тема сохраняется на этом устройстве.": "Тақырып осы құрылғыда сақталады.",
  "Тёмная": "Қараңғы",
  "У меня есть право использовать эти фотографии и согласие изображённых людей.": "Менің бұл фотоларды пайдалануға құқығым бар және суреттегі адамдардың келісімін алдым.",
  "УДАЛИТЬ": "УДАЛИТЬ",
  "Убираем шум": "Шуды азайту",
  "Убрать": "Алып тастау",
  "Убрать {0}": "{0} алып тастау",
  "Убрать из избранного": "Таңдаулылардан алып тастау",
  "Убрать фоновый шум": "Фондық шуды азайту",
  "Убрать фото": "Фотосуретті алып тастау",
  "Уведомления": "Хабарландырулар",
  "Уведомления недоступны.": "Хабарландырулар қолжетімсіз.",
  "Уведомления пока недоступны.": "Хабарландырулар әзірше қолжетімсіз.",
  "Удаление аккаунта Mini App": "Mini App аккаунтын жою",
  "Удаление:": "Жойылуы:",
  "Удалить": "Жою",
  "Удалить «": "« алып тастау",
  "Удалить «{0}»?": "«{0}» жойылсын ба?",
  "Удалить аккаунт Mini App": "Mini App аккаунтын жою",
  "Удалить близкого": "Жақын адамды жою",
  "Удалить вариант": "Нұсқаны жою",
  "Удалить голос": "Дауысты жою",
  "Удаляем…": "Жойылуда…",
  "Удаляется": "Жойылуда",
  "Українська": "Українська",
  "Условия использования": "Пайдалану шарттары",
  "Файл": "Файл",
  "Формат": "Пішім",
  "Фото Telegram": "Telegram фотосы",
  "Фото {0}": "Фото {0}",
  "Фото и имя берутся из вашего профиля в Telegram. Если вы их сменили, обновите данные здесь.": "Фото мен ат Telegram профиліңізден алынады. Егер оларды өзгертсеңіз, деректерді осында жаңартыңыз.",
  "Фото и фотосессия": "Фото және фотосессия",
  "Фото перед загрузкой": "Жүктеу алдындағы фото",
  "Фото профиля": "Профиль фотосы",
  "Фото профиля Telegram": "Telegram профиль фотосы",
  "Фото, голоса, близкие и данные Mini App будут удалены во всех сервисах. STEOS ID и финансовые квитанции останутся. Отменить удаление нельзя.": "Фотолар, дауыстар, жақын адамдар және Mini App деректері барлық сервистерден жойылады. STEOS ID мен қаржылық түбіртектер сақталады. Жоюды болдырмау мүмкін емес.",
  "Фото:": "Фото:",
  "Часть профиля временно недоступна. Попробуйте обновить.": "Профильдің бір бөлігі уақытша қолжетімсіз. Жаңартып көріңіз.",
  "Читаем аудиофайлы…": "Аудиофайлдар оқылуда…",
  "Что нового": "Жаңалықтар",
  "Что нового пока не опубликовано или временно недоступно.": "Жаңалықтар әлі жарияланбаған немесе уақытша қолжетімсіз.",
  "Что нового пока не опубликовано.": "Жаңалықтар әлі жарияланбаған.",
  "Шаблоны": "Үлгілер",
  "Шаблоны и рилс": "Үлгілер және рилстер",
  "Эта неделя": "Осы апта",
  "Этот голос используется:": "Бұл дауыс мына жерде пайдаланылады:",
  "Этот запуск пока нельзя повторить. Обновите статус голоса.": "Бұл іске қосуды әзірше қайталау мүмкін емес. Дауыс күйін жаңартыңыз.",
  "Этот формат не поддерживается. Выберите MP3, WAV, M4A, OGG или WebM.": "Бұл пішімге қолдау көрсетілмейді. MP3, WAV, M4A, OGG немесе WebM таңдаңыз.",
  "Язык аккаунта": "Аккаунт тілі",
  "готова": "дайын",
  "готова частично": "ішінара дайын",
  "дата недоступна": "күн қолжетімсіз",
  "для переозвучки": "қайта дыбыстауға арналған",
  "до {0}, потом {1}": "{0}-ге дейін, содан кейін {1}",
  "другой тариф": "басқа тариф",
  "закончится {0}": "{0} күні аяқталады",
  "и": "және",
  "из": "ішінен",
  "из 1:30 · минимум 0:02": "1:30 ішінен · ең азы 0:02",
  "лимит уточняется": "лимит нақтылануда",
  "не задан": "берілмеген",
  "не назначен": "тағайындалмаған",
  "новых": "жаңа",
  "образец": "үлгі",
  "образца": "үлгінің",
  "образцов": "үлгілер",
  "оплачено до {0}": "{0} күніне дейін төленген",
  "подарок до {0}": "{0} күніне дейінгі сыйлық",
  "пока недоступно": "әзірше қолжетімсіз",
  "политику конфиденциальности STEOS": "STEОS құпиялылық саясаты",
  "продлится {0}": "{0} ұзартылады",
  "речи.": "сөйлеу.",
  "токенов": "токен",
  "условия": "шарттар",
  "уточняется": "нақтылануда",
  "Қазақша": "Қазақша",
  "← Профиль": "← Профиль",
  "▶ Прослушать": "▶ Тыңдау",
  "Озвучка": "Дыбыстау",
  "Клон": "Клон",
  "Студия": "Студия",
  "Баланс": "Теңгерім",
  "История": "Тарих",
  "Ещё": "Тағы",
  "Клонирование голоса": "Дауысты клондау",
  "Партнёрство": "Серіктестік",
  "Добавить в чат": "Чатқа қосу",
  "Разделы": "Бөлімдер",
  "Главное меню": "Басты мәзір",
  "Выберите": "Таңдаңыз",
  "После объединения сохранены все фото. Оставьте до пяти, чтобы изменить образ.": "Біріктіргеннен кейін барлық фотосурет сақталды. Бейнеңізді өзгерту үшін беске дейін фотосурет қалдырыңыз.",
  "Абзацы": "Абзацтар",
  "Альбом": "Альбом",
  "Аудио": "Аудио",
  "Без изменения": "Өзгеріссіз",
  "Бесплатно по текущему тестовому dev-тарифу.": "Қолданыстағы dev-тариф бойынша тегін.",
  "Бесплатно по тестовому dev-тарифу": "Сынақ dev-тарифі бойынша тегін",
  "В избранном пока пусто": "Таңдаулылар әзірге бос",
  "В очереди": "Кезекте",
  "Вариант {0}": "{0}-нұсқа",
  "Введите текст до 1000 символов": "1000 таңбаға дейін мәтін енгізіңіз",
  "Вернули": "Қайтарылды",
  "Вернуть запись в историю не получится. Файл в чате останется.": "Жазбаны тарихқа қайтару мүмкін емес. Файл чатта қалады.",
  "Видео": "Бейне",
  "Виды работ": "Жұмыс түрлері",
  "Все": "Барлығы",
  "Вчера": "Кеше",
  "Выбранный вариант": "Таңдалған нұсқа",
  "Выбранный вариант недоступен. Вернитесь в профиль и обновите список.": "Таңдалған нұсқа қолжетімді емес. Профильге оралып, тізімді жаңартыңыз.",
  "Выполняется": "Орындалуда",
  "Высота голоса": "Дауыс биіктігі",
  "Говорящее видео": "Сөйлейтін видео",
  "Голоса": "Дауыстар",
  "Дата неизвестна": "Күні белгісіз",
  "Длительность": "Ұзақтығы",
  "Для этого действия пока нет доступного опубликованного инструмента.": "Бұл әрекет үшін әзірге жарияланған қолжетімді құрал жоқ.",
  "Дополнительное поле": "Қосымша өріс",
  "Заголовок": "Тақырып",
  "Загружаем историю…": "Тарих жүктелуде…",
  "Загружаем работу…": "Жұмыс жүктелуде…",
  "Загружаем результат…": "Нәтиже жүктелуде…",
  "Загружаем…": "Жүктелуде…",
  "Загружено": "Жүктелді",
  "Загрузка не подтверждена. Продолжите проверку этого файла.": "Жүктелгені расталмады. Бұл файлды тексеруді жалғастырыңыз.",
  "Заказ": "Тапсырыс",
  "Заказ не подтверждён. Продолжение проверит прежний запрос с тем же ключом.": "Тапсырыс расталмады. Жалғастырғанда бұрынғы сұрау сол кілтпен тексеріледі.",
  "Заменить файл": "Файлды ауыстыру",
  "Избранное: {0}": "Таңдаулылар: {0}",
  "Инструмент обновляется. Обновите форму позже.": "Құрал жаңартылып жатыр. Форманы кейінірек жаңартыңыз.",
  "Искать в {0} работах": "{0} жұмыстың ішінен іздеу",
  "Искать в истории": "Тарихтан іздеу",
  "Использовать фото выбранного варианта": "Таңдалған нұсқаның фотосын пайдалану",
  "Используется выбранный голос.": "Таңдалған дауыс қолданылуда.",
  "Исход генерации уточняется. Новая работа автоматически не запускается.": "Генерация нәтижесі нақтыланып жатыр. Жаңа жұмыс автоматты түрде басталмайды.",
  "К инструментам": "Құралдарға өту",
  "Кавер": "Кавер",
  "Карусель": "Карусель",
  "Ключевые слова": "Түйінді сөздер",
  "Коллаж": "Коллаж",
  "Кратко": "Қысқаша",
  "Кружки": "Бейнехабарлар",
  "Кружок": "Бейнехабар",
  "Кто в кадре": "Кадрда кім бар",
  "Название": "Атауы",
  "Не получилось": "Сәтсіз аяқталды",
  "Не удалось выполнить": "Орындау мүмкін болмады",
  "Не удалось выполнить действие с этой работой. Обновите её и попробуйте снова.": "Бұл жұмыспен әрекетті орындау мүмкін болмады. Оны жаңартып, қайталап көріңіз.",
  "Не удалось завершить создание. Попробуйте изменить настройки.": "Жасауды аяқтау мүмкін болмады. Параметрлерді өзгертіп көріңіз.",
  "Не удалось загрузить историю. Попробуйте ещё раз.": "Тарихты жүктеу мүмкін болмады. Қайталап көріңіз.",
  "Не удалось загрузить студию.": "Студияны жүктеу мүмкін болмады.",
  "Не удалось загрузить фото варианта. Обновите профиль.": "Нұсқа фотосын жүктеу мүмкін болмады. Профильді жаңартыңыз.",
  "Не удалось обработать запись": "Жазбаны өңдеу мүмкін болмады",
  "Не удалось озвучить текст": "Мәтінді дыбыстау мүмкін болмады",
  "Не удалось открыть инструмент. Попробуйте обновить.": "Құралды ашу мүмкін болмады. Жаңартып көріңіз.",
  "Не удалось открыть результат. Попробуйте снова.": "Нәтижені ашу мүмкін болмады. Қайталап көріңіз.",
  "Не удалось отправить результат. Повторите отправку.": "Нәтижені жіберу мүмкін болмады. Қайта жіберіңіз.",
  "Не удалось связаться с сервисом. Попробуйте ещё раз.": "Қызметке қосылу мүмкін болмады. Қайталап көріңіз.",
  "Не удалось скопировать. Выделите текст вручную.": "Көшіру мүмкін болмады. Мәтінді қолмен белгілеңіз.",
  "Не удалось сохранить отправку. Разрешите хранилище вкладки и попробуйте ещё раз.": "Жіберілімді сақтау мүмкін болмады. Қойындының жадын пайдалануға рұқсат беріп, қайталап көріңіз.",
  "Некоторые файлы повтора больше недоступны. Загрузите их заново.": "Қайталау үшін пайдаланылған кейбір файлдар енді қолжетімсіз. Оларды қайта жүктеңіз.",
  "Ничего не нашли": "Ештеңе табылмады",
  "Нужно разных фото": "Әртүрлі фотолар қажет",
  "Обрабатываем запись": "Жазба өңделуде",
  "Озвучиваем текст": "Мәтін дыбысталуда",
  "Озвучить": "Дыбыстау",
  "Озвучка готова": "Дыбыстау дайын",
  "Озвучка проекта": "Жобаны дыбыстау",
  "Оплата": "Төлем",
  "Оплачено донатом": "Донат арқылы төленген",
  "Определить автоматически": "Автоматты түрде анықтау",
  "Основа": "Негіз",
  "Открыть результат": "Нәтижені ашу",
  "Отменено": "Болдырылмады",
  "Отправить в чат": "Чатқа жіберу",
  "Отправка не принята. Проверьте сообщение об ошибке.": "Жіберілім қабылданбады. Қате туралы хабарламаны тексеріңіз.",
  "Отправка принята. Бот доставит результат в чат.": "Жіберілім қабылданды. Бот нәтижені чатқа жеткізеді.",
  "Отправлено": "Жіберілді",
  "Переозвучить запись": "Жазбаны қайта дыбыстау",
  "Переозвучка": "Қайта дыбыстау",
  "Персонаж": "Кейіпкер",
  "Площадка": "Алаң",
  "Повтори движения": "Қимылдарды қайталаңыз",
  "Повторить": "Қайталау",
  "Подпись": "Жазу",
  "Подтверждаю право использовать загружаемые материалы": "Жүктелетін материалдарды пайдалануға құқығым бар екенін растаймын",
  "Подтверждаю право использовать эти фото и согласие изображённых людей на создание варианта": "Бұл фотоларды пайдалануға және бейнеленген адамдардың нұсқа жасауға келісімі бар екенін растаймын",
  "Поиск в истории": "Тарихтан іздеу",
  "Показатели истории": "Тарих көрсеткіштері",
  "Показатели истории временно недоступны": "Тарих көрсеткіштері уақытша қолжетімсіз",
  "Показать все работы": "Барлық жұмысты көрсету",
  "Показать текст": "Мәтінді көрсету",
  "Порядок": "Реті",
  "Почистить запись": "Жазбаны тазарту",
  "Прежний голос недоступен. Выберите другой голос.": "Алдыңғы дауыс қолжетімсіз. Басқа дауыс таңдаңыз.",
  "Преимущества": "Артықшылықтары",
  "Проверьте заполненные поля. Заказ не создан.": "Толтырылған өрістерді тексеріңіз. Тапсырыс жасалмады.",
  "Проверяем итог операции": "Әрекет нәтижесі тексерілуде",
  "Проверяем отправку…": "Жіберілім тексерілуде…",
  "Проверяем результат": "Нәтиже тексерілуде",
  "Проверяем списание токенов": "Токендердің есептен шығарылуы тексерілуде",
  "Продолжить проверку озвучки": "Дыбыстауды тексеруді жалғастыру",
  "Работ пока нет": "Әзірге жұмыс жоқ",
  "Работ: {0}": "Жұмыс саны: {0}",
  "Работа": "Жұмыс",
  "Работа больше не найдена. Обновите историю.": "Жұмыс енді табылмайды. Тарихты жаңартыңыз.",
  "Работа из истории": "Тарихтағы жұмыс",
  "Работа не прошла проверку.": "Жұмыс тексеруден өтпеді.",
  "Работа обновилась. Загрузите её ещё раз.": "Жұмыс жаңартылды. Оны қайта жүктеңіз.",
  "Распознавание": "Тану",
  "Распознанный текст": "Танылған мәтін",
  "Распознать речь": "Сөйлеуді тану",
  "Расшифровка": "Транскрипция",
  "Режим озвучки": "Дыбыстау режимі",
  "Результат": "Нәтиже",
  "Результат больше недоступен": "Нәтиже енді қолжетімсіз",
  "Результат операции уточняется. Повторный запуск отключён.": "Әрекет нәтижесі нақтыланып жатыр. Қайта іске қосу өшірілген.",
  "Результат отправки пока неизвестен. Повторите проверку.": "Жіберілім нәтижесі әзірге белгісіз. Қайта тексеріңіз.",
  "Результат отправки пока неизвестен. Повторите с тем же ключом.": "Жіберілім нәтижесі әзірге белгісіз. Сол кілтпен қайта тексеріңіз.",
  "Результат переозвучки": "Қайта дыбыстау нәтижесі",
  "Результат работы": "Жұмыс нәтижесі",
  "Реплики": "Репликалар",
  "Речевая запись": "Сөйлеу жазбасы",
  "Рилс": "Рилс",
  "Сегодня": "Бүгін",
  "Сейчас создаётся": "Қазір жасалуда",
  "Сервис сейчас недоступен.": "Қызмет қазір қолжетімсіз.",
  "Сессия истекла. Откройте приложение заново.": "Сессияның мерзімі аяқталды. Қолданбаны қайта ашыңыз.",
  "Синтез": "Синтез",
  "Скачать": "Жүктеп алу",
  "Скачать все файлы": "Барлық файлды жүктеп алу",
  "Скачать набор": "Жинақты жүктеп алу",
  "Скопировано": "Көшірілді",
  "Скопировать": "Көшіру",
  "Слайды": "Слайдтар",
  "Слишком много запросов. Подождите немного.": "Сұраулар тым көп. Сәл күте тұрыңыз.",
  "Слушать результат": "Нәтижені тыңдау",
  "Смена голоса": "Дауысты ауыстыру",
  "Сначала новые": "Алдымен жаңалары",
  "Сначала старые": "Алдымен ескілері",
  "Создать": "Жасау",
  "Создаётся": "Жасалуда",
  "Списано": "Есептен шығарылды",
  "Статус пока не подтверждён. Проверяем прежний заказ.": "Күйі әлі расталмады. Алдыңғы тапсырыс тексерілуде.",
  "Статус текущих заказов временно недоступен": "Ағымдағы тапсырыстардың күйі уақытша қолжетімсіз",
  "Стиль": "Стиль",
  "Стоимость": "Құны",
  "Сцена": "Сахна",
  "Съёмка": "Түсірілім",
  "Текст": "Мәтін",
  "Текст для озвучки": "Дыбыстауға арналған мәтін",
  "Текст песни": "Ән мәтіні",
  "Текст поста": "Жазба мәтіні",
  "Товар": "Тауар",
  "Удалить из истории": "Тарихтан жою",
  "Удалить из истории?": "Тарихтан жойылсын ба?",
  "Уточняем результат": "Нәтиже нақтылануда",
  "Уточняем состояние сохранённого заказа…": "Сақталған тапсырыстың күйі нақтылануда…",
  "Файл в чате останется": "Файл чатта қалады",
  "Файлов: {0}": "Файл саны: {0}",
  "Форма недоступна.": "Форма қолжетімсіз.",
  "Формат отправки": "Жіберу пішімі",
  "Фото": "Фото",
  "Фотосессии": "Фотосессиялар",
  "Фотосессия": "Фотосессия",
  "Фотосессия товара": "Тауар фотосессиясы",
  "Части": "Бөліктер",
  "Шаблон": "Үлгі",
  "Эта работа недоступна вашему аккаунту.": "Бұл жұмыс аккаунтыңызға қолжетімсіз.",
  "Это вся история": "Тарихтың соңы",
  "Этот инструмент сейчас недоступен. Попробуйте обновить форму.": "Бұл құрал қазір қолжетімсіз. Форманы жаңартып көріңіз.",
  "Язык записи": "Жазба тілі",
  "MP3 · пауза между репликами 0,6 с": "MP3 · репликалар арасындағы үзіліс 0,6 с",
  "{0} / 1 000 знаков": "{0} / 1 000 таңба",
  "{0} / 20 000 знаков · версия {1}": "{0} / 20 000 таңба · {1}-нұсқа",
  "{0} реплик": "{0} реплика",
  "{0} ролей · {1} новых реплик": "{0} рөл · {1} жаңа реплика",
  "Аудио больше недоступно. Обновите статус проекта.": "Аудио енді қолжетімсіз. Жоба мәртебесін жаңартыңыз.",
  "Буфер недоступен. Вставьте текст в поле вручную.": "Буфер қолжетімсіз. Мәтінді өріске қолмен қойыңыз.",
  "В проекте должно быть от 1 до 50 ролей.": "Жобада 1-ден 50-ге дейін рөл болуы керек.",
  "В проекте может быть не больше 500 реплик.": "Жобада 500-ден артық реплика болмауы керек.",
  "Вставить из буфера": "Буферден қою",
  "Вставить сценарий": "Сценарийді қою",
  "Выберите голос для каждой непустой роли.": "Әр бос емес рөл үшін дауысты таңдаңыз.",
  "Выше": "Жоғары",
  "Голос {0}": "{0} дауысы",
  "Голос роли": "Рөл дауысы",
  "Готовим аудио…": "Аудио дайындалуда…",
  "Добавить {0} реплик": "{0} реплика қосу",
  "Добавьте реплику или вставьте сценарий.": "Реплика қосыңыз немесе сценарийді қойыңыз.",
  "Дождитесь загрузки общего файла и попробуйте ещё раз.": "Ортақ файлдың жүктелуін күтіп, әрекетті қайталаңыз.",
  "Дублировать": "Көшірмесін жасау",
  "Загружаем аудио…": "Аудио жүктелуде…",
  "Загружаем проекты…": "Жобалар жүктелуде…",
  "Загрузить версию сервера": "Сервер нұсқасын жүктеу",
  "Закрыть раздел без сохранения изменений?": "Өзгерістерді сақтамай бөлімді жабу керек пе?",
  "Заменить текущие роли и реплики?": "Ағымдағы рөлдер мен репликалар ауыстырылсын ба?",
  "Заменить текущий сценарий": "Ағымдағы сценарийді ауыстыру",
  "Изменить сценарий": "Сценарийді өзгерту",
  "Имя роли": "Рөл атауы",
  "Кто говорит": "Кім сөйлейді",
  "Мои проекты": "Менің жобаларым",
  "Нажмите воспроизведение в плеере, чтобы разрешить звук.": "Дыбысты қосуға рұқсат беру үшін ойнатқыштағы ойнату түймесін басыңыз.",
  "Название проекта": "Жоба атауы",
  "Название слишком длинное.": "Атауы тым ұзын.",
  "Не удалось восстановить операции. Не запускайте озвучку повторно; проверьте историю.": "Әрекеттерді қалпына келтіру мүмкін болмады. Дауыстауды қайта бастамаңыз; тарихты тексеріңіз.",
  "Не удалось выполнить действие. Изменения остаются на экране.": "Әрекетті орындау мүмкін болмады. Өзгерістер экранда сақталған.",
  "Не удалось загрузить аудио. Проверьте соединение и попробуйте ещё раз.": "Аудионы жүктеу мүмкін болмады. Байланысты тексеріп, әрекетті қайталаңыз.",
  "Не удалось озвучить проект": "Жобаны дауыстау мүмкін болмады",
  "Не удалось подготовить аудио. Проверьте реплику и выбранный голос.": "Аудионы дайындау мүмкін болмады. Реплика мен таңдалған дауысты тексеріңіз.",
  "Не удалось проверить владельца проекта. Обновите страницу.": "Жоба иесін тексеру мүмкін болмады. Бетті жаңартыңыз.",
  "Не удалось связаться с сервером. Проверьте соединение и повторите попытку.": "Серверге қосылу мүмкін болмады. Байланысты тексеріп, әрекетті қайталаңыз.",
  "Не хватает Circle. Пополните баланс и повторите действие.": "Circle жеткіліксіз. Балансты толтырып, әрекетті қайталаңыз.",
  "Ниже": "Төмен",
  "Новый дубль реплики": "Репликаның жаңа дублін жасау",
  "Общий файл · MP3": "Ортақ файл · MP3",
  "Один из голосов больше недоступен. Выберите другой голос.": "Дауыстардың бірі енді қолжетімсіз. Басқа дауысты таңдаңыз.",
  "Озвучено реплик: {0} из {1}": "Дауысталған репликалар: {0} / {1}",
  "Озвучиваем проект": "Жоба дауысталуда",
  "Озвучить · {0} Circle": "Дауыстау · {0} Circle",
  "Озвучить проект": "Жобаны дауыстау",
  "Озвучка проектов": "Жобаларды дыбыстау",
  "Озвучка уже выполняется. Дождитесь результата.": "Дауыстау орындалып жатыр. Нәтижені күтіңіз.",
  "Операция уже принята или её исход неизвестен. Проверьте прежний запрос.": "Әрекет қабылданған немесе оның нәтижесі белгісіз. Алдыңғы сұрауды тексеріңіз.",
  "Отбросить локальные изменения и загрузить версию сервера?": "Жергілікті өзгерістерді алып тастап, сервер нұсқасын жүктеу керек пе?",
  "Открыть в истории": "Тарихта ашу",
  "Отменить изменения": "Өзгерістерді болдырмау",
  "Отменить несохранённые изменения?": "Сақталмаған өзгерістерді болдырмау керек пе?",
  "Перед озвучкой дождитесь сохранения изменений.": "Дауыстау алдында өзгерістердің сақталуын күтіңіз.",
  "Переозвучить": "Қайта дауыстау",
  "Переозвучить реплику": "Репликаны қайта дауыстау",
  "Повторить проверку": "Қайта тексеру",
  "Подтвердить и запустить": "Растау және іске қосу",
  "Подтверждение озвучки": "Дауыстауды растау",
  "Проверить прежний запрос": "Алдыңғы сұрауды тексеру",
  "Проверить статус": "Мәртебені тексеру",
  "Проверьте роли, голоса и длину реплик.": "Рөлдерді, дауыстарды және репликалардың ұзындығын тексеріңіз.",
  "Проект больше недоступен.": "Жоба енді қолжетімсіз.",
  "Проект длиннее 20 000 знаков.": "Жоба көлемі 20 000 таңбадан асады.",
  "Проект изменился в другом окне. Сравните свою версию и загрузите свежую.": "Жоба басқа терезеде өзгертілді. Өз нұсқаңызды салыстырып, жаңартылған нұсқаны жүктеңіз.",
  "Проект изменился. Сохраните его и проверьте цену ещё раз.": "Жоба өзгерді. Оны сақтап, бағаны қайта тексеріңіз.",
  "Проект или результат больше недоступен.": "Жоба немесе нәтиже енді қолжетімсіз.",
  "Проект озвучен": "Жоба дауысталды",
  "Проекты {0}": "Жобалар {0}",
  "Прослушать": "Тыңдау",
  "Прослушать реплику": "Репликаны тыңдау",
  "Прослушать текущую версию": "Ағымдағы нұсқаны тыңдау",
  "Прослушивание в очереди": "Тыңдау кезекте тұр",
  "Прослушивание реплики": "Репликаны тыңдау",
  "Результат изменился. Загрузите его актуальную версию.": "Нәтиже өзгерді. Оның жаңартылған нұсқасын жүктеңіз.",
  "Результат озвучки проекта": "Жобаны дауыстау нәтижесі",
  "Результат уточняется. Повторная генерация автоматически не запускается.": "Нәтиже нақтылануда. Қайта генерациялау автоматты түрде басталмайды.",
  "Реплика {0}": "{0}-реплика",
  "Реплика длиннее 1 000 знаков.": "Реплика көлемі 1 000 таңбадан асады.",
  "Реплики · {0}": "Репликалар · {0}",
  "Реплику {0} выше": "{0}-репликаны жоғары жылжыту",
  "Реплику {0} ниже": "{0}-репликаны төмен жылжыту",
  "Роли и голоса": "Рөлдер мен дауыстар",
  "Роль {0}": "{0}-рөл",
  "Роль реплики": "Реплика рөлі",
  "Скачать MP3": "MP3 жүктеп алу",
  "Слишком много запросов. Подождите и повторите проверку.": "Сұраулар тым көп. Күтіп, тексеруді қайталаңыз.",
  "Создайте проект, затем вставьте сценарий или добавьте роли и реплики.": "Жоба жасаңыз, содан кейін сценарийді қойыңыз немесе рөлдер мен репликалар қосыңыз.",
  "Стоимость подтверждена сервером. Повторная проверка этого же запроса не создаёт нового списания.": "Құн серверде расталды. Осы сұрауды қайта тексеру қосымша ақы алмайды.",
  "Стоимость: {0} Circle": "Құны: {0} Circle",
  "Строки «Имя: реплика» станут ролями и репликами. Таймкоды можно оставить.": "«Аты: реплика» жолдары рөлдер мен репликаларға айналады. Уақыт белгілерін қалдыруға болады.",
  "Сценарий": "Сценарий",
  "Сценарий изменился. Эта дорожка относится к предыдущей версии проекта.": "Сценарий өзгерді. Бұл аудиожол жобаның алдыңғы нұсқасына тиесілі.",
  "Сценарий по ролям — каждая роль звучит своим голосом.": "Рөлдерге бөлінген сценарий — әр рөл өз даусымен сөйлейді.",
  "Текст или голос изменились. Для текущей версии нужно новое прослушивание.": "Мәтін немесе дауыс өзгерді. Ағымдағы нұсқаны қайта тыңдау қажет.",
  "Текст реплики": "Реплика мәтіні",
  "Удалить проект": "Жобаны жою",
  "Удалить реплику {0}": "{0}-репликаны жою",
  "Удалить реплику?": "Репликаны жою керек пе?",
  "Удалить роль {0}": "{0}-рөлді жою",
  "Удалить роль «{0}» вместе с её репликами ({1})?": "«{0}» рөлін оның репликаларымен бірге жою керек пе ({1})?",
  "Удалить этот проект?": "Бұл жобаны жою керек пе?",
  "Укажите имя каждой роли.": "Әр рөлдің атын көрсетіңіз.",
  "Уточняем результат озвучки": "Дауыстау нәтижесі нақтылануда",
  "Цена изменилась. Проверьте новую цену перед запуском.": "Баға өзгерді. Іске қоспас бұрын жаңа бағаны тексеріңіз.",
  "есть несохранённые изменения": "сақталмаған өзгерістер бар",
  "сохранено": "сақталды",
  "＋ Новый проект": "＋ Жаңа жоба",
  "＋ Реплика": "＋ Реплика",
  "＋ Роль": "＋ Рөл",
  "Circle из пакетов без срока действия.": "Мерзімі шектелмеген пакеттердегі Circle.",
  "Circle каждый месяц": "Ай сайынғы Circle",
  "Circle приходят каждые {0} дней, первая партия — сразу.": "Circle әр {0} күн сайын беріледі, алғашқы топтама бірден беріледі.",
  "Circle этой партии действуют до {0}": "Осы топтамадағы Circle {0} дейін жарамды",
  "{0} Circle каждый месяц": "Ай сайын {0} Circle",
  "{0} Circle каждый месяц · до {1} своих голосов": "Ай сайын {0} Circle · {1} жеке дауысқа дейін",
  "{0} мес.": "{0} ай",
  "Баланс и профиль": "Баланс және профиль",
  "В текущем месяце осталось {0} из {1} Circle": "Ағымдағы айда {1} Circle ішінен {0} қалды",
  "Ваш текущий тариф": "Ағымдағы тарифіңіз",
  "Включить тестовое продление": "Сынақ мерзімін ұзартуды қосу",
  "Выбор тарифа": "Тарифті таңдау",
  "Действует до {0}": "{0} дейін жарамды",
  "Для этой подписки продление пока недоступно.": "Бұл жазылымды әзірге ұзарту мүмкін емес.",
  "До {0} своих голосов": "{0} жеке дауысқа дейін",
  "До {0} сохраняется текущий тариф.": "{0} дейін ағымдағы тариф сақталады.",
  "Докупить Circle": "Қосымша Circle сатып алу",
  "Доступные сроки": "Қолжетімді мерзімдер",
  "Загружаем подписку…": "Жазылым жүктелуде…",
  "Запланировать переход": "Ауысуды жоспарлау",
  "Запрос не совпадает с сохранённой операцией. Не повторяйте покупку; обратитесь в поддержку.": "Сұрау сақталған операцияға сәйкес келмейді. Сатып алуды қайталамаңыз, қолдау қызметіне хабарласыңыз.",
  "Исход прежнего запроса нужно проверить. Новая покупка пока заблокирована.": "Алдыңғы сұраудың нәтижесін тексеру қажет. Жаңа сатып алуға әзірге тыйым салынған.",
  "Начислить {0} тестовых Circle": "{0} сынақ Circle есептеу",
  "Не удалось восстановить операцию. Проверьте подписку перед новой покупкой.": "Операцияны қалпына келтіру мүмкін болмады. Жаңа сатып алмас бұрын жазылымды тексеріңіз.",
  "Операция подтверждена. Обновите данные; повторять покупку не нужно.": "Операция расталды. Деректерді жаңартыңыз, сатып алуды қайталаудың қажеті жоқ.",
  "Оставить текущий тариф": "Ағымдағы тарифті сақтау",
  "Отмена продления сохраняет тариф и лимиты до конца оплаченного срока.": "Ұзартудан бас тартсаңыз, төленген мерзімнің соңына дейін тариф пен лимиттер сақталады.",
  "Отменить продление": "Ұзартудан бас тарту",
  "Оформить dev-подписку": "Dev-жазылымын рәсімдеу",
  "Пакет Circle начислен.": "Circle пакеті есептелді.",
  "Пакеты Circle доступны с активной подпиской.": "Circle пакеттері белсенді жазылым болғанда қолжетімді.",
  "Перейти на выбранный тариф": "Таңдалған тарифке ауысу",
  "Переход начнётся после окончания текущей подписки. Сейчас оплата не требуется.": "Ауысу ағымдағы жазылым аяқталғаннан кейін басталады. Қазір төлем қажет емес.",
  "Подписка": "Жазылым",
  "Подписка временно недоступна. Попробуйте обновить данные.": "Жазылым уақытша қолжетімсіз. Деректерді жаңартып көріңіз.",
  "Подписка не продлится": "Жазылым ұзартылмайды",
  "Подписка обновлена.": "Жазылым жаңартылды.",
  "Подписка уже активна. Обновите данные и выберите доступное действие.": "Жазылым әлдеқашан белсенді. Деректерді жаңартып, қолжетімді әрекетті таңдаңыз.",
  "Подписка уже закончилась. Обновите данные.": "Жазылымның мерзімі аяқталған. Деректерді жаңартыңыз.",
  "Подтвердить": "Растау",
  "Подтверждение подписки": "Жазылымды растау",
  "Покупка сейчас недоступна. Реальные платежи не включены.": "Қазір сатып алу мүмкін емес. Нақты төлемдер қосылмаған.",
  "Получить dev-пакет бесплатно": "Тегін dev-пакетін алу",
  "Потом: {0}": "Кейін: {0}",
  "Предыдущая подписка закончилась {0}": "Алдыңғы жазылымның мерзімі {0} аяқталды",
  "При продлении оплаченного срока новая партия придёт в следующем периоде.": "Ақылы мерзімді ұзартқанда, жаңа топтама келесі кезеңде беріледі.",
  "Проверка операции": "Операцияны тексеру",
  "Продление включено": "Ұзарту қосылды",
  "Продлить подписку": "Жазылымды ұзарту",
  "Свои голоса": "Жеке дауыстар",
  "Свои голоса: {0} из {1}": "Жеке дауыстар: {1} ішінен {0}",
  "Сравнить тарифы": "Тарифтерді салыстыру",
  "Срок": "Мерзім",
  "Срок подписки": "Жазылым мерзімі",
  "Срок: {0} мес.": "Мерзімі: {0} ай",
  "Тариф останется до конца срока. Следующего продления не будет.": "Тариф мерзім аяқталғанша сақталады. Келесі ұзарту болмайды.",
  "Тарифы пока недоступны. Попробуйте обновить данные позже.": "Тарифтер әзірге қолжетімсіз. Кейінірек деректерді жаңартып көріңіз.",
  "Текущий тариф": "Ағымдағы тариф",
  "Тестовый dev-каталог. Реальных платежей нет; начисляются тестовые Circle.": "Сынақ dev-каталогы. Нақты төлемдер жоқ, сынақ Circle есептеледі.",
  "Управление подпиской": "Жазылымды басқару",
  "Условия тарифа изменились. Обновите данные перед подтверждением.": "Тариф шарттары өзгерді. Растамас бұрын деректерді жаңартыңыз.",
  "Что входит": "Құрамына не кіреді",
  "Это бесплатная dev-операция. Деньги и Telegram Stars не списываются.": "Бұл — тегін dev-операциясы. Ақша да, Telegram Stars та алынбайды.",
  "Этот переход между тарифами недоступен.": "Бұл тарифтер арасындағы ауысу қолжетімсіз.",
  "Этот тариф больше недоступен. Обновите список.": "Бұл тариф енді қолжетімсіз. Тізімді жаңартыңыз.",
  "QR-код": "QR-код",
  "QR-код приглашения": "Шақыру QR-коды",
  "{0} из {1} · {2} Circle": "{0} / {1} · {2} Circle",
  "Виды заданий": "Тапсырма түрлері",
  "Выполнение этого задания пока недоступно.": "Бұл тапсырманы әзірге орындау мүмкін емес.",
  "Готовим материал…": "Материал дайындалуда…",
  "Действие подтверждено. Обновляем задания.": "Әрекет расталды. Тапсырмалар жаңартылуда.",
  "День {0}": "{0}-күн",
  "День {0} из {1}": "{0}-күн / {1}",
  "Дней подряд: {0}": "Қатарынан күндер: {0}",
  "Друзья": "Достар",
  "Ежедневная серия": "Күнделікті серия",
  "Ежедневные": "Күнделікті",
  "Есть награды": "Сыйақылар бар",
  "Забрать {0} Circle": "{0} Circle алу",
  "Загружаем награды…": "Сыйақылар жүктелуде…",
  "Задание ещё не выполнено. Обновите прогресс.": "Тапсырма әлі орындалмаған. Прогресті жаңартыңыз.",
  "Задание засчитывает открытие отправки сторис. Telegram не подтверждает публикацию.": "Тапсырма сторис жариялау терезесін ашуды есепке алады. Telegram жарияланғанын растамайды.",
  "Заданий в этой группе пока нет.": "Бұл топта әзірге тапсырмалар жоқ.",
  "Задания дня": "Күн тапсырмалары",
  "Заходите каждый день. Пропуск дня начинает серию заново.": "Күн сайын кіріп тұрыңыз. Бір күнді өткізіп алсаңыз, серия қайта басталады.",
  "Исход прежнего запроса нужно проверить. Новые начисления пока заблокированы.": "Алдыңғы сұраудың нәтижесін тексеру қажет. Жаңа есептеулер әзірге бұғатталған.",
  "Копирование недоступно. Выделите текст вручную.": "Көшіру мүмкін емес. Мәтінді қолмен белгілеңіз.",
  "Материал для сторис": "Сториске арналған материал",
  "Награда подтверждена. Обновите данные; повторять начисление не нужно.": "Сыйақы расталды. Деректерді жаңартыңыз; қайта есептеудің қажеті жоқ.",
  "Награда получена": "Сыйақы алынды",
  "Награда получена. Завтра +{0} Circle": "Сыйақы алынды. Ертең +{0} Circle",
  "Награда уже получена. Обновите данные.": "Сыйақы бұрын алынған. Деректерді жаңартыңыз.",
  "Награды временно недоступны. Попробуйте обновить данные.": "Сыйақылар уақытша қолжетімсіз. Деректерді жаңартып көріңіз.",
  "Награды за друзей": "Достар үшін сыйақылар",
  "Награды приходят в Circle: ими можно платить в STEOS, выводить нельзя.": "Сыйақылар Circle түрінде беріледі: оларды STEOS ішінде төлеуге пайдалануға болады, бірақ шығарып алу мүмкін емес.",
  "Начисление не подтверждено. Проверьте прежний запрос; новая награда пока заблокирована.": "Есептеу расталмады. Алдыңғы сұрауды тексеріңіз; жаңа сыйақы әзірге бұғатталған.",
  "Начисления приостановлены.": "Есептеулер тоқтатылды.",
  "Начислено {0} Circle": "{0} Circle есептелді",
  "Начислено: {0} Circle": "Есептелді: {0} Circle",
  "Не удалось восстановить запрос награды. Проверьте баланс и обратитесь в поддержку.": "Сыйақы сұрауын қалпына келтіру мүмкін болмады. Балансты тексеріп, қолдау қызметіне хабарласыңыз.",
  "Не удалось загрузить QR-код.": "QR-кодты жүктеу мүмкін болмады.",
  "Не удалось открыть отправку сторис. Награда не начислена.": "Сторис жариялау терезесін ашу мүмкін болмады. Сыйақы есептелмеді.",
  "Не удалось подготовить сторис. Попробуйте ещё раз.": "Сторис дайындау мүмкін болмады. Қайталап көріңіз.",
  "Новый день: {0}": "Жаңа күн: {0}",
  "Обновить награды": "Сыйақыларды жаңарту",
  "Обновятся: {0}": "Жаңартылатындар: {0}",
  "Откройте Mini App в Telegram с поддержкой сторис.": "Mini App қолданбасын стористерді қолдайтын Telegram нұсқасында ашыңыз.",
  "Открыть STEOS ID в профиле": "Профильде STEOS ID ашу",
  "Открыть сторис": "Стористі ашу",
  "Отправить в сторис": "Сториске жіберу",
  "Партнёрские данные временно недоступны.": "Серіктес деректері уақытша қолжетімсіз.",
  "Партнёрство · Статистика, материалы и вывод": "Серіктестік · Статистика, материалдар және қаражат шығару",
  "Первые шаги": "Алғашқы қадамдар",
  "Перейти к заданию": "Тапсырмаға өту",
  "Получить ежедневную награду": "Күнделікті сыйақыны алу",
  "Приглашено: {0} · Покупателей: {1}": "Шақырылғандар: {0} · Сатып алушылар: {1}",
  "Прогресс задания": "Тапсырманың орындалу барысы",
  "Прогресс задания временно недоступен.": "Тапсырманың орындалу барысы уақытша қолжетімсіз.",
  "Промокод": "Промокод",
  "Разовые": "Бір реттік",
  "Скопировать приглашение": "Шақыруды көшіру",
  "Скопировать промокод": "Промокодты көшіру",
  "Ссылка приглашения": "Шақыру сілтемесі",
  "Сторис в Telegram": "Telegram стористері",
  "Челленджи недели": "Апталық челлендждер",
  "Circle используются внутри STEOS": "Circle STEOS ішінде қолданылады",
  "Telegram подтвердил отправку сообщения.": "Telegram хабарламаның жіберілгенін растады.",
  "Без покупок": "Сатып алусыз",
  "В этом списке пока нет друзей.": "Бұл тізімде әзірге достар жоқ.",
  "Возможен вывод по условиям программы": "Бағдарлама шарттарына сәйкес қаражатты шығаруға болады",
  "Вопросы": "Сұрақтар",
  "Всё время": "Барлық уақыт",
  "Вы здесь": "Сіз осындасыз",
  "Выберите PDF, JPG или PNG.": "PDF, JPG немесе PNG файлын таңдаңыз.",
  "Выберите плательщика": "Төлеушіні таңдаңыз",
  "Выбрать чат в Telegram": "Telegram-да чатты таңдау",
  "Выбрать чат для отправки": "Жіберу үшін чатты таңдау",
  "Вывод": "Қаражатты шығару",
  "Вывод недоступен на текущем уровне.": "Қазіргі деңгейде қаражатты шығару мүмкін емес.",
  "Вывод сейчас недоступен.": "Қазір қаражатты шығару мүмкін емес.",
  "Вывод средств": "Қаражат шығару",
  "Выплачен": "Төленді",
  "Выставьте счёт на": "Шот кімге жазылады",
  "Для вывода войдите в STEOS ID.": "Қаражат шығару үшін STEOS ID жүйесіне кіріңіз.",
  "Для расчёта нужны опубликованные уровни и тарифы.": "Есептеу үшін жарияланған деңгейлер мен тарифтер қажет.",
  "До уровня «{0}»: ещё {1} покупателей": "«{0}» деңгейіне дейін: тағы {1} сатып алушы қажет",
  "Доступно к выводу": "Шығаруға қолжетімді",
  "Доступных шаблонов пока нет.": "Әзірге қолжетімді үлгілер жоқ.",
  "Доход": "Табыс",
  "Если купят {0} друзей": "{0} дос сатып алса",
  "Есть покупки": "Сатып алулар бар",
  "За этот период начислений пока нет.": "Бұл кезеңде әзірге ешқандай сома есептелмеген.",
  "Загружаем QR-код…": "QR-код жүктелуде…",
  "Загружаем друзей…": "Достар жүктелуде…",
  "Загружаем материалы…": "Материалдар жүктелуде…",
  "Загружаем партнёрские данные…": "Серіктестік деректер жүктелуде…",
  "Загрузите проверенный счёт на оплату.": "Тексерілген төлем шотын жүктеңіз.",
  "Заказать материал в чат": "Чатқа материалға тапсырыс беру",
  "Запрос принят. Доставка в чат ещё не подтверждена.": "Сұрау қабылданды. Чатқа жеткізілгені әлі расталған жоқ.",
  "Заявка принята. Статус выплаты появится в истории.": "Өтінім қабылданды. Төлем мәртебесі тарихта көрсетіледі.",
  "Заявок на вывод пока нет.": "Әзірге қаражат шығару өтінімдері жоқ.",
  "Изменение реквизитов заблокировано до получения результата этой заявки.": "Бұл өтінімнің нәтижесі алынғанша төлем деректемелерін өзгерту бұғатталған.",
  "Имя получателя": "Алушының аты-жөні",
  "История выводов": "Қаражат шығару тарихы",
  "Исход запроса нужно проверить. Новый материал пока заблокирован.": "Сұрау нәтижесін тексеру қажет. Жаңа материал әзірге бұғатталған.",
  "Как определяется уровень?": "Деңгей қалай анықталады?",
  "Как это работает": "Бұл қалай жұмыс істейді",
  "Калькулятор станет доступен после публикации расчётной политики.": "Есептеу саясаты жарияланғаннан кейін калькулятор қолжетімді болады.",
  "Количество друзей": "Достар саны",
  "Материалы": "Материалдар",
  "Материалы временно недоступны. Попробуйте обновить список.": "Материалдар уақытша қолжетімсіз. Тізімді жаңартып көріңіз.",
  "Материалы пока недоступны.": "Материалдар әзірге қолжетімсіз.",
  "Месяц": "Ай",
  "Минимальная сумма": "Ең аз сома",
  "На рассмотрении": "Қаралуда",
  "Налоговый номер": "Салық нөмірі",
  "Начисления за период": "Кезең бойынша есептелген сомалар",
  "Начислено Circle": "Есептелген Circle",
  "Начислено за период: {0} Circle": "Кезең үшін есептелді: {0} Circle",
  "Не удалось безопасно сохранить заявку или проверить владельца. Отправка не выполнена.": "Өтінімді қауіпсіз сақтау немесе иесін тексеру мүмкін болмады. Жіберу орындалмады.",
  "Не удалось восстановить отправку. Обратитесь в поддержку перед новым запросом.": "Жіберу күйін қалпына келтіру мүмкін болмады. Жаңа сұрау жібермес бұрын қолдау қызметіне хабарласыңыз.",
  "Не удалось загрузить друзей.": "Достарды жүктеу мүмкін болмады.",
  "Не удалось загрузить историю выводов.": "Қаражат шығару тарихын жүктеу мүмкін болмады.",
  "Не удалось загрузить тарифы.": "Тарифтерді жүктеу мүмкін болмады.",
  "Не удалось открыть отправку в Telegram.": "Telegram арқылы жіберу терезесін ашу мүмкін болмады.",
  "Не удалось проверить владельца. Обновите страницу.": "Иесін тексеру мүмкін болмады. Бетті жаңартыңыз.",
  "Не удалось прочитать сохранённую заявку. Новый вывод заблокирован.": "Сақталған өтінімді оқу мүмкін болмады. Қаражатты қайта шығару бұғатталған.",
  "Не удалось сохранить состояние отправки.": "Жіберу күйін сақтау мүмкін болмады.",
  "Неделя": "Апта",
  "Нет данных": "Деректер жоқ",
  "Новая заявка": "Жаңа өтінім",
  "Новая заявка на вывод сейчас недоступна.": "Қаражат шығаруға жаңа өтінім беру қазір қолжетімсіз.",
  "О программе": "Бағдарлама туралы",
  "Обзор": "Шолу",
  "Обновите страницу или обратитесь в поддержку.": "Бетті жаңартыңыз немесе қолдау қызметіне хабарласыңыз.",
  "Обновить историю выводов": "Қаражат шығару тарихын жаңарту",
  "Обновить материалы": "Материалдарды жаңарту",
  "От {0} покупателей": "{0} сатып алушыдан бастап",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены.": "Жауап алынбады. Сол өтінімді тексеріңіз: оның деректері мен кілті сақталған.",
  "Отклонён": "Қабылданбады",
  "Откройте Mini App в Telegram с поддержкой отправки материалов.": "Материал жіберуді қолдайтын Telegram ішіндегі Mini App қолданбасын ашыңыз.",
  "Открыть сторис в Telegram": "Telegram-да стористі ашу",
  "Отправка не подтверждена. Повтор проверит прежний запрос без новой отправки.": "Жіберілгені расталмады. Қайталау жаңа жіберуді бастамай, алдыңғы сұрауды тексереді.",
  "Отправка отменена. Можно открыть выбор чата ещё раз.": "Жіберу тоқтатылды. Чат таңдау терезесін қайта ашуға болады.",
  "Оценка дохода": "Табыс болжамы",
  "Оценка за {0} месяцев: {1} Circle": "{0} айға болжам: {1} Circle",
  "Оценка за месяц: {0} Circle": "Бір айға болжам: {0} Circle",
  "Переходы": "Өтулер",
  "Период обзора": "Шолу кезеңі",
  "Плательщик": "Төлеуші",
  "Подать заявку на вывод": "Қаражат шығаруға өтінім беру",
  "Подготовить QR-код": "QR-кодты дайындау",
  "Подготовить другой материал": "Басқа материалды дайындау",
  "Подготовить материал": "Материалды дайындау",
  "Поделитесь своей ссылкой или промокодом.": "Сілтемеңізді немесе промокодыңызды бөлісіңіз.",
  "Поделиться": "Бөлісу",
  "Пока без покупок": "Әзірге сатып алулар жоқ",
  "Пока недоступно": "Әзірге қолжетімсіз",
  "Покупатели": "Сатып алушылар",
  "Покупки друзей учитывает сервер STEOS ID.": "Достардың сатып алуларын STEOS ID сервері есепке алады.",
  "Полные условия программы": "Бағдарламаның толық шарттары",
  "Пользователь": "Пайдаланушы",
  "Попробуйте STEOS: {0}\nПромокод: {1}": "STEOS-ты қолданып көріңіз: {0}\nПромокод: {1}",
  "Привязка до: {0}": "Байланыстыру мерзімі: {0}",
  "Привязка приглашённого друга действует {0} месяцев.": "Шақырылған достың байланыстырылуы {0} ай бойы жарамды.",
  "Приглашён: {0}": "Шақырған адам: {0}",
  "Проверить загрузку счёта": "Шоттың жүктелуін тексеру",
  "Проверить ту же заявку": "Сол өтінімді тексеру",
  "Проверьте налоговый номер получателя.": "Алушының салық нөмірін тексеріңіз.",
  "Проверьте реквизиты и счёт.": "Төлем деректемелері мен шотты тексеріңіз.",
  "Проверьте сумму вывода: целое число в доступном диапазоне.": "Шығарылатын соманы тексеріңіз: ол қолжетімді ауқымдағы бүтін сан болуы керек.",
  "Проверяем владельца…": "Иесі тексерілуде…",
  "Проверяем заявку или счёт…": "Өтінім немесе шот тексерілуде…",
  "Процент и доступность вывода определяет опубликованная программа.": "Пайыздық мөлшерлеме мен қаражат шығару мүмкіндігін жарияланған бағдарлама анықтайды.",
  "Проценты, сроки и ограничения показаны по опубликованным данным сервера.": "Пайыздар, мерзімдер мен шектеулер сервер жариялаған деректер негізінде көрсетілген.",
  "Размер счёта должен быть от 1 байта до 10 МБ.": "Шот файлының өлшемі 1 байттан 10 МБ-қа дейін болуы керек.",
  "Регистрации": "Тіркелулер",
  "Результат загрузки счёта неизвестен. Проверьте загрузку без повторной отправки файла.": "Шоттың жүктелу нәтижесі белгісіз. Файлды қайта жібермей, жүктелуін тексеріңіз.",
  "Скачать PNG": "PNG жүктеп алу",
  "Сколько действует привязка друга?": "Досты байланыстыру мерзімі қанша?",
  "Скопировать текст": "Мәтінді көшіру",
  "Сохранена неподтверждённая заявка": "Расталмаған өтінім сақталды",
  "Срок рассмотрения, дней": "Қарау мерзімі, күн",
  "Ссылка и промокод добавляются сервером. Выберите доступный материал.": "Сілтеме мен промокодты сервер қосады. Қолжетімді материалды таңдаңыз.",
  "Ссылка на полный документ условий пока не опубликована.": "Шарттардың толық құжатына сілтеме әлі жарияланған жоқ.",
  "Сторис открыта в Telegram. Публикацию нужно подтвердить в редакторе.": "Стори Telegram-да ашылды. Жариялауды редакторда растау қажет.",
  "Сумма в Circle": "Circle сомасы",
  "Сумма меньше минимальной суммы вывода.": "Сома қаражат шығарудың ең аз мөлшерінен төмен.",
  "Сумма превышает доступный остаток.": "Сома қолжетімді қалдықтан асып кетті.",
  "Счёт на оплату · PDF, JPG или PNG, до 10 МБ": "Төлем шоты · PDF, JPG немесе PNG, 10 МБ-қа дейін",
  "Счёт не прошёл загрузку или проверку. Выберите PDF, JPG или PNG до 10 МБ.": "Шот жүктелмеді немесе тексеруден өтпеді. 10 МБ-қа дейінгі PDF, JPG немесе PNG файлын таңдаңыз.",
  "Счёт пока не подтверждён. Повторите проверку или выберите другой файл.": "Шот әлі расталған жоқ. Қайта тексеріңіз немесе басқа файлды таңдаңыз.",
  "Счёт проверен": "Шот тексерілді",
  "Текст приглашения": "Шақыру мәтіні",
  "Текст сообщения": "Хабарлама мәтіні",
  "Тексты": "Мәтіндер",
  "Тестовая заявка": "Тестілік өтінім",
  "Тестовая программа dev. Реальные выплаты выключены.": "dev тестілік бағдарламасы. Нақты төлемдер өшірілген.",
  "Тестовая программа: реальные выплаты отключены.": "Тестілік бағдарлама: нақты төлемдер өшірілген.",
  "Тестовый расчёт dev. Это оценка, начисление не выполняется.": "dev тестілік есебі. Бұл — болжам, есептеу жүргізілмейді.",
  "Укажите имя получателя: до 200 символов.": "Алушының аты-жөнін көрсетіңіз: 200 таңбаға дейін.",
  "Уровень показывает сервер по учтённым покупателям. Смотрите вкладку «Уровни».": "Деңгейді сервер есепке алынған сатып алушылар саны бойынша анықтайды. «Деңгейлер» қойындысын қараңыз.",
  "Уровни": "Деңгейлер",
  "Условия начислений пока не опубликованы.": "Есептеу шарттары әлі жарияланған жоқ.",
  "Условия программы": "Бағдарлама шарттары",
  "Учёт переходов по ссылке пока недоступен.": "Сілтеме бойынша өтулерді есепке алу әзірге қолжетімсіз.",
  "Фильтр друзей": "Достар сүзгісі",
  "Что делать, если данные не обновились?": "Деректер жаңартылмаса, не істеу керек?",
  "Шаги": "Қадамдар",
  "Баннер": "Баннер",
  "QR-постер": "QR-постер",
  "{0} / 300 знаков": "{0} / 300 таңба",
  "· до 20 МБ": "· 20 МБ-қа дейін",
  "Агент готовит ответ…": "Агент жауап дайындап жатыр…",
  "Аудиозапись": "Аудиожазба",
  "Бесплатно только в dev. До 30 секунд и 10 МБ. Текст можно исправить перед отправкой.": "Тек dev ортасында тегін. 30 секундқа және 10 МБ-қа дейін. Жібермес бұрын мәтінді түзетуге болады.",
  "Ваш вопрос": "Сұрағыңыз",
  "Вопрос или название инструмента": "Сұрақ немесе құрал атауы",
  "Вопросов: {0}": "Сұрақтар: {0}",
  "Вопросы · {0}": "Сұрақтар · {0}",
  "Восстанавливаем чат…": "Чат қалпына келтіріліп жатыр…",
  "Все сервисы работают": "Барлық қызмет жұмыс істеп тұр",
  "Выберите MP3, WAV или M4A до 20 МБ.": "20 МБ-қа дейінгі MP3, WAV немесе M4A файлын таңдаңыз.",
  "Выберите инструкцию к нужному инструменту или странице.": "Қажетті құралға немесе бетке арналған нұсқаулықты таңдаңыз.",
  "Диктовать вопрос": "Сұрақты дауыспен айту",
  "Диктовка не подтверждена. Повторите проверку прежнего запроса или загрузки.": "Диктовка расталмады. Алдыңғы сұрауды немесе жүктеп салуды қайта тексеріңіз.",
  "До": "Дейін",
  "Ещё спрашивают": "Тағы сұрайды",
  "Загружаем справку…": "Анықтама жүктеліп жатыр…",
  "Загружаем статус…": "Күйі жүктеліп жатыр…",
  "Закрыть чат": "Чатты жабу",
  "ИИ-агент поддержки": "Қолдау көрсететін AI-агент",
  "ИИ-агент сейчас недоступен.": "AI-агент қазір қолжетімсіз.",
  "Инструкции": "Нұсқаулықтар",
  "Инструкции · {0}": "Нұсқаулықтар · {0}",
  "Инструкции пока не опубликованы.": "Нұсқаулықтар әлі жарияланбаған.",
  "Исход запроса пока неизвестен. Новый вопрос не отправляется.": "Сұраудың нәтижесі әзірге белгісіз. Жаңа сұрақ жіберілмейді.",
  "Как пользоваться STEOS": "STEOS жүйесін қалай пайдалану керек",
  "Кружки и говорящие видео": "Дөңгелек бейнелер және сөйлейтін бейнелер",
  "Медленнее обычного": "Әдеттегіден баяу",
  "Написать агенту": "Агентке жазу",
  "Начать": "Бастау",
  "Начать новую диктовку": "Жаңа диктовканы бастау",
  "Не помогло": "Көмектеспеді",
  "Не удалось восстановить диктовку. Новый запрос заблокирован.": "Диктовканы қалпына келтіру мүмкін болмады. Жаңа сұрау бұғатталды.",
  "Не удалось восстановить чат. Обратитесь в поддержку.": "Чатты қалпына келтіру мүмкін болмады. Қолдау қызметіне хабарласыңыз.",
  "Не удалось загрузить поддержку. Попробуйте ещё раз.": "Қолдау бөлімін жүктеу мүмкін болмады. Қайталап көріңіз.",
  "Не удалось загрузить статус сервисов.": "Қызметтердің күйін жүктеу мүмкін болмады.",
  "Не удалось подтвердить ответ. Можно начать новый чат или написать в поддержку.": "Жауапты растау мүмкін болмады. Жаңа чат бастауға немесе қолдау қызметіне жазуға болады.",
  "Не удалось получить ответ. Повторите проверку без нового вопроса.": "Жауап алу мүмкін болмады. Жаңа сұрақ қоймай, алдыңғы сұрауды қайта тексеріңіз.",
  "Не удалось проверить владельца чата. Повторите открытие.": "Чат иесін тексеру мүмкін болмады. Қайта ашып көріңіз.",
  "Не удалось сохранить новый чат.": "Жаңа чатты сақтау мүмкін болмады.",
  "Не удалось сохранить оценку. Попробуйте ещё раз.": "Бағаны сақтау мүмкін болмады. Қайталап көріңіз.",
  "Недоступен": "Қолжетімсіз",
  "Некоторые сервисы работают медленнее обычного. Открыть статус": "Кейбір қызметтер әдеттегіден баяу жұмыс істеп тұр. Күйін ашу",
  "Нет подтверждённых данных": "Расталған деректер жоқ",
  "Ничего не нашли. Попробуйте другие слова или спросите ИИ-агента.": "Ештеңе табылмады. Басқа сөздерді қолданып көріңіз немесе AI-агенттен сұраңыз.",
  "Новый чат": "Жаңа чат",
  "Обзор приложения": "Қолданбаға шолу",
  "Обновить справку": "Анықтаманы жаңарту",
  "Обновить статус": "Күйді жаңарту",
  "Опубликованная проверка. Автоматический мониторинг не заявлен.": "Тексеру нәтижесі жарияланған. Автоматты мониторинг бар деп мәлімделмейді.",
  "Ответ не подтверждён. Проверьте прежний запрос или напишите в поддержку.": "Жауап расталмады. Алдыңғы сұрауды тексеріңіз немесе қолдау қызметіне жазыңыз.",
  "Отвечает по опубликованной справке STEOS": "STEOS жүйесінің жарияланған анықтамасы бойынша жауап береді",
  "Открыть инструкции": "Нұсқаулықтарды ашу",
  "Открыть инструкцию": "Нұсқаулықты ашу",
  "Открыть инструмент": "Құралды ашу",
  "Открыть ответ справки": "Анықтама жауабын ашу",
  "Открыть раздел": "Бөлімді ашу",
  "Отправить вопрос": "Сұрақ жіберу",
  "Оценка ответа": "Жауапты бағалау",
  "Очистить поиск": "Іздеуді тазарту",
  "Поиск по справке": "Анықтамадан іздеу",
  "Полезно": "Пайдалы",
  "Помощь": "Көмек",
  "Популярные вопросы": "Танымал сұрақтар",
  "Последняя проверка устарела. Текущее состояние неизвестно.": "Соңғы тексеру ескірген. Ағымдағы күй белгісіз.",
  "Посмотреть короткий обзор": "Қысқаша шолуды көру",
  "Предыдущая": "Алдыңғы",
  "Проверено: {0}": "Тексерілген: {0}",
  "Проверить диктовку": "Диктовканы тексеру",
  "Пропустить": "Өткізіп жіберу",
  "Работает": "Жұмыс істеп тұр",
  "Распознать вопрос": "Сұрақты тану",
  "Распознаём вопрос…": "Сұрақ танылып жатыр…",
  "Результаты поиска": "Іздеу нәтижелері",
  "Следующая": "Келесі",
  "Советы": "Кеңестер",
  "Справка пока не опубликована.": "Анықтама әлі жарияланбаған.",
  "Спросите что угодно": "Кез келген сұрақ қойыңыз",
  "Спросить ИИ-агента": "AI-агенттен сұрау",
  "Спросить ИИ-агента поддержки": "Қолдау қызметінің AI-агентінен сұрау",
  "Статус": "Күйі",
  "Статус сервисов": "Қызметтердің күйі",
  "Статус сервисов пока не публикуется.": "Қызметтердің күйі әзірге жарияланбайды.",
  "Статья недоступна": "Мақала қолжетімсіз",
  "Темы": "Тақырыптар",
  "Темы пока не опубликованы.": "Тақырыптар әлі жарияланбаған.",
  "Точного ответа в справке нет.": "Анықтамада нақты жауап жоқ.",
  "Чат не отправляет сообщения человеку автоматически.": "Чат хабарламаларды адамға автоматты түрде жібермейді.",
  "Читаем запись…": "Жазба оқылып жатыр…",
  "Эта статья больше не входит в опубликованную справку.": "Бұл мақала енді жарияланған анықтамаға кірмейді.",
  "Выберите MP3, WAV или M4A до {0} МБ.": "Өлшемі {0} МБ-тан аспайтын MP3, WAV немесе M4A файлын таңдаңыз.",
  "До {0} · до {1} МБ": "{0}-қа дейін · {1} МБ-қа дейін",
  "Нужна запись от 1 секунды до {0}.": "Ұзақтығы кемінде 1 секунд және {0}-тан аспайтын жазба қажет.",
  "Остановить запись · {0}": "Жазуды тоқтату · {0}",
  "{0} C/сек": "{0} C/сек",
  "Все инструменты": "Барлық құралдар",
  "Все шаблоны": "Барлық үлгілер",
  "Вся подборка": "Барлық топтама",
  "Выбрать, кто играет": "Кім ойнайтынын таңдау",
  "Голос и музыка": "Дауыс пен музыка",
  "Двое": "Екеуі",
  "Дети": "Балалар",
  "Дешевле": "Арзанырақ",
  "Для бизнеса": "Бизнеске арналған",
  "Для этого действия доступно несколько шаблонов. Выберите подходящий в каталоге.": "Бұл әрекет үшін бірнеше үлгі қолжетімді. Каталогтан қолайлысын таңдаңыз.",
  "Загружаем шаблон…": "Үлгі жүктелуде…",
  "Закрыть поиск": "Іздеуді жабу",
  "Закрыть превью": "Алдын ала қарауды жабу",
  "Инструменты": "Құралдар",
  "Искать во всех шаблонах": "Барлық үлгілерден іздеу",
  "Короче": "Қысқарақ",
  "Кто играет": "Кім ойнайды",
  "Найти инструмент или шаблон": "Құралды немесе үлгіні табу",
  "Не удалось загрузить выбранный вариант.": "Таңдалған нұсқаны жүктеу мүмкін болмады.",
  "Не удалось загрузить шаблон. Обновите превью.": "Үлгіні жүктеу мүмкін болмады. Алдын ала қарауды жаңартыңыз.",
  "Не удалось открыть инструмент.": "Құралды ашу мүмкін болмады.",
  "Несколько": "Бірнешеу",
  "Новые": "Жаңалары",
  "Один": "Біреу",
  "от {0} C": "{0} C-тан бастап",
  "от {0} C/сек": "{0} C/сек бастап",
  "От {0} Circle": "{0} Circle-ден бастап",
  "От А до Я": "А-дан Я-ға дейін",
  "Очистить": "Тазалау",
  "Питомцы": "Үй жануарлары",
  "По желанию": "Қалауыңыз бойынша",
  "Подборка пока недоступна.": "Топтама әзірге қолжетімді емес.",
  "Подборки": "Топтамалар",
  "Поиск": "Іздеу",
  "Пока нет доступных шаблонов": "Әзірге қолжетімді үлгілер жоқ",
  "Популярные": "Танымал",
  "После": "Кейін",
  "Превью шаблона": "Үлгіні алдын ала қарау",
  "Пример результата пока не опубликован.": "Нәтиже үлгісі әзірге жарияланбаған.",
  "Пример сейчас недоступен.": "Мысал әзірге қолжетімді емес.",
  "Рекомендуем": "Ұсынылған",
  "Смотреть все": "Барлығын көру",
  "Сначала": "Сұрыптау",
  "Сравнить до и после": "Дейінгі және кейінгі нәтижелерді салыстыру",
  "Стилей: {0}. Выбор на следующем шаге.": "Стильдер: {0}. Таңдау келесі қадамда жасалады.",
  "Удерживайте для просмотра": "Көру үшін басып тұрыңыз",
  "Цена уточняется в форме создания.": "Бағасы жасау формасында нақтыланады.",
  "Частые вопросы": "Жиі қойылатын сұрақтар",
  "Что нужно": "Не қажет",
  "Что хотите сделать?": "Не істегіңіз келеді?",
  "Шаблоны и подборки": "Үлгілер мен топтамалар",
  "Это действие пока недоступно.": "Бұл әрекет әзірге қолжетімді емес.",
  "е": "е",
  "за секунду": "секундына",
  "ё": "ё",
  "{0} C в минуту": "{0} C минутына",
  "{0} C за 100 знаков": "{0} C 100 таңбаға",
  "Владелец сессии изменился. Вернитесь в студию после обновления страницы.": "Сессия иесі өзгерді. Бетті жаңартқаннан кейін студияға қайта оралыңыз.",
  "Не удалось восстановить сохранённую заявку. Новая генерация заблокирована.": "Сақталған өтінімді қалпына келтіру мүмкін болмады. Жаңа генерациялауға тыйым салынды.",
  "Не удалось обновить сохранённую заявку. Новая генерация заблокирована.": "Сақталған өтінімді жаңарту мүмкін болмады. Жаңа генерациялауға тыйым салынды.",
  "Не удалось проверить владельца. Новая генерация заблокирована.": "Иесін тексеру мүмкін болмады. Жаңа генерациялауға тыйым салынды.",
  "Не удалось сохранить заявку. Отправка не выполнена.": "Өтінімді сақтау мүмкін болмады. Жіберу орындалмады.",
  "от {0} C в минуту": "{0} C минутына бастап",
  "от {0} C за 100 знаков": "{0} C 100 таңбаға бастап",
  "Проверить статус заказа": "Тапсырыс күйін тексеру",
  "Статус пока не подтверждён. Проверьте этот же заказ позже.": "Күйі әлі расталған жоқ. Кейінірек осы тапсырысты қайта тексеріңіз.",
  "в минуту": "минутына",
  "за 100 знаков": "100 таңбаға",
  "Анимация звука": "Дыбыс анимациясы",
  "В видео останется исходная речь. Выберите фрагмент до одной минуты.": "Бейнеде бастапқы сөйлеу сақталады. Бір минутқа дейінгі үзіндіні таңдаңыз.",
  "В видео останутся исходные слова. Голос можно изменить. Выберите фрагмент до одной минуты.": "Бейнеде бастапқы сөздер сақталады. Дауысты өзгертуге болады. Бір минутқа дейінгі үзіндіні таңдаңыз.",
  "Вид персонажа": "Кейіпкердің көрінісі",
  "Видео готово": "Бейне дайын",
  "Видео не создано": "Бейне жасалмады",
  "Волна": "Толқын",
  "Выберите, кто говорит": "Кім сөйлейтінін таңдаңыз",
  "Выбранное фото": "Таңдалған фото",
  "Движение": "Қозғалыс",
  "Добавьте видео": "Бейне қосыңыз",
  "Дополнительная настройка": "Қосымша баптау",
  "Другой голос для записи": "Жазба үшін басқа дауыс",
  "Ещё вариант": "Тағы бір нұсқа",
  "Ещё настройки": "Қосымша баптаулар",
  "Изменить данные": "Деректерді өзгерту",
  "Источник": "Дереккөз",
  "Источник лица": "Бет дереккөзі",
  "Источник речи": "Сөйлеу дереккөзі",
  "Кадр по вертикали": "Тік кадр",
  "Кадр по горизонтали": "Көлденең кадр",
  "Каких движений избегать": "Қандай қозғалыстардан аулақ болу керек",
  "Конец фрагмента, секунды": "Үзіндінің соңы, секунд",
  "Кружком": "Бейнехабармен",
  "Кружок готов": "Дөңгелек бейне дайын",
  "Кружок не создан": "Дөңгелек бейне жасалмады",
  "Люди и персонажи": "Адамдар мен кейіпкерлер",
  "Напишите текст или добавьте запись": "Мәтін жазыңыз немесе жазба қосыңыз",
  "Начало фрагмента, секунды": "Үзіндінің басы, секунд",
  "Не удалось загрузить виды персонажа.": "Кейіпкер көріністерін жүктеу мүмкін болмады.",
  "Не удалось загрузить людей и персонажей.": "Адамдар мен кейіпкерлерді жүктеу мүмкін болмады.",
  "Не удалось подтвердить завершение заказа. Новая генерация не начата.": "Тапсырыстың аяқталғанын растау мүмкін болмады. Жаңа генерация басталған жоқ.",
  "Не удалось проверить доставку. Откройте историю заказа.": "Жеткізілімді тексеру мүмкін болмады. Тапсырыс тарихын ашыңыз.",
  "Оставить голос записи": "Жазбадағы дауысты сақтау",
  "Открыть в чате": "Чатта ашу",
  "Отправлено в чат": "Чатқа жіберілді",
  "По умолчанию": "Әдепкі бойынша",
  "Подтвердите право использовать материалы": "Материалдарды пайдалануға құқығыңызды растаңыз",
  "Полосы": "Жолақтар",
  "Портретное": "Портреттік",
  "Прежний заказ ещё не завершён. Сначала проверьте его результат.": "Алдыңғы тапсырыс әлі аяқталған жоқ. Алдымен оның нәтижесін тексеріңіз.",
  "Приближение": "Жақындату",
  "Проверка отклонила материал. Измените исходные данные.": "Тексеру материалды қабылдамады. Бастапқы деректерді өзгертіңіз.",
  "Продолжить проверку отправки": "Жіберуді тексеруді жалғастыру",
  "Результат недоступен. Проверьте историю заказа.": "Нәтиже қолжетімсіз. Тапсырыс тарихын тексеріңіз.",
  "Результат отправки пока не подтверждён. Продолжите проверку с тем же ключом.": "Жіберу нәтижесі әлі расталған жоқ. Сол кілтпен тексеруді жалғастырыңыз.",
  "Результат пока не подтверждён. Проверьте этот заказ, прежде чем создавать новый.": "Нәтиже әлі расталған жоқ. Жаңасын жасамас бұрын осы тапсырысты тексеріңіз.",
  "Своё видео": "Өз бейнеңіз",
  "Своё фото": "Өз фотоңыз",
  "Создание сейчас недоступно": "Қазір жасау мүмкін емес",
  "Создать кружок": "Бейнехабар жасау",
  "Создаём видео": "Бейне жасалуда",
  "Списание возвращено": "Шегерілген сома қайтарылды",
  "Тестовый заказ без списания": "Сома шегерілмейтін сынақ тапсырысы",
  "Файлом": "Файл ретінде",
  "Фоновый звук": "Фондық дыбыс",
  "Фото с лицом": "Бет бейнеленген фото",
  "Цена или версия инструмента изменилась. Обновите форму и проверьте стоимость.": "Құралдың бағасы немесе нұсқасы өзгерді. Пішінді жаңартып, құнын тексеріңіз.",
  "Человек или персонаж": "Адам немесе кейіпкер",
  "Что скажет?": "Ол не айтады?",
  "Напишите не меньше {0} знаков": "Кемінде {0} таңба жазыңыз",
  "Текст отклонён проверкой. Измените текст.": "Мәтін тексеруден өтпеді. Мәтінді өзгертіңіз.",
  "В видео прозвучат новые слова.": "Видеода жаңа сөздер айтылады.",
  "Если речь длиннее видео, ролик повторится.": "Егер сөйлеу ұзақтығы видеодан асып кетсе, ролик қайталанады.",
  "Исходная речь": "Бастапқы сөйлеу",
  "Новая запись": "Жаңа жазба",
  "Новые слова текстом": "Жаңа сөздер мәтін түрінде",
  "Речь в видео": "Видеодағы сөйлеу",
  "Размер файла не должен превышать {0} МБ.": "Файл өлшемі {0} МБ-тан аспауы керек.",
  "До {0} МБ": "{0} МБ дейін",
  "Альбомное": "Альбомдық",
  "Альбомом": "Альбомдық форматта",
  "Без стиля": "Стильсіз",
  "В новом стиле": "Жаңа стильде",
  "Вариант": "Нұсқа",
  "Во весь экран": "Толық экран",
  "Восстановить фото": "Фотосуретті қалпына келтіру",
  "Все стили": "Барлық стильдер",
  "Все темы": "Барлық тақырыптар",
  "Выберите инструмент в каталоге, затем подтвердите использование фото.": "Каталогтан құралды таңдаңыз, содан кейін фотосуретті пайдалануды растаңыз.",
  "Выберите подходящее фото до {0} МБ.": "{0} МБ-қа дейінгі сәйкес фотосуретті таңдаңыз.",
  "Выберите стиль или свой референс": "Стильді немесе өз референсіңізді таңдаңыз",
  "Выбран свой референс": "Өз референсіңіз таңдалды",
  "Выбрать стиль": "Стильді таңдау",
  "Двигайте картинку, чтобы выбрать кадр": "Кадрды таңдау үшін суретті жылжытыңыз",
  "Диафрагма": "Диафрагма",
  "Добавить человека": "Адам қосу",
  "Добавьте описание, от 10 знаков": "Сипаттаманы енгізіңіз, кемінде 10 таңба",
  "Загрузите фото": "Фотосуретті жүктеңіз",
  "Заполните обязательные поля": "Міндетті өрістерді толтырыңыз",
  "Изменить фото": "Фотосуретті өзгерту",
  "Использовать выбранное фото результата": "Нәтижедегі таңдалған фотосуретті пайдалану",
  "Кадр": "Кадр",
  "Кадрирование": "Кадрлау",
  "Как у фото": "Фотодағыдай",
  "Камера": "Камера",
  "Найти настройку съёмки": "Түсірілім параметрін табу",
  "Найти стиль": "Стильді табу",
  "Настройки съёмки недоступны.": "Түсірілім параметрлері қолжетімсіз.",
  "Начать новое улучшение": "Жаңа жақсартуды бастау",
  "Не выбран": "Таңдалмаған",
  "Не удалось восстановить улучшение. Новая отправка заблокирована.": "Жақсартуды қалпына келтіру мүмкін болмады. Жаңа жіберуге тыйым салынған.",
  "Не удалось загрузить режимы фото.": "Фото режимдерін жүктеу мүмкін болмады.",
  "Не удалось загрузить фото.": "Фотосуретті жүктеу мүмкін болмады.",
  "Не удалось использовать фото результата. Откройте исходный заказ и попробуйте снова.": "Нәтижедегі фотосуретті пайдалану мүмкін болмады. Бастапқы тапсырысты ашып, қайталап көріңіз.",
  "Не удалось открыть режим. Попробуйте ещё раз.": "Режимді ашу мүмкін болмады. Қайталап көріңіз.",
  "Не удалось передать выбранное фото. Попробуйте снова.": "Таңдалған фотосуретті жіберу мүмкін болмады. Қайталап көріңіз.",
  "Не удалось проверить владельца.": "Иесін тексеру мүмкін болмады.",
  "Не удалось прочитать фото.": "Фотосуретті оқу мүмкін болмады.",
  "Не удалось улучшить текст. Исходный текст сохранён.": "Мәтінді жақсарту мүмкін болмады. Бастапқы мәтін сақталды.",
  "О стиле": "Стиль туралы",
  "Объектив": "Объектив",
  "Оживить фото": "Фотосуретті жандандыру",
  "Описание во весь экран": "Толық экрандағы сипаттама",
  "Описание длиннее допустимого": "Сипаттама рұқсат етілген ұзындықтан асып кетті",
  "По вертикали": "Тігінен",
  "По горизонтали": "Көлденеңінен",
  "По описанию": "Сипаттама бойынша",
  "Повторить прежнее улучшение": "Алдыңғы жақсартуды қайталау",
  "Подтвердите права на материалы": "Материалдарды пайдалануға құқығыңызды растаңыз",
  "Пример": "Мысал",
  "Проверить улучшение": "Жақсартуды тексеру",
  "Проверяем фото…": "Фотосурет тексерілуде…",
  "Ракурс": "Түсіру бұрышы",
  "Раскрасить чёрно-белое": "Ақ-қара фотосуретті бояу",
  "Режим фото": "Фото режимі",
  "Референс должен быть не меньше 256 × 256 пикселей.": "Референс өлшемі кемінде 256 × 256 пиксель болуы керек.",
  "Свернуть": "Жию",
  "Свет": "Жарық",
  "Свой референс": "Өз референсіңіз",
  "Свой референс сейчас недоступен": "Өз референсіңіз қазір қолжетімсіз",
  "Сделать рилс": "Рилс жасау",
  "Сколько фото": "Фотосуреттер саны",
  "Создать фото": "Фотосурет жасау",
  "Создаём фото": "Фотосурет жасалуда",
  "Срок проверки улучшения истёк. Исходный текст сохранён.": "Жақсартуды тексеру мерзімі аяқталды. Бастапқы мәтін сақталды.",
  "Тема стиля": "Стиль тақырыбы",
  "Убрать из кадра": "Кадрдан алып тастау",
  "Улучшение пока не подтверждено. Исходный текст сохранён.": "Жақсарту әлі расталмады. Бастапқы мәтін сақталды.",
  "Улучшить": "Жақсарту",
  "Формат файла": "Файл пішімі",
  "Фото готовы": "Фотосуреттер дайын",
  "Фото на аватарку": "Аватарға арналған фото",
  "Фото не создано": "Фотосурет жасалмады",
  "Цвет": "Түс",
  "Что дальше": "Әрі қарай не істеу керек",
  "Что делает в кадре": "Кадрда не істеп жатыр",
  "Выберите разных людей в кадре": "Кадрға әртүрлі адамдарды таңдаңыз",
  "Измените описание и попробуйте улучшить его снова.": "Сипаттаманы өзгертіп, оны жақсартуды қайта көріңіз.",
  "Использовать референс": "Референсті пайдалану",
  "Авто": "Авто",
  "Без движения": "Қозғалыссыз",
  "Видео должно длиться не меньше секунды": "Видео кемінде бір секунд болуы керек",
  "Выберите главное фото": "Негізгі фотоны таңдаңыз",
  "Выберите один исходный файл": "Бір бастапқы файлды таңдаңыз",
  "Выберите файл подходящего формата и размера": "Қолдау көрсетілетін пішім мен өлшемдегі файлды таңдаңыз",
  "Выберите фрагмент от 1 до 10 секунд": "1–10 секундтық үзіндіні таңдаңыз",
  "Главное фото": "Негізгі фото",
  "Длительность исходника: {0} с": "Бастапқы ұзақтығы: {0} с",
  "Добавить речь": "Сөйлеу қосу",
  "Загрузите видео": "Видео жүктеңіз",
  "Загрузите фото или видео": "Фото немесе видео жүктеңіз",
  "Загрузить": "Жүктеу",
  "Загрузить видео": "Видео жүктеу",
  "Загрузить фото": "Фото жүктеу",
  "Звук исходника не сохраняется: модель создаёт новый звук.": "Бастапқы дыбыс сақталмайды: модель жаңа дыбыс жасайды.",
  "Звук от модели": "Модель жасаған дыбыс",
  "Звук создаёт модель: фон, шумы и музыка. Речь можно добавить после создания.": "Модель фондық дыбыс, шу мен музыка жасайды. Сөйлеуді кейін қосуға болады.",
  "Использовать видео результата": "Нәтиже видеосын пайдалану",
  "Исходное видео": "Бастапқы видео",
  "Исходный файл": "Бастапқы файл",
  "Как двигаться": "Қалай қозғалсын",
  "Конец фрагмента, мс": "Үзінді соңы, мс",
  "Конец, секунды": "Соңы, секунд",
  "Люди в кадре недоступны для этого режима": "Бұл режимде кадрға адам қосу қолжетімсіз",
  "Начало фрагмента, мс": "Үзінді басы, мс",
  "Начало, секунды": "Басы, секунд",
  "Не удалось загрузить режимы видео.": "Видео режимдерін жүктеу мүмкін болмады.",
  "Не удалось использовать видео результата. Откройте исходный заказ и попробуйте снова.": "Нәтиже видеосын пайдалану мүмкін болмады. Бастапқы тапсырысты ашып, қайталап көріңіз.",
  "Не удалось передать видео. Откройте исходный заказ и попробуйте снова.": "Видеоны жіберу мүмкін болмады. Бастапқы тапсырысты ашып, қайталап көріңіз.",
  "Новое": "Жаңа",
  "Объёмное фото создаётся без звука": "Көлемді фото дыбыссыз жасалады",
  "Первый кадр": "Бірінші кадр",
  "Продолжить загрузку": "Жүктеуді жалғастыру",
  "Разрешение": "Ажыратымдылық",
  "Режим видео": "Видео режимі",
  "Снимем из главного фото. Выберите главное фото для кадрирования.": "Негізгі фото пайдаланылады. Қию үшін негізгі фотоны таңдаңыз.",
  "Снять": "Түсіру",
  "Снять видео": "Видео түсіру",
  "Создать видео": "Видео жасау",
  "Темп": "Қарқын",
  "Формат задаёт инструмент: портрет 3:4, ролик на 5 секунд": "Пішім бекітілген: тік 3:4, 5 секундтық видео",
  "Фото товара": "Тауар фотолары",
  "Фрагмент от 1 до 10 секунд": "1–10 секундтық үзінді",
  "Хит": "Танымал",
  "Что изменить": "Нені өзгерту керек",
  "Этот режим видео пока недоступен": "Бұл видео режимі әзірге қолжетімсіз",
  "Как у исходника": "Бастапқыдай",
  "Со звуком": "Дыбыспен",
  "Без звука": "Дыбыссыз",
  "5 секунд": "5 секунд",
  "10 секунд": "10 секунд",
  "Не удалось прочитать файл.": "Файлды оқу мүмкін болмады.",
  "1. Видео с вами": "1. Сіз бар видео",
  "1. Видео с движениями": "1. Қозғалыс видеосы",
  "2. Кем стать": "2. Кімге айналу",
  "2. Кто повторит": "2. Кім қайталайды",
  "Видео должно длиться не меньше {0} секунд": "Видео кемінде {0} секунд болуы керек",
  "Водяной знак — недоступен": "Сутаңба — қолжетімсіз",
  "Вы, близкий или персонаж": "Сіз, жақыныңыз немесе кейіпкер",
  "Выберите допустимый фрагмент видео": "Рұқсат етілген ұзақтықтағы үзіндіні таңдаңыз",
  "Выберите одного героя": "Бір кейіпкерді таңдаңыз",
  "Выберите фон": "Фонды таңдаңыз",
  "Выберите, кто повторит движения": "Қозғалысты кім қайталайтынын таңдаңыз",
  "Голос героя — недоступен": "Кейіпкер дауысы — қолжетімсіз",
  "Другой голос — недоступен": "Басқа дауыс — қолжетімсіз",
  "Загрузите видео с движениями": "Қозғалыс видеосын жүктеңіз",
  "Из видео": "Видеодан",
  "Изменить людей и свои фото": "Адамдар мен өз фотоларыңызды өзгерту",
  "Источник героя": "Кейіпкер көзі",
  "Исходный звук сохраняется, если он есть в ролике.": "Видеода дыбыс болса, бастапқы дыбыс сақталады.",
  "Кадр, ракурс и фон берутся с фото героя.": "Кадр, бұрыш және фон кейіпкердің фотосынан алынады.",
  "Кто повторит движения": "Қозғалысты кім қайталайды",
  "На фото должны быть видны голова, плечи и корпус.": "Фотода бас, иық және дене көрінуі керек.",
  "Нужен один человек в кадре. На фото и видео должны быть видны голова, плечи и корпус.": "Кадрда бір адам болуы керек. Фото мен видеода бас, иық және дене көрінуі керек.",
  "Подтвердите права и согласие человека": "Құқықтарыңызды және адамның келісімін растаңыз",
  "Подтверждаю права на материалы и согласие человека на использование его изображения": "Материалдарға құқығымды және адамның бейнесін пайдалануға келісімін растаймын",
  "Преобразование в кружок недоступно: в результате нет подтверждённой звуковой дорожки.": "Дөңгелек видеоға айналдыру қолжетімсіз: нәтижеде расталған дыбыс жолы жоқ.",
  "Режим движения": "Қозғалыс режимі",
  "С героя": "Кейіпкерден",
  "Смена голоса пока недоступна": "Дауысты ауыстыру әзірге қолжетімсіз",
  "Снять выбор": "Таңдауды алып тастау",
  "Сохранение исходного звука не подтверждено.": "Бастапқы дыбыстың сақталуы расталмаған.",
  "Стать персонажем": "Кейіпкерге айналу",
  "Сцена и движения берутся из видео; внешность может отличаться.": "Көрініс пен қозғалыс видеодан алынады; сыртқы келбет өзгеше болуы мүмкін.",
  "Только свои фото или с согласием человека на фото": "Тек өз фотоңызды немесе фотодағы адамның келісімімен",
  "Фон": "Фон",
  "Фото героя": "Кейіпкер фотосы",
  "Фрагмент от {0} до {1} секунд": "{0}–{1} секундтық үзінді",
  "{0} символов": "{0} таңба",
  "Авито": "Avito",
  "Английский": "Ағылшын",
  "Выберите аудио или видео": "Аудио немесе видео таңдаңыз",
  "Выбрать": "Таңдау",
  "Гарантия": "Кепілдік",
  "Да": "Иә",
  "Для чего нужен промпт": "Промпт мақсаты",
  "Для этого инструмента сократите текст до 500 символов.": "Бұл құрал үшін мәтінді 500 таңбаға қысқартыңыз.",
  "Добавьте текст": "Мәтін қосыңыз",
  "Добавьте файл": "Файл қосыңыз",
  "Дополнительные варианты": "Қосымша нұсқалар",
  "Дополнительные варианты пока не подтверждены.": "Қосымша нұсқалар әлі расталмады.",
  "Дружелюбный": "Достық",
  "Загрузите запись или запишите голос. Распознавание начнётся после подтверждения.": "Жазба жүктеңіз немесе дауысыңызды жазыңыз. Тану растаудан кейін басталады.",
  "Исходное фото": "Бастапқы фото",
  "Как изменить текст": "Мәтінді қалай өзгерту керек",
  "Комплект": "Жиынтық",
  "Короткий": "Қысқа",
  "Материал": "Материал",
  "Музыка": "Музыка",
  "На весь экран": "Толық экран",
  "Не удалось открыть инструмент. Проверьте аккаунт и длину текста.": "Құралды ашу мүмкін болмады. Аккаунт пен мәтін ұзындығын тексеріңіз.",
  "Не удалось подтвердить дополнительные варианты. Проверьте тот же запрос.": "Қосымша нұсқалар расталмады. Сол сұрауды тексеріңіз.",
  "Не удалось скачать текст.": "Мәтінді жүктеу мүмкін болмады.",
  "Не удалось скопировать текст.": "Мәтінді көшіру мүмкін болмады.",
  "Не удалось сохранить черновик. Создание заблокировано, чтобы не потерять данные.": "Нобай сақталмады. Деректерді жоғалтпау үшін жасау бұғатталды.",
  "Нейтральный": "Бейтарап",
  "Нет": "Жоқ",
  "Объём описания": "Сипаттама көлемі",
  "Описание товара": "Тауар сипаттамасы",
  "Повторить запрос с тем же ключом": "Сол кілтпен қайталау",
  "Подарочный": "Сыйлық",
  "Подробнее": "Толығырақ",
  "Подробный": "Толық",
  "Подтверждаю права на материалы": "Материалдарға құқығымды растаймын",
  "Пожелания": "Тілектер",
  "Показать время": "Уақытты көрсету",
  "Показать всё": "Барлығын көрсету",
  "Премиальный": "Премиум",
  "Проверить тот же запрос": "Сол сұрауды тексеру",
  "Продающий": "Сатуға бағытталған",
  "Промпт из видео пока недоступен.": "Видеодан промпт әзірге қолжетімсіз.",
  "Промпт из фото": "Фотодан промпт",
  "Разделить по собеседникам": "Сөйлеушілерге бөлу",
  "Размеры": "Өлшемдер",
  "Распознавание по ссылке YouTube пока недоступно.": "YouTube сілтемесі арқылы тану әзірге қолжетімсіз.",
  "Распознать": "Тану",
  "Редактировать текст": "Мәтінді өңдеу",
  "Сайт": "Сайт",
  "Сбросить сохранённый черновик": "Сақталған нобайды қалпына келтіру",
  "Скачать TXT": "TXT жүктеу",
  "Скопировать весь текст": "Бүкіл мәтінді көшіру",
  "Собеседник {0}": "Сөйлеуші {0}",
  "Создать промпт": "Промпт жасау",
  "Создать сценарий": "Сценарий жасау",
  "Создаём текст": "Мәтін жасалуда",
  "Сократите пожелания": "Тілектерді қысқартыңыз",
  "Сократите текст": "Мәтінді қысқартыңыз",
  "Список": "Тізім",
  "Текст готов": "Мәтін дайын",
  "Текст из аудио и видео": "Аудио мен видеодан мәтін",
  "Текст не создан": "Мәтін жасалмады",
  "Тестовый режим без списания": "Есептен шығарылмайтын сынақ режимі",
  "Тон описания": "Сипаттама үні",
  "Улучшить промпт": "Промптты жақсарту",
  "Уход": "Күтім",
  "Что добавить в описание": "Сипаттамаға не қосу керек",
  "Экспертный": "Сарапшылық",
  "Язык": "Тіл",
  "Яндекс Маркет": "Yandex Market",
  "Добавьте фото в открывшемся инструменте.": "Ашылған құралда фото қосыңыз.",
  "Не удалось открыть фото.": "Фотоны ашу мүмкін болмады.",
  "Текст для видео": "Видеоға арналған мәтін",
  "Цена этого выбора пока не подтверждена": "Бұл таңдаудың бағасы әлі расталмады",
  "C за фото": "C / фото",
  "C за секунду": "C / секунд",
  "Обычный": "Әдеттегі",
  "Кто повторил": "Кім қайталады",
  "Человек с фото": "Фотодағы адам",
  "Сменить фон": "Фонды ауыстыру",
  "Убрать лишнее": "Артығын алып тастау",
  "Добавить очки": "Көзілдірік қосу",
  "Причёска": "Шаш үлгісі",
  "Улыбка": "Күлімсіреу",
  "Деловой образ": "Іскерлік бейне",
  "Летний фон": "Жазғы фон",
  "Машет рукой": "Қол бұлғайды",
  "Ветер": "Жел",
  "Плавнее": "Біркелкірек",
  "Ярче": "Жарқынырақ",
  "День в ночь": "Күндізден түнге",
  "Снег": "Қар",
  "Очки": "Көзілдірік",
  "Что должно быть на фото? Например: девушка с зонтом на мокрой улице, вечер, огни витрин": "Фотода не болуы керек? Мысалы: дымқыл көшеде қолшатыр ұстаған қыз, кеш, витрина шамдары",
  "Что поменять на фото? Например: замени фон на ночной город, добавь очки": "Фотода нені өзгерту керек? Мысалы: фонды түнгі қалаға ауыстыр, көзілдірік қос",
  "Что добавить или поменять? Например: деловой костюм, лёгкая улыбка": "Нені қосу немесе өзгерту керек? Мысалы: іскерлік костюм, жеңіл күлімсіреу",
  "Что происходит в ролике? Например: камера медленно летит над ночным городом, огни и мокрый асфальт": "Бейнеде не болып жатыр? Мысалы: камера түнгі қаланың үстінен баяу ұшып барады, шамдар мен дымқыл асфальт",
  "Как двигаться? Например: улыбается и машет рукой, ветер в волосах": "Қалай қозғалсын? Мысалы: күлімсіреп қол бұлғайды, шашын жел желпиді",
  "Что поменять в видео? Например: замени фон на ночной город, добавь снег": "Бейнеде нені өзгерту керек? Мысалы: фонды түнгі қалаға ауыстыр, қар қос",
  "Что добавить? Например: движения плавнее, ярче": "Нені қосу керек? Мысалы: біркелкірек қимылдар, жарқынырақ",
  "Сменить голос в записи": "Жазбадағы дауысты өзгерту",
  "Загрузите запись": "Жазбаны жүктеңіз",
  "Ваша речь зазвучит выбранным голосом": "Сөзіңіз таңдалған дауыспен естіледі",
  "Голосовое, интервью или заметку: уберём шум": "Дауыстық хабарлама, сұхбат немесе жазба: шуды жоямыз",
  "Библиотека и ваши клоны": "Кітапхана және сіздің клондарыңыз",
  "Без переозвучки, выберите другой": "Дауысты түрлендіру жоқ, басқасын таңдаңыз",
  "· Мой голос": "· Менің дауысым",
  "· ещё {0}+ голосов": "· тағы {0}+ дауыс",
  "Убрать шум": "Шуды жою",
  "Перед сменой голоса уберём фон и эхо": "Дауысты өзгертпес бұрын фон мен жаңғырықты жоямыз",
  "Оставим только голос, без фона и эха": "Тек дауысты қалдырамыз, фонсыз және жаңғырықсыз",
  "Голосовым или файлом: выберете, когда запись будет готова": "Дауыстық хабарлама немесе файл ретінде: жазба дайын болғанда таңдайсыз",
  "Сменить голос": "Дауысты өзгерту",
  "Сделать голосовым": "Дауыстық хабарлама жасау",
  "{0} · от {1} C": "{0} · {1} C бастап",
  "Сначала остановите запись": "Алдымен жазуды тоқтатыңыз",
  "Загрузите или запишите аудио": "Аудионы жүктеңіз немесе жазыңыз",
  "Читаем запись, секунду": "Жазба оқылуда, бір сәт",
  "Запись длиннее {0}, загрузите короче": "Жазба {0} уақыттан ұзын, қысқасын жүктеңіз",
  "Выберите голос, которым зазвучит запись": "Жазба қай дауыспен естілетінін таңдаңыз",
  "Этот голос не умеет переозвучку, выберите другой": "Бұл дауыс түрлендіруді қолдамайды, басқасын таңдаңыз",
  "Пауза": "Кідірту",
  "Длиннее {0}": "{0} уақыттан ұзын",
  "Звучит запись": "Жазба ойнатылуда",
  "Прослушать запись": "Жазбаны тыңдау",
  "Загрузите запись короче": "Қысқарақ жазба жүктеңіз",
  "Запись с микрофона": "Микрофон жазбасы",
  "Без шума": "Шусыз",
  "Как в записи": "Жазбадағыдай",
  "Слушать": "Тыңдау",
  "Отправить голосовым": "Дауыстық хабарлама ретінде жіберу",
  "Отправить файлом": "Файл ретінде жіберу",
  "Голосовое в чате": "Дауыстық хабарлама чатта",
  "Файл в чате": "Файл чатта",
  "Голосовое в чате, в отдельной теме": "Дауыстық хабарлама чатта, бөлек тақырыпта",
  "Файл в чате, в отдельной теме": "Файл чатта, бөлек тақырыпта",
  "Тут откроется тема чата, куда бот прислал голосовое": "Мұнда бот дауыстық хабарламаны жіберген чат тақырыбы ашылады",
  "Тут откроется тема чата, куда бот прислал запись": "Мұнда бот жазбаны жіберген чат тақырыбы ашылады",
  "Меняем голос": "Дауыс өзгертілуде",
  "Собираем запись": "Жазба жиналуда",
  "Шум убран": "Шу жойылды",
  "Запись готова": "Жазба дайын",
  "Голос изменён": "Дауыс өзгертілді",
  "Можно уйти с экрана: бот напишет, когда запись будет готова.": "Экраннан шыға беруге болады: жазба дайын болғанда бот жазады.",
  "Голос ваш, шума больше нет.": "Дауыс сіздікі, шу енді жоқ.",
  "Голос ваш, запись готова стать голосовым.": "Дауыс сіздікі, жазба дауыстық хабарлама болуға дайын.",
  "Слова и интонация ваши, голос новый.": "Сөздер мен интонация сіздікі, дауыс жаңа.",
  "Пришлём в чат голосовым или файлом, как удобнее.": "Чатқа дауыстық хабарлама немесе файл ретінде жібереміз, қалай ыңғайлы болса.",
  "Запись ещё собирается": "Жазба әлі жиналып жатыр",
  "Заставить говорить": "Сөйлету",
  "Заменить запись": "Жазбаны ауыстыру",
  "Загружаем запись": "Жазба жүктелуде",
  "Запись загружена": "Жазба жүктелді",
  "Запись собрана": "Жазба жиналды",
  "Запись не прошла проверку": "Жазба тексеруден өтпеді",
  "запись не собрана": "жазба жиналмады",
  "голос не изменён": "дауыс өзгертілмеді",
  "Не получилось убрать шум": "Шуды жою мүмкін болмады",
  "Не получилось собрать запись": "Жазбаны жинау мүмкін болмады",
  "Не получилось сменить голос": "Дауысты өзгерту мүмкін болмады",
  "Обновить форму": "Пішінді жаңарту",
  "Запись {0}": "Жазба {0}",
  "Проверяем доступность": "Қолжетімділік тексерілуде",
  "Загрузите запись заново": "Жазбаны қайта жүктеңіз",
  "Не удалось выбрать голос. Попробуйте ещё раз.": "Дауысты таңдау мүмкін болмады. Қайталап көріңіз.",
  "Запись здесь недоступна, загрузите файл": "Мұнда жазу қолжетімсіз, файл жүктеңіз",
  "Не удалось прочитать запись, попробуйте ещё раз": "Жазбаны оқу мүмкін болмады, қайталап көріңіз",
  "Ваш голос": "Сіздің дауысыңыз",
  "в аудио": "аудиода",
  "со скидкой, {0} водяной знак": "жеңілдікпен, {0} су таңбасы",
  "Запись ещё загружается": "Жазба әлі жүктелуде",
  "Проверяем отправку": "Жіберу тексерілуде",
  "Этот способ отправки сейчас недоступен": "Бұл жіберу тәсілі қазір қолжетімсіз",
  "Отправка пока не подтверждена. Нажмите ещё раз — проверим тот же запрос.": "Жіберу әлі расталмады. Қайта басыңыз — сол сұрауды тексереміз.",
  "Не удалось передать запись. Откройте работу в «Истории» и попробуйте снова.": "Жазбаны беру мүмкін болмады. Жұмысты «Тарих» бөлімінде ашып, қайталап көріңіз.",
  "Попробовать ещё раз": "Қайталап көру",
  "Проверить ещё раз": "Қайта тексеру",
  "К настройкам": "Баптауларға оралу",
  "Заказ не создан": "Тапсырыс жасалмады",
  "Заказ не подтверждён": "Тапсырыс расталмады",
  "остаток": "қалдық",
  "Права на материалы": "Материалдарға құқық",
  "Только свои файлы или с согласия владельца": "Тек өз файлдарыңыз немесе иесінің келісімімен",
  "Загружаем файл": "Файл жүктелуде",
  "Создаём": "Жасалуда",
  "Файл больше {0} МБ, загрузите меньше": "Файл {0} МБ-тан үлкен, кішірегін жүктеңіз",
  "Фото меньше {0} × {1} пикселей, загрузите крупнее": "Фото {0} × {1} пиксельден кіші, үлкенін жүктеңіз",
  "Видео длиннее {0}, загрузите короче": "Бейне {0} уақыттан ұзын, қысқасын жүктеңіз",
  "Запись короче {0}, загрузите длиннее": "Жазба {0} уақыттан қысқа, ұзынырағын жүктеңіз",
  "Видео короче {0}, загрузите длиннее": "Бейне {0} уақыттан қысқа, ұзынырағын жүктеңіз",
  "Не удалось открыть фото. Загрузите его заново.": "Фотоны ашу мүмкін болмады. Оны қайта жүктеңіз.",
  "Не удалось открыть видео. Загрузите его заново.": "Бейнені ашу мүмкін болмады. Оны қайта жүктеңіз.",
  "Можно до {0} фото": "{0} фотоға дейін",
  "Этот человек не участвует": "Бұл адам қатыспайды",
  "Добавьте фото": "Фото қосыңыз",
  "Файл не читается, загрузите другой": "Файл оқылмайды, басқасын жүктеңіз",
  "Запись слишком короткая": "Жазба тым қысқа",
  "Не удалось открыть запись для прослушивания. Загрузите её заново.": "Жазбаны тыңдау үшін ашу мүмкін болмады. Оны қайта жүктеңіз.",
  "Файл не прошёл проверку. Выберите другой файл.": "Файл тексеруден өтпеді. Басқа файл таңдаңыз.",
  "Слишком много загрузок подряд. Подождите минуту и выберите файл снова.": "Қатарынан тым көп жүктеу. Бір минут күтіп, файлды қайта таңдаңыз.",
  "Файл не принят. Выберите его снова.": "Файл қабылданбады. Оны қайта таңдаңыз.",
  "Выбранный персонаж, голос или шаблон стал недоступен. Выберите другой — заказ не создан.": "Таңдалған кейіпкер, дауыс немесе үлгі қолжетімсіз болды. Басқасын таңдаңыз — тапсырыс жасалмады.",
  "Создание сейчас недоступно. Заказ не создан, Circle не списаны.": "Қазір жасау қолжетімсіз. Тапсырыс жасалмады, Circle шегерілмеді.",
  "Предыдущая работа ещё создаётся. Когда она будет готова, отправьте заказ снова.": "Алдыңғы жұмыс әлі жасалуда. Ол дайын болғанда, тапсырысты қайта жіберіңіз.",
  "Политику и запрещённые темы не пропускаем.": "Саясат пен тыйым салынған тақырыптарды өткізбейміз.",
  "{0} C списаны, {1}.": "{0} C шегерілді, {1}.",
  "{0} C вернулись на баланс.": "{0} C балансқа қайтарылды.",
  ", на шаге «{0}»": ", «{0}» қадамында",
  "Сбой на нашей стороне": "Біздің тарапта ақау болды",
  "{0} или {1}": "{0} немесе {1}",
  "до {0}": "{0} дейін",
  "Записать": "Жазу",
  "Заменить": "Ауыстыру",
  "Нужна запись: MP3, WAV или M4A": "Жазба қажет: MP3, WAV немесе M4A",
  "Нужно фото: JPG или PNG": "Фото қажет: JPG немесе PNG",
  "Нужно видео: MP4 или MOV": "Бейне қажет: MP4 немесе MOV",
  "Нужен файл PDF, DOCX или TXT": "PDF, DOCX немесе TXT файлы қажет",
  "Нужно фото или видео": "Фото немесе бейне қажет",
  "Файл больше {0} МБ": "Файл {0} МБ-тан үлкен",
  "Остановить запись": "Жазуды тоқтату",
  "Запрашиваем микрофон": "Микрофонға рұқсат сұралуда",
  "Отменить запись": "Жазудан бас тарту",
  "{0} КБ": "{0} КБ",
  "{0} МБ": "{0} МБ",
  "Не хватает {0} C · Пополнить": "{0} C жетіспейді · Толықтыру",
  "Не хватает Circle": "Circle жеткіліксіз",
  "Не хватает {0} C": "{0} C жетіспейді",
  "На балансе {0} C, нужно {1} C": "Балансында {0} C, қажет {1} C",
  "Создать за {0} вместо {1} C": "{1} C орнына {0} бағасымен жасау",
  "Создать за {0} C вместо {1} C": "{1} C орнына {0} C бағасымен жасау",
  "Со скидкой всё равно не хватает {0}": "Жеңілдікпен де {0} жетіспейді",
  "Со скидкой всё равно не хватает {0} C": "Жеңілдікпен де {0} C жетіспейді",
  "Для этой работы скидки нет": "Бұл жұмысқа жеңілдік жоқ",
  "Сделать дешевле на {0}%, с водяным знаком": "{0}% арзанырақ, су таңбасымен",
  "Сделать дешевле на 10%, с водяным знаком": "10% арзанырақ, су таңбасымен",
  "Назад в студию": "Студияға оралу",
  "Работа ещё создаётся": "Жұмыс әлі жасалуда",
  "Ваше фото": "Сіздің фотоңыз",
  "Ваши фото": "Сіздің фотоларыңыз",
  "Ваш текст": "Сіздің мәтініңіз",
  "Ваша тема": "Сіздің тақырыбыңыз",
  "Тема поста": "Жазба тақырыбы",
  "Готовые кадры": "Дайын кадрлар",
  "Готовый кружок": "Дайын дөңгелек видео",
  "Готовый ролик": "Дайын ролик",
  "Готовое фото": "Дайын фото",
  "Готовая аватарка": "Дайын аватар",
  "Готовые слайды": "Дайын слайдтар",
  "Готовый сюжет с вами: монтаж и музыка уже в шаблоне": "Сіз бар дайын сюжет: монтаж бен музыка үлгіде бар",
  "Пост в стиле шаблона, {0} на выбор": "Үлгі стиліндегі жазба, таңдауға {0}",
  "Аватарка для соцсетей и мессенджеров, {0} на выбор": "Әлеуметтік желілер мен мессенджерлерге арналған аватар, таңдауға {0}",
  "Фотосессия из {0} кадра в стиле шаблона": "Үлгі стиліндегі {0} кадрлық фотосессия",
  "Фотосессия из {0} кадров в стиле шаблона": "Үлгі стиліндегі {0} кадрлық фотосессия",
  "Ваш снимок оживёт в коротком ролике, {0} на выбор": "Суретіңіз қысқа роликте жанданады, таңдауға {0}",
  "Персонаж скажет ваш текст в кружке Telegram, {0} на выбор": "Кейіпкер мәтініңізді Telegram дөңгелек видеосында айтады, таңдауға {0}",
  "Карусель слайдов для поста, {0} на выбор": "Жазбаға арналған слайдтар каруселі, таңдауға {0}",
  "{0} стиль": "{0} стиль",
  "{0} стиля": "{0} стиль",
  "{0} стилей": "{0} стиль",
  "{0}, выберете на следующем шаге": "{0}, келесі қадамда таңдайсыз",
  "Что скажет герой, до 250 знаков": "Кейіпкер не айтады, 250 таңбаға дейін",
  "1 фото": "1 фото",
  "Любое, где хорошо видно лицо": "Бет анық көрінетін кез келген фото",
  "Лицо крупно и при хорошем свете": "Бет ірі планда және жақсы жарықта",
  "Селфи, лицо крупно": "Селфи, бет ірі планда",
  "Снимок оживёт в ролике": "Сурет роликте жанданады",
  "Или фото, из которых сделаем слайды": "Немесе слайд жасайтын фотолар",
  "Стиль кружка": "Дөңгелек видео стилі",
  "1 человек": "1 адам",
  "Вы, близкие или персонаж": "Сіз, жақындарыңыз немесе кейіпкер",
  "Ваши дети, до {0}": "Балаларыңыз, {0} дейін",
  "Ребёнок, одно фото": "Бала, бір фото",
  "Питомец, одно фото": "Үй жануары, бір фото",
  "Вы или близкие, одно фото": "Сіз немесе жақындарыңыз, бір фото",
  "По желанию: вы, близкие или персонаж": "Қалауыңыз бойынша: сіз, жақындарыңыз немесе кейіпкер",
  "По желанию: ваши дети, до {0}": "Қалауыңыз бойынша: балаларыңыз, {0} дейін",
  "По желанию: ребёнок, одно фото": "Қалауыңыз бойынша: бала, бір фото",
  "По желанию: питомец, одно фото": "Қалауыңыз бойынша: үй жануары, бір фото",
  "По желанию: вы или близкие, одно фото": "Қалауыңыз бойынша: сіз немесе жақындарыңыз, бір фото",
  "Reels": "Reels",
  "Аватар": "Аватар",
  "{0} кадр": "{0} кадр",
  "{0} кадра": "{0} кадр",
  "{0} кадров": "{0} кадр",
  "Выбрать, кто играет: {0}": "Кім ойнайтынын таңдау: {0}",
  "Сравнить: {0} и {1}": "Салыстыру: {0} және {1}",
  "Поровну": "Тең жартысы",
  "Пример результата пока не опубликован": "Нәтиже үлгісі әлі жарияланбаған",
  "Результат сохранён в «Истории». В чат не отправляем — так выбрано в настройках.": "Нәтиже «Тарих» бөлімінде сақталды. Чатқа жібермейміз — баптауларда солай таңдалған.",
  "Результат сохранён в «Истории».": "Нәтиже «Тарих» бөлімінде сақталды.",
  "Файл результата пока недоступен. Проверьте работу в «Истории».": "Нәтиже файлы әлі қолжетімді емес. Жұмысты «Тарих» бөлімінде тексеріңіз.",
  ", голос для: {0}": ", {0} үшін дауыс",
  ", играет: {0}": ", ойнайды: {0}",
  ": добавьте свои фото": ": фотоларыңызды қосыңыз",
  ": добавьте фото": ": фото қосыңыз",
  "<b class=\"mono\">{0}</b> из <span class=\"mono\">{1}</span>": "<b class=\"mono\">{0}</b> / <span class=\"mono\">{1}</span>",
  "JPG или PNG, до 10 МБ": "JPG немесе PNG, 10 МБ дейін",
  "JPG, PNG · до {0} снимков": "JPG, PNG · {0} суретке дейін",
  "MP3, WAV или M4A, до 50 МБ": "MP3, WAV немесе M4A, 50 МБ дейін",
  "MP4 или MOV, до 200 МБ": "MP4 немесе MOV, 200 МБ дейін",
  "PDF, DOCX или TXT, до 20 МБ": "PDF, DOCX немесе TXT, 20 МБ дейін",
  "{0} и {1}": "{0} және {1}",
  "{0} фото": "{0} фото",
  "{0} фото · как в жизни": "{0} фото · өмірдегідей",
  "{0}, персонаж": "{0}, кейіпкер",
  "Анфас, вполоборота, с улыбкой и без": "Алдынан, жартылай бұрылып, күлімсіреп және күлімсіремей",
  "Без модели": "Модельсіз",
  "Без сильных теней и фильтров": "Қатты көлеңкесіз және сүзгісіз",
  "Было": "Бұрын",
  "В близких": "Жақындарда",
  "В кадре {0}": "Кадрда: {0}",
  "В кадре уже {0} из {1}: снимите отметку с кого-нибудь": "Кадрда {1} ішінен {0} бар: біреудің белгісін алып тастаңыз",
  "В кадре: {0}": "Кадрда: {0}",
  "В роли «{0}» не больше {1}": "«{0}» рөлінде {1}-ден аспайды",
  "В роль «{0}» персонажи не входят": "«{0}» рөліне кейіпкерлер кірмейді",
  "В роль «{0}» подходят {1}": "«{0}» рөліне сәйкес келеді: {1}",
  "Варианты делаются из ваших фото в разделе «Свой аватар». Выбранный встаёт в «Кто в кадре» на всех экранах.": "Нұсқалар «Жеке аватар» бөлімінде фотоларыңыздан жасалады. Таңдалғаны барлық экрандағы «Кадрда кім бар» бөліміне шығады.",
  "Ваш питомец из близких": "Жақындарыңыздан үй жануарыңыз",
  "Ваш ребёнок из близких": "Жақындарыңыздан балаңыз",
  "Ваши фото: один раз для всех инструментов": "Фотоларыңыз: барлық құралдар үшін бір рет",
  "Вкл": "Қосулы",
  "Впишите имя": "Атын жазыңыз",
  "Все <span class=\"mono\">{0}</span>": "Барлығы <span class=\"mono\">{0}</span>",
  "Все варианты на виду": "Барлық нұсқа көрініп тұр",
  "Все персонажи": "Барлық кейіпкерлер",
  "Вы и персонажи": "Сіз және кейіпкерлер",
  "Вы или персонаж": "Сіз немесе кейіпкер",
  "Вы, близкие и персонажи": "Сіз, жақындар және кейіпкерлер",
  "Вы, свои фото": "Сіз, өз фотоларыңыз",
  "Вы: добавьте свои фото": "Сіз: фотоларыңызды қосыңыз",
  "Выберите вариант": "Нұсқаны таңдаңыз",
  "Выберите вариант для поля «{0}»": "«{0}» өрісі үшін нұсқаны таңдаңыз",
  "Выберите ниже": "Төменнен таңдаңыз",
  "Выберите одного": "Біреуін таңдаңыз",
  "Выберите, кто играет: {0}": "Кім ойнайтынын таңдаңыз: {0}",
  "Выберите, кто это для вас": "Бұл сізге кім екенін таңдаңыз",
  "Выбирать во всех инструментах без загрузки": "Барлық құралдарда қайта жүктемей таңдау",
  "Выбор встанет во все инструменты": "Таңдау барлық құралдарға қолданылады",
  "Выбрать «{0}»": "«{0}» таңдау",
  "Выбрать вариант": "Нұсқаны таңдау",
  "Выбрать: {0}": "Таңдау: {0}",
  "Выкл": "Өшірулі",
  "Выключится, когда выберете вариант": "Нұсқаны таңдағанда өшеді",
  "Группы": "Топтар",
  "Добавить": "Қосу",
  "Добавить в кадр": "Кадрға қосу",
  "Добавьте свои фото": "Фотоларыңызды қосыңыз",
  "Добавьте свои фото или вариант": "Фотоларыңызды немесе нұсқаны қосыңыз",
  "Добавьте фото: {0}": "Фото қосыңыз: {0}",
  "Другой голос": "Басқа дауыс",
  "Ещё {0}: {1}": "Тағы {0}: {1}",
  "Заготовки": "Дайындамалар",
  "Загрузите файл": "Файлды жүктеңіз",
  "Загрузить ещё": "Тағы жүктеу",
  "Закрыть камеру": "Камераны жабу",
  "Запись недоступна. Загрузите видео.": "Жазу қолжетімсіз. Бейнені жүктеңіз.",
  "Здесь подходят {0}": "Мұнда сәйкес келеді: {0}",
  "Здесь только персонажи своей подборки": "Мұнда тек өз жинағының кейіпкерлері",
  "Играет: {0}": "Ойнайды: {0}",
  "Из ваших фото": "Фотоларыңыздан",
  "Из каталога": "Каталогтан",
  "Изменить ваши фото": "Фотоларыңызды өзгерту",
  "Изменить свои фото": "Өз фотоларыңызды өзгерту",
  "Изменить: {0}": "Өзгерту: {0}",
  "Иллюстрация": "Иллюстрация",
  "Имя": "Аты",
  "Имя и фото · роли выбираются в ряду": "Аты мен фотолары · рөлдер қатарда таңдалады",
  "Искать стиль": "Стиль іздеу",
  "Каким вы будете": "Қандай боласыз",
  "Камера · лицо в кадр": "Камера · бет кадрда",
  "Камера · селфи в кадр": "Камера · селфи кадрда",
  "Камера недоступна · имитация": "Камера қолжетімсіз · имитация",
  "Камера недоступна. Загрузите файл.": "Камера қолжетімсіз. Файлды жүктеңіз.",
  "Каталог 2 400+ голосов, подборки": "2 400+ дауыс каталогы, жинақтар",
  "Ко всем стилям": "Барлық стильдерге",
  "Кто будет моделью на фото": "Фотода кім модель болады",
  "Кто играет: <b>{0}</b>": "Кім ойнайды: <b>{0}</b>",
  "Кто играет: {0}": "Кім ойнайды: {0}",
  "Кто это для вас": "Бұл сізге кім",
  "Лицо в круг, смотрите в камеру": "Бетіңіз шеңберде болсын, камераға қараңыз",
  "Люди": "Адамдар",
  "Можно близких или персонажа": "Жақындарды немесе кейіпкерді таңдауға болады",
  "Можно ваших близких": "Жақындарыңызды таңдауға болады",
  "Можно до {0} видео": "{0} бейнеге дейін болады",
  "Можно до {0} записей": "{0} жазбаға дейін болады",
  "Можно до {0} записи": "{0} жазбаға дейін болады",
  "Можно до {0} запись": "{0} жазбаға дейін болады",
  "Можно до {0} файл": "{0} файлға дейін болады",
  "Можно до {0} файла": "{0} файлға дейін болады",
  "Можно до {0} файлов": "{0} файлға дейін болады",
  "Можно и так, но 3 или больше снимков дадут сходство точнее": "Осылай да болады, бірақ 3 не одан көп сурет ұқсастықты дәлірек етеді",
  "Можно и так, но 3 или больше фото дадут сходство точнее": "Осылай да болады, бірақ 3 не одан көп фото ұқсастықты дәлірек етеді",
  "Можно себя или близких": "Өзіңізді немесе жақындарды таңдауға болады",
  "Можно себя, близких или персонажа": "Өзіңізді, жақындарды немесе кейіпкерді таңдауға болады",
  "На этом экране вы в кадре всегда": "Бұл экранда сіз әрқашан кадрдасыз",
  "Навсегда, вместе с фото": "Фотоларымен бірге біржола",
  "Нажмите, чтобы выбрать": "Таңдау үшін басыңыз",
  "Найти": "Табу",
  "Напишите пару слов, и мы предложим варианты": "Бірнеше сөз жазыңыз, біз нұсқалар ұсынамыз",
  "Например: Барсик": "Мысалы: Барсик",
  "Например: Лёша": "Мысалы: Әли",
  "Нашли": "Табылды",
  "Не получилось подготовить файл": "Файлды дайындау мүмкін болмады",
  "Не получилось улучшить. Попробуйте дописать пару слов": "Жақсарту мүмкін болмады. Бірнеше сөз қосып көріңіз",
  "Не помещается<span class=\"nfx\">: до {0} знаков</span>": "Сыймайды<span class=\"nfx\">: {0} таңбаға дейін</span>",
  "Необязательно: всё уже настроено": "Міндетті емес: бәрі бапталған",
  "Ничего не нашлось": "Ештеңе табылмады",
  "Нужно выбрать": "Таңдау керек",
  "Объём": "Көлем",
  "Один раз для всех инструментов": "Барлық құралдар үшін бір рет",
  "Отменить свой вариант": "Өз нұсқаңыздан бас тарту",
  "Отметьте, кто будет в кадре · {0}": "Кадрда кім болатынын белгілеңіз · {0}",
  "Персонажи": "Кейіпкерлер",
  "Подберём сами": "Өзіміз таңдаймыз",
  "Подбираем варианты": "Нұсқаларды таңдап жатырмыз",
  "Пожилой": "Егде",
  "Поиск стилей": "Стильдерді іздеу",
  "Пока нечего сохранять": "Әзірге сақтайтын ештеңе жоқ",
  "Попробуйте другое слово": "Басқа сөзді көріңіз",
  "Порядок здесь один": "Мұнда реті біреу ғана",
  "Примеры": "Мысалдар",
  "Пропадёт {0} вместе с фото. Вернуть не получится.": "Фотоларымен бірге {0} жойылады. Қайтару мүмкін болмайды.",
  "Пропадёт из близких вместе с фото. Вернуть не получится.": "Фотоларымен бірге жақындардан жойылады. Қайтару мүмкін болмайды.",
  "Пропадёт из близких и {0} вместе с фото. Вернуть не получится.": "Фотоларымен бірге жақындардан және {0} жойылады. Қайтару мүмкін болмайды.",
  "Профиль близкого": "Жақынның профилі",
  "Разные ракурсы и выражения": "Әртүрлі ракурс пен мимика",
  "Реалистичный": "Шынайы",
  "Реалистичный, иллюстрация или 3D": "Шынайы, иллюстрация немесе 3D",
  "Роли": "Рөлдер",
  "Роль «{0}»": "«{0}» рөлі",
  "Роль «{0}» для женского персонажа": "«{0}» рөлі әйел кейіпкерге арналған",
  "Роль «{0}» для мужского персонажа": "«{0}» рөлі ер кейіпкерге арналған",
  "Роль «{0}» для персонажей своей подборки": "«{0}» рөлі өз жинағының кейіпкерлеріне арналған",
  "Свой вариант": "Өз нұсқаңыз",
  "Скачать здесь не получится": "Мұнда жүктеп алу мүмкін емес",
  "Создайте новый вариант": "Жаңа нұсқа жасаңыз",
  "Сортировка": "Сұрыптау",
  "Сохранится в близких": "Жақындарға сақталады",
  "Сохранить в близких": "Жақындарға сақтау",
  "Стало": "Кейін",
  "Только для этой фотосессии": "Тек осы фотосессия үшін",
  "Удаление": "Жою",
  "Удалить «{0}» {1}?": "«{0}» {1} жойылсын ба?",
  "Удалить «{0}» из близких?": "«{0}» жақындардан жойылсын ба?",
  "Удалить из близких": "Жақындардан жою",
  "Удалить из фотосессии": "Фотосессиядан жою",
  "Удерживайте, чтобы посмотреть примеры": "Мысалдарды көру үшін басып тұрыңыз",
  "Управление": "Басқару",
  "Файл готов. Нажмите ещё раз": "Файл дайын. Тағы басыңыз",
  "Фото до 10 МБ, видео до 200 МБ": "Фото 10 МБ дейін, бейне 200 МБ дейін",
  "Фрагмент": "Үзінді",
  "Что делает? Например: поправляет шарф": "Не істеп жатыр? Мысалы: шарфын түзеп жатыр",
  "Что делают в кадре": "Кадрда не істейді",
  "Эта настройка здесь закреплена": "Бұл баптау мұнда бекітілген",
  "Этот голос не умеет переозвучку записи": "Бұл дауыс жазбаны қайта дыбыстай алмайды",
  "вариант «{0}»": "«{0}» нұсқасы",
  "взрослая": "ересек",
  "взрослый": "ересек",
  "всё видео умещается": "бүкіл бейне сыяды",
  "выберите": "таңдаңыз",
  "до <span class=\"mono\">{0}</span>": "<span class=\"mono\">{0}</span> дейін",
  "до {0} человек": "{0} адамға дейін",
  "до {0} человека": "{0} адамға дейін",
  "ещё {0} из {1}": "{1} ішінен тағы {0}",
  "женская роль": "әйел рөлі",
  "из фотосессии": "фотосессиядан",
  "из этой фотосессии": "осы фотосессиядан",
  "камера": "камера",
  "максимум {0} секунд": "ең көбі {0} секунд",
  "максимум {0} секунда": "ең көбі {0} секунд",
  "максимум {0} секунды": "ең көбі {0} секунд",
  "можно до <span class=\"mono\">{0}</span>": "<span class=\"mono\">{0}</span> дейін болады",
  "мужская роль": "ер рөлі",
  "не из подборки этой роли": "бұл рөлдің жинағынан емес",
  "не подходит по возрасту": "жасы сәйкес келмейді",
  "не участвует в этой фотосессии": "бұл фотосессияға қатыспайды",
  "необязательно": "міндетті емес",
  "нет фото": "фото жоқ",
  "нужно выбрать": "таңдау керек",
  "нужно: Вы": "керек: Сіз",
  "персонажи в эту роль не входят": "кейіпкерлер бұл рөлге кірмейді",
  "питомец": "үй жануары",
  "по желанию": "қалауыңыз бойынша",
  "пожилая": "егде",
  "пожилой": "егде",
  "ребёнок": "бала",
  "роль для взрослого": "ересекке арналған рөл",
  "роль для женщины": "әйелге арналған рөл",
  "роль для мужчины": "ер адамға арналған рөл",
  "роль для питомца": "үй жануарына арналған рөл",
  "роль для ребёнка": "балаға арналған рөл",
  "роль для человека": "адамға арналған рөл",
  "Попробуйте другое слово или сбросьте тему": "Басқа сөзді көріңіз немесе тақырыпты алып тастаңыз",
  "Искать среди {n}+ голосов": "{n}+ дауыстан іздеу",
  "Голосов: {n}": "Дауыс: {n}",
  "Персонажей: {n}": "Кейіпкер: {n}",
  "Голосов: {0}": "Дауыс: {0}",
  "Прослушать {n}": "{n} тыңдау",
  "Загружаем ещё {n}": "Тағы {n} жүктелуде",
  "{a} из {b}": "{b} ішінен {a}",
  "Подборка": "Топтама",
  "Закрыть подборку": "Топтаманы жабу",
  "По имени": "Аты бойынша",
  "Загружаем подборки…": "Топтамалар жүктелуде…",
  "Не удалось загрузить голоса": "Дауыстар жүктелмеді",
  "Не удалось воспроизвести пример. Попробуйте ещё раз.": "Үлгі ойнатылмады. Қайталап көріңіз.",
  "Мой голос": "Менікі",
  "Мои": "Менікі",
  "Своих голосов пока нет": "Әзірге өз дауысыңыз жоқ",
  "Клонируйте свой голос, и он появится на этой вкладке.": "Дауысыңызды клондаңыз, ол осында шығады.",
  "Клонировать голос": "Дауысты клондау",
  "Открыть персонажа {0}": "{0} кейіпкерін ашу",
  "От": "Ең аз",
  "Тренды недели": "Апта трендтері",
  "Голоса, которые быстрее всего набирают заказы": "Тапсырысты ең жылдам жинап жатқан дауыстар",
  "Мужские": "Ер дауыстар",
  "Все мужские голоса библиотеки": "Кітапханадағы барлық ер дауыстар",
  "Женские": "Әйел дауыстар",
  "Все женские голоса библиотеки": "Кітапханадағы барлық әйел дауыстар",
  "Детские": "Балалар",
  "Детские и мультяшные голоса": "Балалар мен мультфильм дауыстары",
  "меню: Озвучка": "Дауыстар",
  "Системная": "Жүйелік",
  "Для аватарки и ленты": "Аватар мен лента үшін",
  "Как снимок с телефона": "Телефонмен түсірілгендей",
  "Для ленты": "Лента үшін",
  "На весь экран телефона": "Телефонның толық экраны",
  "Для обложки и экрана": "Мұқаба мен экран үшін",
  "Станет голосом по умолчанию для озвучки.": "Дыбыстаудың әдепкі дауысы болады.",
  "Когда генерация закончится": "Генерация аяқталғанда",
  "Награды и серия": "Марапаттар мен серия",
  "Напомним о награде за день": "Күнделікті марапатты еске саламыз",
  "Новые шаблоны и стили": "Жаңа үлгілер мен стильдер",
  "Не чаще раза в неделю": "Аптасына бір реттен артық емес",
  "Новости STEOS": "STEOS жаңалықтары",
  "Только крупные обновления": "Тек ірі жаңартулар",
  "Тут откроется документ в браузере": "Құжат браузерде ашылады",
  "Язык и валюта": "Тіл мен валюта",
  "Интерфейс и цены картой": "Интерфейс және карта бағалары",
  "новое|новых|новых": "жаңа",
  "работа|работы|работ": "жұмыс",
  "заказ|заказа|заказов": "тапсырыс",
  "Счётчики недоступны": "Есептегіштер қолжетімсіз",
  "История пуста": "Тарих бос",
  "Не задан": "Орнатылмаған",
  "Недоступны": "Қолжетімсіз",
  "Срок истёк": "Мерзімі өтті",
  "Не удалась": "Сәтсіз",
  "Готовится": "Дайындалуда",
  "Запрошено": "Сұралды",
  "Запрошено {0}": "{0} сұралды",
  "Недоступно": "Қолжетімсіз",
  "Пусто": "Бос",
  "Данные Mini App удалены": "Mini App деректері жойылды",
  "Удаление данных не удалось": "Деректер жойылмады",
  "Данные удалены частично": "Деректер ішінара жойылды",
  "Удаление требует проверки": "Жою тексеруді қажет етеді",
  "Запрос удаления принят": "Жою сұрауы қабылданды",
  "Удаляем данные Mini App": "Mini App деректерін жоюдамыз",
  "Удаление данных в очереди": "Жою кезекте",
  "STEOS ID сохранён": "STEOS ID сақталды",
  "Финансовые квитанции сохранены": "Қаржылық түбіртектер сақталды",
  "Статус удаления не подтверждён": "Жою күйі расталмады",
  "Удаление аккаунта": "Аккаунтты жою",
  "Удалить данные Mini App?": "Mini App деректерін жою керек пе?",
  "Удалить аккаунт?": "Аккаунтты жою керек пе?",
  "Работы, голоса и варианты «Вы» в Mini App удалятся. STEOS ID и финансовые квитанции сохранятся.": "Mini App-тегі жұмыстар, дауыстар мен «Сіз» нұсқалары жойылады. STEOS ID мен қаржылық түбіртектер сақталады.",
  "Работы, голоса, варианты «Вы» и Circle удалятся. Вернуть их не получится.": "Жұмыстар, дауыстар, «Сіз» нұсқалары мен Circle жойылады. Қайтару мүмкін емес.",
  "Удалить данные Mini App": "Mini App деректерін жою",
  "Удалить аккаунт": "Аккаунтты жою",
  "Данные Mini App. STEOS ID сохранится": "Mini App деректері. STEOS ID қалады",
  "Все данные удалятся навсегда": "Барлық дерек біржола жойылады",
  "В прототипе аккаунт не удаляется": "Прототипте аккаунт жойылмайды",
  "Автовоспроизведение": "Автоойнату",
  "Пример при выборе голоса": "Дауыс таңдағанда үлгі",
  "Присылать в чат": "Чатқа жіберу",
  "Готовые работы от бота": "Боттан дайын жұмыстар",
  "Уведомления и отклик": "Хабарландырулар мен діріл",
  "Данные": "Деректер",
  "Выгрузить данные": "Деректерді жүктеп алу",
  "Настройки создания сейчас только для чтения": "Жасау баптаулары қазір тек оқуға арналған",
  "Формат по умолчанию": "Әдепкі формат",
  "Для новых фото и видео": "Жаңа фото мен бейнеге",
  "На экране создания их можно поменять для одной работы.": "Жасау экранында оны бір жұмыс үшін өзгертуге болады.",
  "Сообщения приходят в чат с ботом": "Хабарлар ботпен чатқа келеді",
  "Бот напишет только в ответ на действия": "Бот тек әрекеттеріңізге жауап береді",
  "Уведомления пока недоступны": "Хабарландырулар әзірге қолжетімсіз",
  "Вибрация": "Діріл",
  "Лёгкий отклик на нажатия": "Басқанда жеңіл діріл",
  "Выгрузка данных": "Деректерді жүктеу",
  "Выгрузка запрошена": "Жүктеу сұралды",
  "Пришлём архив в чат в течение суток": "Мұрағатты бір тәулік ішінде чатқа жібереміз",
  "Настройки и доступные текстовые данные аккаунта": "Баптаулар және аккаунттың қолжетімді мәтіндік деректері",
  "Ссылка на архив придёт в чат с ботом": "Мұрағат сілтемесі ботпен чатқа келеді",
  "Готовые работы и заказы": "Дайын жұмыстар мен тапсырыстар",
  "Клоны и записи образцов": "Клондар мен үлгі жазбалары",
  "Ваши фото и варианты себя": "Суреттеріңіз бен өз нұсқаларыңыз",
  "Люди и питомцы из фотосессий": "Фотосессиялардағы адамдар мен үй жануарлары",
  "Запросить выгрузку": "Жүктеуді сұрау",
  "Готовим архив": "Мұрағатты дайындаудамыз",
  "Это займёт несколько минут. Лист можно закрыть, выгрузка продолжится": "Бұл бірнеше минут алады. Жаба беруге болады, жүктеу жалғасады",
  "Срок хранения архива истёк": "Мұрағаттың сақталу мерзімі өтті",
  "Запросите новую выгрузку данных": "Деректерді жаңадан жүктеуді сұраңыз",
  "Архив не собрался": "Мұрағат жиналмады",
  "Запросите выгрузку ещё раз": "Жүктеуді қайта сұраңыз",
  "Не вошли: {0}": "Кірмеді: {0}",
  "Вошли частично: {0}": "Ішінара кірді: {0}",
  "Не входят в выгрузку: {0}": "Жүктеуге кірмейді: {0}",
  "Часть данных недоступна. Точный состав указан в manifest.json внутри архива": "Деректердің бір бөлігі қолжетімсіз. Нақты құрамы мұрағаттағы manifest.json ішінде",
  "Архив готов, но не полностью": "Мұрағат дайын, бірақ толық емес",
  "Архив готов": "Мұрағат дайын",
  "Скачать можно до {0}": "{0} дейін жүктеп алуға болады",
  "Архив в формате ZIP": "ZIP мұрағаты",
  "Скачать архив": "Мұрағатты жүктеп алу",
  "Счётчики истории не загрузились": "Тарих есептегіштері жүктелмеді",
  "Загружаем историю": "Тарихты жүктеудеміз",
  "Проверьте связь и повторите загрузку": "Байланысты тексеріп, қайталаңыз",
  "История очищена": "Тарих тазартылды",
  "Голоса, варианты «Вы», близкие и Circle на месте": "Дауыстар, «Сіз» нұсқалары, жақындар мен Circle орнында",
  "Здесь появятся работы, когда вы что-то создадите": "Бірдеңе жасағанда жұмыстар осында шығады",
  "Раздел «История»": "«Тарих» бөлімі",
  "Работы": "Жұмыстар",
  "Фото, видео, кружки и озвучки": "Фото, бейне, дөңгелектер мен дыбыстаулар",
  "Заказы": "Тапсырыстар",
  "Параметры и статусы генераций": "Генерация параметрлері мен күйлері",
  "Голоса, варианты «Вы», близкие и Circle останутся.": "Дауыстар, «Сіз» нұсқалары, жақындар мен Circle қалады.",
  "Удалить работы и заказы": "Жұмыстар мен тапсырыстарды жою",
  "Без возможности восстановления": "Қалпына келтіру мүмкін емес",
  "Подтверждение удаления": "Жоюды растау",
  "Попробовать: {0}": "Байқап көру: {0}",
  "Обновление": "Жаңарту",
  "Загружаем «Что нового»": "«Не жаңа» жүктелуде",
  "Новых обновлений пока нет": "Әзірге жаңа жаңартулар жоқ",
  "Уведомления сейчас не сохранить": "Хабарландыруларды қазір сақтау мүмкін емес",
  "Настройки сейчас только для чтения": "Баптаулар қазір тек оқуға арналған",
  "Выгрузка не запросилась. Попробуйте ещё раз": "Жүктеу сұралмады. Қайталап көріңіз",
  "Удалить всю историю?": "Бүкіл тарихты жою керек пе?",
  "{0}. Вернуть не получится.": "{0}. Қайтару мүмкін емес.",
  "История не очистилась. Попробуйте ещё раз": "Тарих тазартылмады. Қайталап көріңіз",
  "Удаление не началось. Попробуйте ещё раз": "Жою басталмады. Қайталап көріңіз",
  "Не удалось загрузить настройки": "Баптаулар жүктелмеді",
  "«Что нового» не загрузилось": "«Не жаңа» жүктелмеді",
  "Сохранение настроек сейчас недоступно": "Баптауларды сақтау қазір қолжетімсіз",
  "Настройки уже изменились, показываем актуальные": "Баптаулар өзгерді, өзектісін көрсетеміз",
  "Не удалось сохранить. Попробуйте ещё раз": "Сақталмады. Қайталап көріңіз",
  "Настройки, ресурсы и история": "Баптаулар, ресурстар мен тарих",
  "Данные Mini App": "Mini App деректері",
  "Учётная запись и финансовые данные STEOS ID": "STEOS ID аккаунты және қаржылық деректер",
  "Переписка с ботом": "Ботпен хат алмасу",
  "Фото, аудио, видео и модели": "Фото, аудио, бейне және модельдер",
  "Данные других продуктов STEOS": "Басқа STEOS өнімдерінің деректері",
  "Рубли": "Рубль",
  "Драмы": "Драм",
  "Евро": "Еуро",
  "Доллары": "Доллар",
  "Другие языки": "Басқа тілдер",
  "Интерфейс и сообщения бота": "Интерфейс және бот хабарлары",
  "Цены картой покажем в этой валюте. Звёзды Telegram везде одинаковые.": "Карта бағалары осы валютада көрсетіледі. Telegram жұлдыздары барлық жерде бірдей.",
  "сегодня, {0}": "бүгін, {0}",
  "вчера, {0}": "кеше, {0}",
  "Старт": "Старт",
  "Плюс": "Плюс",
  "Про": "Про",
  "Картой или СБП": "Карта немесе СБП",
  "СБП только для РФ": "СБП тек РФ үшін",
  "1 месяц": "1 ай",
  "3 месяца": "3 ай",
  "6 месяцев": "6 ай",
  "Год": "Жыл",
  "год": "1 жыл",
  "С днём рождения": "Туған күніңмен",
  "С днём рождения. Пусть всё задуманное получается с первого раза": "Туған күніңмен. Ойлағаның бірден орындалсын",
  "Просто так": "Жай ғана",
  "Просто так. Пусть у тебя будет больше кружков и смешных голосов": "Жай ғана. Дөңгелектер мен күлкілі дауыстар көбейе берсін",
  "Спасибо": "Рақмет",
  "Спасибо, что ты рядом. Это маленький подарок от меня": "Қасымда болғаның үшін рақмет. Бұл менен шағын сыйлық",
  "С праздником": "Мерекең құтты болсын",
  "С праздником. Твори, снимай и удивляй": "Мерекең құтты болсын. Жаса, түсір, таң қалдыр",
  "Для блога": "Блогқа",
  "Для твоего блога: пусть ролики выходят чаще и легче": "Блогыңа: роликтер жиі әрі оңай шықсын",
  "Удачи": "Сәттілік",
  "Удачи в новом проекте. Пусть голос и картинка будут такими, как задумано": "Жаңа жобаңа сәттілік. Дауыс пен сурет ойлағаныңдай болсын",
  "картой": "картамен",
  "оплата картой каждый месяц": "ай сайын картамен төлем",
  "оплата картой за {0}": "{0} үшін картамен төлем",
  "{0} в месяц": "айына {0}",
  "{0} за {1}": "{1} үшін {0}",
  "кружок|кружка|кружков": "бейнехабар",
  "рилс|рилса|рилсов": "рилс",
  "свой голос|своих голоса|своих голосов": "өз дауыс",
  "своего голоса|своих голосов|своих голосов": "өз дауыс",
  "день|дня|дней": "күн",
  "звезда|звезды|звёзд": "жұлдыз",
  "Подписаться на {0}": "{0} жазылу",
  "Продлевается каждый месяц, отмена в любой момент": "Ай сайын жаңарады, кез келген уақытта тоқтатуға болады",
  "Без автопродления, Circle приходят каждый месяц": "Автожаңартусыз, Circle ай сайын келеді",
  "Перейти на {0}": "{0} тарифіне өту",
  "Сразу придут {0} C, а {1} больше не продлится": "{0} C бірден келеді, ал {1} енді жаңармайды",
  "Сразу придут {0} C": "{0} C бірден келеді",
  "Перейти на {0} с {1}": "{1} бастап {0} тарифіне өту",
  "До {0} остаётся {1}, потом {2}": "{0} дейін {1} қалады, кейін {2}",
  "Продлить на {0}": "{0} ұзарту",
  "Ещё {0} после {1}, без автопродления": "{1} кейін тағы {0}, автожаңартусыз",
  "Следующее списание {0}, {1}": "Келесі есептен шығару {0}, {1}",
  "Способ оплаты": "Төлем тәсілі",
  "Звёздами": "Жұлдызбен",
  "Тестовая оплата": "Сынақ төлемі",
  "Звёзды и деньги не списываются": "Жұлдыз да, ақша да алынбайды",
  "Оплата картой скоро": "Картамен төлем жақында",
  "Ваш тариф": "Сіздің тариф",
  "выгоднее на {0}%": "{0}% тиімдірек",
  "{0} C в месяц": "Айына {0} C",
  "или": "немесе",
  "Что сотворим в этом месяце?": "Осы айда не жасаймыз?",
  "Готовы творить без пауз?": "Үзіліссіз жасауға дайынсыз ба?",
  "Ваш тариф {0}": "Сіздің тариф: {0}",
  "{0} C каждый месяц": "Ай сайын {0} C",
  "До {0} {1}": "{0} {1} дейін",
  "Пакеты Circle, если не хватит": "Жетпесе — Circle пакеттері",
  "{0} включает": "{0} ішінде",
  "Сравнить": "Салыстыру",
  "Помесячно": "Ай сайын",
  "Выгода {0}": "Үнем {0}",
  "Одним платежом": "Бір төлеммен",
  "{0} с {1}": "{1} бастап {0}",
  "Оставить {0}": "{0} қалдыру",
  "Продлить {0}": "{0} ұзарту",
  "Продлить": "Ұзарту",
  "Включить продление": "Жаңартуды қосу",
  "Возобновить {0}": "{0} жаңғырту",
  "Возобновить": "Жаңғырту",
  "Оплата пока не подключена": "Төлем әлі қосылмаған",
  "Сейчас недоступно": "Қазір қолжетімсіз",
  "Переход на {0} на {1}": "{1} мерзімге {0} тарифіне өту",
  "Переход на {0}": "{0} тарифіне өту",
  "Продление {0} на {1}": "{0} тарифін {1} ұзарту",
  "Подписка {0} на {1}": "{1} мерзімге {0}",
  "Как удобнее оплатить": "Қалай төлеген ыңғайлы",
  "Подарок друга": "Дос сыйлығы",
  "{0} на первый пакет {1} после подписки": "Жазылғаннан кейін {1} бойы алғашқы пакетке {0}",
  "Не загрузилось": "Жүктелмеді",
  "Прошлую операцию не проверить": "Алдыңғы операцияны тексеру мүмкін емес",
  "разрешите хранение данных и откройте раздел снова": "деректерді сақтауға рұқсат беріп, бөлімді қайта ашыңыз",
  "Оплата требует проверки": "Төлемді тексеру керек",
  "Исход подтверждения оплаты ещё неизвестен": "Төлемді растау нәтижесі әлі белгісіз",
  "Исход отмены счёта неизвестен": "Шотты болдырмау нәтижесі белгісіз",
  "Ждём подтверждения оплаты": "Төлемнің расталуын күтудеміз",
  "Исход прошлой операции неизвестен": "Алдыңғы операция нәтижесі белгісіз",
  "проверьте его перед новой покупкой": "жаңа сатып алу алдында тексеріңіз",
  "Проверить": "Тексеру",
  "Открыть оплату": "Төлемді ашу",
  "Отменить счёт": "Шотты болдырмау",
  "Продление отменено": "Жаңарту тоқтатылды",
  "Сообщение со старым счётом может прийти. Оно не подтверждает новую подписку": "Ескі шоты бар хабар келуі мүмкін. Ол жаңа жазылымды растамайды",
  "Продление требует проверки": "Жаңартуды тексеру керек",
  "Счёт не подтверждён. Обновите данные или обратитесь в поддержку": "Шот расталмады. Деректерді жаңартыңыз немесе қолдауға жазыңыз",
  "Не удалось подготовить счёт": "Шот дайындалмады",
  "Сервер повторит проверку. Текущие права не меняются": "Сервер қайта тексереді. Ағымдағы құқықтар өзгермейді",
  "Счёт отправлен": "Шот жіберілді",
  "Бот прислал счёт. Подписка начнётся после подтверждённой оплаты": "Бот шот жіберді. Жазылым төлем расталған соң басталады",
  "Счёт подготовлен": "Шот дайындалды",
  "Передан боту. Доставка и оплата ещё не подтверждены": "Ботқа берілді. Жеткізу мен төлем әлі расталмады",
  "Срок счёта истёк": "Шоттың мерзімі өтті",
  "Продление не оплачено. Выберите тариф ещё раз": "Жаңарту төленбеді. Тарифті қайта таңдаңыз",
  "Запланированное продление отменено": "Жоспарланған жаңарту тоқтатылды",
  "Текущий тариф не меняется. Для новой подписки потребуется отдельная оплата": "Ағымдағы тариф өзгермейді. Жаңа жазылымға бөлек төлем керек",
  "Продление запланировано": "Жаңарту жоспарланды",
  "Счёт на свою подписку придёт в конце подарочного месяца": "Өз жазылымыңыздың шоты сыйлық айының соңында келеді",
  "Подарок ещё действует": "Сыйлық әлі жарамды",
  "Месячная подписка будет доступна после его окончания. Сейчас можно продлить на 3 или 12 месяцев": "Айлық жазылым ол біткен соң қолжетімді болады. Қазір 3 не 12 айға ұзартуға болады",
  "выберите другой тариф или срок": "басқа тариф не мерзім таңдаңыз",
  "−{0}% на первый пакет · ещё {1}": "Алғашқы пакетке −{0}% · тағы {1}",
  "Circle из пакетов не сгорают": "Пакеттердегі Circle күймейді",
  "Подарить другу": "Досқа сыйлау",
  "С открыткой, без продления": "Ашықхатпен, жаңартусыз",
  "Промокод {0}": "Промокод {0}",
  "{0} C, сгорят {1}": "{0} C, {1} күйеді",
  "Промокод применён": "Промокод қолданылды",
  "{0} C и {1} на первый пакет": "{0} C және алғашқы пакетке {1}",
  "после подписки": "жазылғаннан кейін",
  "Вы пришли по ссылке партнёра": "Сіз серіктес сілтемесі арқылы келдіңіз",
  "привязка уже действует": "байланыс қазірдің өзінде жұмыс істейді",
  "Есть промокод?": "Промокод бар ма?",
  "Загружаем тарифы": "Тарифтерді жүктеудеміз",
  "Счёт придёт {0}": "Шот {0} келеді",
  "Счёт придёт в конце текущего срока": "Шот ағымдағы мерзімнің соңында келеді",
  "Новый тариф начнётся после оплаты. Сейчас ничего не списывается.": "Жаңа тариф төлемнен кейін басталады. Қазір ештеңе алынбайды.",
  "Оплата подтверждена": "Төлем расталды",
  "Оплаченный период уже закончился. Circle за прошедший период не начисляются.": "Төленген кезең аяқталды. Өткен кезеңге Circle есептелмейді.",
  "Баланс пополнен": "Теңгерім толтырылды",
  "Теперь на балансе {0} C. Circle из пакетов не сгорают": "Енді теңгерімде {0} C. Пакеттердегі Circle күймейді",
  "следующие {0} C придут {1}": "келесі {0} C {1} келеді",
  "До этой даты действует {0}": "Осы күнге дейін {0} жарамды",
  "{0} продлён до {1}": "{0} {1} дейін ұзартылды",
  "Circle приходят каждый месяц, {0}": "Circle ай сайын келеді, {0}",
  "Тариф {0} подключён": "{0} тарифі қосылды",
  "Подписка {0} оформлена": "{0} жазылымы рәсімделді",
  "Оплачено до {0}. Circle приходят каждый месяц, {1}": "{0} дейін төленген. Circle ай сайын келеді, {1}",
  "Тестовая подписка действует до {0}. Звёзды и деньги не списываются": "Сынақ жазылымы {0} дейін жарамды. Жұлдыз да, ақша да алынбайды",
  "Circle действуют до {0}, тогда же следующее списание {1}": "Circle {0} дейін жарамды, келесі есептен шығару сол күні: {1}",
  "Circle действуют до {0}, продление выключено": "Circle {0} дейін жарамды, жаңарту өшірулі",
  "В месяц": "Айына",
  "Кружки или фото": "Дөңгелек не фото",
  "Видео говорит": "Бейне сөйлейді",
  "Рилсы": "Рилстер",
  "Сравнение тарифов": "Тарифтерді салыстыру",
  "В любом тарифе {0} {1} вместо {2}, все инструменты студии и пакеты Circle": "Кез келген тарифте: {2} орнына {0} {1}, студияның барлық құралы және Circle пакеттері",
  "Следующее списание": "Келесі есептен шығару",
  "Сумма": "Сома",
  "Тестовая, без списаний": "Сынақ, есептен шығарусыз",
  "Картой": "Картамен",
  "Оплачено до": "Төленген мерзім",
  "Действует до": "Жарамдылық мерзімі",
  "Потом": "Кейін",
  "Продление": "Жаңарту",
  "Счёт на {0} запланирован": "{0} шоты жоспарланды",
  "подписку": "жазылым",
  "Придёт {0}. Новый тариф начнётся после оплаты": "{0} келеді. Жаңа тариф төлемнен кейін басталады",
  "Отменить": "Болдырмау",
  "Отменить подписку": "Жазылымды тоқтату",
  "Тариф останется до {0}": "Тариф {0} дейін қалады",
  "Потом тариф {0}": "Кейін {0} тарифі",
  "Подарок на месяц": "Бір айлық сыйлық",
  "Оплачено вперёд": "Алдын ала төленген",
  "Подписка {0}": "{0} жазылымы",
  "Условия тарифа уточняются": "Тариф шарттары нақтылануда",
  "Сменить тариф": "Тарифті өзгерту",
  "Отмена подписки": "Жазылымды тоқтату",
  "Этот переход сейчас недоступен": "Бұл өту қазір қолжетімсіз",
  "Переход уже назначен": "Өту бұрыннан жоспарланған",
  "Выберите другой тариф": "Басқа тариф таңдаңыз",
  "С {0} начнётся этот тариф": "Бұл тариф {0} басталады",
  "Это ваш тариф": "Бұл сіздің тариф",
  "К подписке": "Жазылымға оралу",
  "Сейчас {0}, {1}": "Қазір {0}, {1}",
  "Латиница, цифры и «_»": "Латын әріптері, цифрлар және «_»",
  "Ник начинается с буквы": "Ник әріптен басталады",
  "Не короче 5 знаков": "Кемінде 5 таңба",
  "Не длиннее 32 знаков": "32 таңбадан аспайды",
  "Ник не кончается на _": "Ник _ таңбасымен аяқталмайды",
  "Это ваш ник": "Бұл сіздің ник",
  "Сначала проверьте прежнюю операцию": "Алдымен алдыңғы операцияны тексеріңіз",
  "Подарок сейчас недоступен": "Сыйлық қазір қолжетімсіз",
  "Укажите ник друга в Telegram": "Достың Telegram-дағы никін енгізіңіз",
  "Проверьте ник": "Никті тексеріңіз",
  "Друг увидит: {0}": "Досыңыз көреді: {0}",
  "Подарок придёт без имени": "Сыйлық атсыз келеді",
  "{0} дарит вам": "{0} сізге сыйлайды:",
  "вам подарили": "сізге сыйланды:",
  "Вам подарили": "Сізге сыйланды:",
  "{0} подписку STEOS {1} на месяц.": "{0} бір айлық STEOS {1} жазылымы.",
  "Забрать подарок": "Сыйлықты алу",
  "От друга": "Достан",
  "{0} C и {1} {2}": "{0} C және {1} {2}",
  "Подарить {0}": "{0} сыйлау",
  "Тестовый подарок: звёзды и деньги не списываются": "Сынақ сыйлығы: жұлдыз да, ақша да алынбайды",
  "На месяц, без продления": "Бір айға, жаңартусыз",
  "Тариф подарка": "Сыйлық тарифі",
  "Кому": "Кімге",
  "ник друга в Telegram": "достың Telegram никі",
  "Ник друга в Telegram": "Достың Telegram никі",
  "Пожелание": "Тілек",
  "Пара тёплых слов, по желанию": "Бірнеше жылы сөз, қалауыңызша",
  "Подписать от меня": "Менің атымнан қол қою",
  "Так увидит друг": "Досыңыз осылай көреді",
  "Подарок оформлен для {0}": "{0} үшін сыйлық рәсімделді",
  "Подарок отправлен {0}": "Сыйлық {0} жіберілді",
  "Бот прислал открытку со ссылкой «Забрать подарок» в подписи.": "Бот жазбасында «Сыйлықты алу» сілтемесі бар ашықхат жіберді.",
  "Месяц {0} начнётся, когда друг заберёт подарок": "{0} айы досыңыз сыйлықты алғанда басталады",
  "Друг ещё не запускал STEOS? Перешлите открытку сами": "Досыңыз STEOS-ты әлі ашпады ма? Ашықхатты өзіңіз жіберіңіз",
  "Переслать": "Жіберу",
  "Загружаем подарок": "Сыйлықты жүктеудеміз",
  "Вам подарок": "Сізге сыйлық",
  "Подписка STEOS на месяц": "Бір айлық STEOS жазылымы",
  "Этот подарок предназначен {0}. Перешлите получателю открытку со ссылкой.": "Бұл сыйлық {0} үшін. Сілтемесі бар ашықхатты алушыға жіберіңіз.",
  "Подарок уже получен": "Сыйлық бұрын алынған",
  "Подарок добавлен": "Сыйлық қосылды",
  "Подписка {0} подключена": "{0} жазылымы қосылды",
  "Circle подарка сгорят {0}": "Сыйлық Circle-і {0} күйеді",
  "Месяц без продления, Circle действуют до {0}": "Бір ай, жаңартусыз, Circle {0} дейін жарамды",
  "У вас уже есть {0}: подарок добавит {1} C, они сгорят через месяц": "Сізде {0} бар: сыйлық {1} C қосады, олар бір айда күйеді",
  "Придут {0} C и {1} {2}. Подписка не продлится сама": "{0} C және {1} {2} келеді. Жазылым өздігінен жаңармайды",
  "За последние 7 дней": "Соңғы 7 күн",
  "Потрачено": "Жұмсалды",
  "Начислено": "Есептелді",
  "Пакеты пока недоступны": "Пакеттер әзірге қолжетімсіз",
  "Пакет": "Пакет",
  "Оплата пакетов пока не подключена": "Пакеттерге төлем әлі қосылмаған",
  "Введите промокод": "Промокодты енгізіңіз",
  "Применить": "Қолдану",
  "Промокод партнёра работает до первой покупки, промокод STEOS можно применить один раз": "Серіктес промокоды алғашқы сатып алуға дейін жарамды, STEOS промокодын бір рет қолдануға болады",
  "От партнёра или от STEOS": "Серіктестен не STEOS-тан",
  "Например, ANNA24": "Мысалы, ANNA24",
  "Не удалось загрузить операции": "Операциялар жүктелмеді",
  "Начисление": "Есептеу",
  "Списание": "Есептен шығару",
  "Загружаем операции": "Операцияларды жүктеудеміз",
  "Журнал STEOS ID": "STEOS ID журналы",
  "Операций пока нет": "Әзірге операциялар жоқ",
  "Применение не подтверждено. Проверьте прежний запрос": "Қолдану расталмады. Алдыңғы сұрауды тексеріңіз",
  "Отменить подписку?": "Жазылымды тоқтату керек пе?",
  "Тариф {0} останется до {1}, потом не продлится.": "{0} тарифі {1} дейін қалады, кейін жаңармайды.",
  "Оставить": "Қалдыру",
  "Не удалось подготовить открытку": "Ашықхат дайындалмады",
  "Откройте Mini App в Telegram, чтобы переслать открытку": "Ашықхатты жіберу үшін Mini App-ты Telegram-да ашыңыз",
  "Отправка отменена": "Жіберу тоқтатылды",
  "Ссылка на подарок скопирована": "Сыйлық сілтемесі көшірілді",
  "Не получилось. Попробуйте ещё раз": "Болмады. Қайталап көріңіз",
  "Счёт отменён": "Шот болдырылмады",
  "Оплата не завершена": "Төлем аяқталмады",
  "Подтверждение оплаты": "Төлемді растау",
  "Проверяем подтверждение оплаты": "Төлемнің расталуын тексеріп жатырмыз",
  "Проверяем отмену счёта": "Шоттың болдырылмауын тексеріп жатырмыз",
  "Telegram начал подтверждение счёта. Его исход ещё неизвестен. Не оплачивайте повторно: проверяйте этот счёт или обратитесь в поддержку.": "Telegram шотты растауды бастады. Нәтижесі әлі белгісіз. Қайта төлемеңіз: осы шотты тексеріңіз немесе қолдауға жазыңыз.",
  "Подарок будет оформлен после подтверждения сервера. Месяц подписки начнётся, когда друг заберёт подарок. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Сыйлық сервер растағаннан кейін рәсімделеді. Жазылым айы досыңыз сыйлықты алғанда басталады. Төлем терезесінен оралу төлем аяқталды дегенді білдірмейді.",
  "Circle поступят на баланс после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Circle сервер растағаннан кейін теңгерімге түседі. Төлем терезесінен оралу төлем аяқталды дегенді білдірмейді.",
  "Circle и подписка появятся после подтверждения сервера. Возврат из окна оплаты ещё не означает, что платёж завершён.": "Circle мен жазылым сервер растағаннан кейін пайда болады. Төлем терезесінен оралу төлем аяқталды дегенді білдірмейді.",
  "Не удалось открыть оплату. Проверьте прежний запрос": "Төлем ашылмады. Алдыңғы сұрауды тексеріңіз",
  "Откройте Mini App в Telegram, чтобы оплатить звёздами": "Жұлдызбен төлеу үшін Mini App-ты Telegram-да ашыңыз",
  "Оплата ещё не подтверждена сервером": "Сервер төлемді әлі растамады",
  "Открытка готова. Откройте Mini App в Telegram, чтобы переслать её": "Ашықхат дайын. Жіберу үшін Mini App-ты Telegram-да ашыңыз",
  "Отменить счёт?": "Шотты болдырмау керек пе?",
  "Отменится только этот неоплаченный счёт. Текущая подписка останется. Если оплата уже подтверждается, сервер не разрешит отмену.": "Тек осы төленбеген шот болдырылмайды. Ағымдағы жазылым қалады. Төлем расталып жатса, сервер болдырмауға рұқсат бермейді.",
  "Вернуться к оплате": "Төлемге оралу",
  "{0} на первый пакет после подписки": "Жазылғаннан кейін алғашқы пакетке {0}",
  "{0} на первый пакет, ещё {1}": "Алғашқы пакетке {0}, тағы {1}",
  "{0} на первый пакет": "Алғашқы пакетке {0}",
  "Промокод {0} применён": "{0} промокоды қолданылды",
  "Circle сгорят {0}": "Circle {0} күйеді",
  "Circle начислены": "Circle есептелді",
  "Привязка к партнёру подтверждена": "Серіктеспен байланыс расталды",
  "Скидка {0}. Бонусные Circle сгорят {1}": "Жеңілдік: {0}. Бонус Circle {1} күйеді",
  "Привязка к партнёру действует": "Серіктеспен байланыс жұмыс істейді",
  "{0} C и {1}": "{0} C және {1}",
  "Открытка передана боту для доставки.": "Ашықхат жеткізу үшін ботқа берілді.",
  "Бот готовит доставку открытки. Можно переслать её самостоятельно.": "Бот ашықхатты жеткізуге дайындалуда. Оны өзіңіз де жібере аласыз.",
  "Доставка открытки не подтверждена. Можно переслать её самостоятельно.": "Ашықхаттың жеткізілуі расталмады. Оны өзіңіз жібере аласыз.",
  "Сначала тратятся Circle со сроком: бонусные и по подписке, потом все остальные, а те, что можно вывести, в последнюю очередь.": "Алдымен мерзімі бар Circle жұмсалады: бонустық және жазылымдағы, кейін қалғаны, ал шығаруға болатыны ең соңында.",
  "Получатель не найден среди пользователей STEOS. Проверьте ник или попросите друга запустить бота.": "Алушы STEOS пайдаланушылары арасында табылмады. Никті тексеріңіз немесе досыңыздан ботты іске қосуды сұраңыз.",
  "Условия оплаты изменились. Обновите данные.": "Төлем шарттары өзгерді. Деректерді жаңартыңыз.",
  "Эту открытку может переслать только отправитель подарка.": "Бұл ашықхатты тек сыйлықты жіберуші жібере алады.",
  "Откройте чат с ботом и попробуйте ещё раз.": "Ботпен чатты ашып, қайталап көріңіз.",
  "Доставка получателю не подтверждена. Перешлите открытку самостоятельно.": "Алушыға жеткізу расталмады. Ашықхатты өзіңіз жіберіңіз.",
  "Предложение не найдено. Обновите данные.": "Ұсыныс табылмады. Деректерді жаңартыңыз.",
  "Такого промокода нет": "Мұндай промокод жоқ",
  "Срок действия промокода закончился": "Промокодтың мерзімі өтті",
  "Этот промокод пока не действует": "Бұл промокод әзірге жарамсыз",
  "Вы уже активировали этот промокод": "Сіз бұл промокодты бұрын қолдандыңыз",
  "Промокод больше не действует": "Промокод енді жарамсыз",
  "Это ваш промокод": "Бұл сіздің промокод",
  "Партнёрские промокоды работают только до первой покупки": "Серіктес промокодтары тек алғашқы сатып алуға дейін жарамды",
  "Промокод партнёра временно недоступен": "Серіктес промокоды уақытша қолжетімсіз",
  "Вы уже привязаны к партнёру": "Сіз серіктеске бұрыннан байланғансыз",
  "Получатель изменился. Отмените прежний неоплаченный счёт и проверьте ник перед новой покупкой.": "Алушы өзгерді. Алдыңғы төленбеген шотты болдырмай, жаңа сатып алу алдында никті тексеріңіз.",
  "Пожелание должно быть не длиннее 200 знаков, без управляющих символов.": "Тілек 200 таңбадан аспауы және басқару таңбаларынсыз болуы керек.",
  "Проверьте ник: получатель должен запускать STEOS, нельзя дарить себе": "Никті тексеріңіз: алушы STEOS-ты іске қосқан болуы керек, өзіңізге сыйлауға болмайды",
  "Получатель сейчас занят. Повторите позже": "Алушы қазір бос емес. Кейінірек қайталаңыз",
  "Подарок не найден": "Сыйлық табылмады",
  "Этот подарок предназначен другому пользователю": "Бұл сыйлық басқа пайдаланушыға арналған",
  "Не удалось подтвердить условия продления. Обновите тарифы.": "Жаңарту шарттары расталмады. Тарифтерді жаңартыңыз.",
  "Подписка изменилась. Обновите данные перед новым продлением.": "Жазылым өзгерді. Жаңа жаңарту алдында деректерді жаңартыңыз.",
  "Продление уже запланировано. Его можно отменить в управлении подпиской.": "Жаңарту бұрыннан жоспарланған. Оны жазылымды басқаруда тоқтатуға болады.",
  "Запланированное продление отменено. Обновите данные.": "Жоспарланған жаңарту тоқтатылды. Деректерді жаңартыңыз.",
  "Счёт будет доступен в конце текущего срока.": "Шот ағымдағы мерзімнің соңында қолжетімді болады.",
  "Месячная подписка будет доступна после окончания подарка. Сейчас можно продлить на 3 или 12 месяцев.": "Айлық жазылым сыйлық біткен соң қолжетімді болады. Қазір 3 не 12 айға ұзартуға болады.",
  "Предыдущее изменение подписки ещё проверяется. Повторите его проверку.": "Жазылымның алдыңғы өзгерісі әлі тексерілуде. Қайта тексеріңіз.",
  "Изменение подписки ещё не подтверждено Telegram.": "Жазылым өзгерісін Telegram әлі растамады.",
  "Подписка изменилась. Обновите данные и повторите проверку.": "Жазылым өзгерді. Деректерді жаңартып, қайта тексеріңіз.",
  "Скидка уже закреплена за предыдущим счётом. Проверьте его оплату.": "Жеңілдік алдыңғы шотқа бекітілген. Оның төлемін тексеріңіз.",
  "Счёт уже подтверждается или недоступен для отмены. Проверьте результат оплаты.": "Шот расталып жатыр немесе болдырмауға болмайды. Төлем нәтижесін тексеріңіз.",
  "Оплата требует проверки. Сервер сохранил платёж; права пока не подтверждены. Не оплачивайте повторно — проверьте результат позже или обратитесь в поддержку.": "Төлемді тексеру керек. Сервер төлемді сақтады, бірақ құқықтар әлі расталмады. Қайта төлемеңіз — кейін тексеріңіз немесе қолдауға жазыңыз.",
  "Счёт отменён. Подписка и Circle по нему не начислены. Можно выбрать новую оплату.": "Шот болдырылмады. Ол бойынша жазылым мен Circle есептелмеді. Жаңа төлем таңдауға болады.",
  "Оплата не завершена. Деньги и Circle не подтверждены; можно начать новую оплату.": "Төлем аяқталмады. Ақша мен Circle расталмады; жаңа төлем бастауға болады.",
  "Открытка готовится. Нажмите «Проверить», чтобы получить результат прежнего запроса.": "Ашықхат дайындалуда. Алдыңғы сұрау нәтижесін алу үшін «Тексеру» түймесін басыңыз.",
  "Подарить подписку": "Жазылым сыйлау",
  "Оплата подписки": "Жазылым төлемі",
  "Итог оплаты": "Төлем нәтижесі",
  "Подарок": "Сыйлық",
  "Пакет Circle": "Circle пакеті",
  "лента: Хит": "Хит",
  "настройки: Очистить историю": "Тарихты тазарту",
  "Разделы, которых нет в меню": "Мәзірде жоқ бөлімдер",
  "Базовый": "Негізгі",
  "Продвинутый": "Озық",
  "Амбассадор": "Амбассадор",
  "задание ждёт|задания ждут|заданий ждут": "тапсырма күтуде",
  ", до +{0} C": ", +{0} C дейін",
  "Серия {0}, задания на сегодня": "{0} серия, бүгінгі тапсырмалар",
  "Задания на каждый день": "Күнделікті тапсырмалар",
  "Всё созданное в одном месте": "Жасағанның бәрі бір жерде",
  "Пока пусто: всё созданное будет здесь": "Әзірге бос: жасағаныңыз осында болады",
  "{0}, последняя {1}": "{0}, соңғысы {1}",
  "тариф {0}": "{0} тарифі",
  "без подписки": "жазылымсыз",
  "{0}, {1}% с покупок": "{0}, сатып алулардан {1}%",
  "{0} уровень, {1}% с покупок": "{0} деңгей, сатып алулардан {1}%",
  "До {0}% с покупок друзей": "Достардың сатып алуларынан {0}% дейін",
  "ИИ-агент ответит сразу": "ЖИ-агент бірден жауап береді",
  "Черновики ролей и реплик": "Рөлдер мен репликалар жобалары",
  "Тема, язык и валюта": "Тақырып, тіл және валюта",
  "{0} ждут": "{0} күтуде",
  "Тут Telegram откроет выбор чата: бот добавится в группу и будет работать там": "Мұнда Telegram чат таңдауын ашады: бот топқа қосылып, сонда жұмыс істейді",
  "голос {0}": "дауыс {0}",
  "Искать в {0} {1}": "{0} {1} ішінен іздеу",
  "работе|работах|работах": "жұмыс",
  "Не прошло модерацию": "Модерациядан өтпеді",
  "Бесплатно": "Тегін",
  "Цена недоступна": "Баға қолжетімсіз",
  "Не удалось загрузить историю": "Тарихты жүктеу мүмкін болмады",
  "Проверьте написание или поищите по номеру заказа": "Жазылуын тексеріңіз немесе тапсырыс нөмірі бойынша іздеңіз",
  "Проверьте написание или поищите по названию, голосу или персонажу": "Жазылуын тексеріңіз немесе атауы, дауысы не кейіпкері бойынша іздеңіз",
  "Сбросить поиск": "Іздеуді тазарту",
  "В этой вкладке пока пусто": "Бұл қойындыда әзірге бос",
  "Отмечайте работы сердцем в карточке, чтобы быстро находить их здесь": "Мұнда тез табу үшін жұмыстарды карточкадағы жүрекшемен белгілеңіз",
  "Новые работы этого вида появятся здесь сами": "Осы түрдегі жаңа жұмыстар осында өздігінен шығады",
  "Показать все": "Барлығын көрсету",
  "Поиск по истории": "Тарихтан іздеу",
  "Что показать": "Нені көрсету",
  "Кружки, фото, видео, озвучки и тексты, которые вы создадите": "Сіз жасайтын дөңгелек видеолар, фото, видео, дыбыстаулар мен мәтіндер",
  "Открыть студию": "Студияны ашу",
  "{0}: шаг {1} из {2}. Открыть": "{0}: {1}/{2} қадам. Ашу",
  "Шаг {0} из {1}": "{1} қадамның {0}-қадамы",
  "{0}: {1}. Открыть": "{0}: {1}. Ашу",
  "Раскладка": "Орналасым",
  "Широкий": "Кең",
  "Инструмент": "Құрал",
  "голос|голоса|голосов": "дауыс",
  "Как в оригинале": "Түпнұсқадағыдай",
  "фото|фото|фото": "фото",
  "слайд|слайда|слайдов": "слайд",
  "снимок|снимка|снимков": "сурет",
  "кадр|кадра|кадров": "кадр",
  "Длительность записи": "Жазба ұзақтығы",
  "Цена": "Бағасы",
  "Списание не подтверждено": "Есептен шығару расталмады",
  "Кадры": "Кадрлар",
  "знак|знака|знаков": "таңба",
  "пункт|пункта|пунктов": "тармақ",
  "фраза|фразы|фраз": "тіркес",
  "человек|человека|человек": "адам",
  "Смотреть видео": "Бейнені көру",
  "символ|символа|символов": "таңба",
  "Дорожка": "Трек",
  "фрагмент 1:00": "1:00 үзінді",
  "вся песня": "бүкіл ән",
  "образец|образца|образцов": "үлгі",
  "Свой голос": "Өз дауысыңыз",
  "{0} C списаны": "{0} C есептен шығарылды",
  "Работа ещё создаётся. Результат появится здесь и придёт в чат": "Жұмыс әлі жасалуда. Нәтиже осында шығады және чатқа келеді",
  "Проверяем результат. Обычно это занимает пару минут": "Нәтижені тексеріп жатырмыз. Әдетте бұл бірнеше минутқа созылады",
  "Не прошло модерацию. Политику и запрещённые темы не пропускаем, {0}": "Модерациядан өтпеді. Саясат пен тыйым салынған тақырыптарды өткізбейміз. {0}",
  "Не прошло модерацию. {0}": "Модерациядан өтпеді. {0}",
  "Не получилось. {0}": "Сәтсіз аяқталды. {0}",
  "Не получилось. {0} C вернулись на баланс": "Сәтсіз аяқталды. {0} C балансқа қайтарылды",
  "Удалится только запись о заказе": "Тек тапсырыс жазбасы ғана жойылады",
  "Удаление из истории": "Тарихтан жою",
  "Смотреть: {0}": "Көру: {0}",
  "В этой работе нет файлов для просмотра": "Бұл жұмыста қарауға арналған файл жоқ",
  "Вернуть запись в историю не получится.": "Жазбаны тарихқа қайтару мүмкін болмайды.",
  "Файл в чате останется. Вернуть работу в историю не получится.": "Файл чатта қалады. Жұмысты тарихқа қайтару мүмкін болмайды.",
  "Отправка пока не подтвердилась. Нажмите ещё раз": "Жіберу әлі расталмады. Қайта басыңыз",
  "Принято": "Қабылданды",
  "Бот пришлёт результат в чат": "Бот нәтижені чатқа жібереді",
  "Возврат обрабатывается": "Қайтару өңделуде",
  "Не списано": "Есептен шығарылмады",
  "Circle не списаны": "Circle есептен шығарылмады",
  "Circle вернулись на баланс": "Circle балансқа қайтарылды",
  "Списание пока не подтверждено": "Есептен шығару әлі расталмады",
  "Возврат не подтверждён": "Қайтару расталмады",
  "Ожидаем подтверждения оплаты": "Төлем расталуы күтілуде",
  "история: Повторить": "Қайталау",
  "история: Кружки": "Бейнехабарлар",
  "Фотосессия из селфи": "Селфиден фотосессия",
  "Рилс с вами": "Сізбен рилс",
  "Фото говорит": "Фото сөйлейді",
  "Слайды с преимуществами": "Артықшылықтар слайдтары",
  "Карусель для поста": "Постқа арналған карусель",
  "Коллаж из фото": "Фото коллажы",
  "Карточка для маркетплейса": "Маркетплейсқа арналған карточка",
  "шаг|шага|шагов": "қадам",
  "вопрос|вопроса|вопросов": "сұрақ",
  "Открыть": "Ашу",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку: {0}.": "Бұл сұрақтың жауабы расталмады. Маңызды болса, қолдау қызметіне жазыңыз: {0}.",
  "Ответ на этот вопрос не подтвердился. Если он важен, напишите в поддержку.": "Бұл сұрақтың жауабы расталмады. Маңызды болса, қолдау қызметіне жазыңыз.",
  "Ответ ещё не пришёл. Проверим этот же вопрос, второй раз он не задастся.": "Жауап әлі келмеді. Осы сұрақты қайта тексереміз, ол екінші рет жіберілмейді.",
  "Открыть профиль": "Профильді ашу",
  "Войти через STEOS ID": "STEOS ID арқылы кіру",
  "Тут Telegram откроет выбор чата": "Мұнда Telegram чат таңдауын ашады",
  "Разделы поддержки": "Қолдау бөлімдері",
  "Ответит сразу": "Бірден жауап береді",
  "Отвечает сразу": "Бірден жауап береді",
  "Поддержка в Telegram, {0}": "Telegram-дағы қолдау қызметі, {0}",
  "Поддержка в Telegram": "Telegram-дағы қолдау қызметі",
  "Видео медленнее обычного": "Бейне әдеттегіден баяу",
  "Видео работает медленнее обычного": "Бейне әдеттегіден баяу жұмыс істеуде",
  "Спросить ИИ‑агента поддержки": "Қолдау қызметінің AI‑агентінен сұрау",
  "Отвечает сразу и знает всё о STEOS": "Бірден жауап береді, STEOS туралы бәрін біледі",
  "Поиск по вопросам и инструкциям": "Сұрақтар мен нұсқаулықтардан іздеу",
  "Шесть коротких сторис о главном": "Негізгісі туралы алты қысқа сторис",
  "Попробуйте другие слова или спросите ИИ-агента": "Басқа сөздерді қолданып көріңіз немесе AI-агенттен сұраңыз",
  "Проверено в {0}": "Тексерілді: {0}",
  "Заказы не теряются: результат придёт в чат, а если что-то сорвётся, Circle вернутся на баланс.": "Тапсырыстар жоғалмайды: нәтиже чатқа келеді, ал бірдеңе сәтсіз болса, Circle балансқа қайтады.",
  "Сервисы": "Қызметтер",
  "Загружаем статус сервисов": "Қызметтер күйі жүктелуде",
  "Загружаем справку": "Анықтама жүктелуде",
  "Статус не загрузился": "Күйі жүктелмеді",
  "Статус сервисов пока не отслеживается": "Қызметтер күйі әзірге бақыланбайды",
  "Если что-то не работает, напишите в поддержку": "Бірдеңе жұмыс істемесе, қолдау қызметіне жазыңыз",
  "Часть сервисов работает с перебоями": "Кейбір қызметтер іркіліспен жұмыс істеуде",
  "Статусы ваших работ и подтверждённые возвраты смотрите в «Истории».": "Жұмыстарыңыздың күйі мен расталған қайтарымдарды «Тарих» бөлімінен қараңыз.",
  "Справка не загрузилась": "Анықтама жүктелмеді",
  "Справка пока не опубликована": "Анықтама әлі жарияланбаған",
  "Вопрос можно задать поддержке в Telegram": "Сұрақты Telegram-дағы қолдау қызметіне қоюға болады",
  "Инструкции появятся после публикации справки": "Нұсқаулықтар анықтама жарияланғаннан кейін пайда болады",
  "Назад к ИИ-агенту": "AI-агентке оралу",
  "Инструкция · {0}": "Нұсқаулық · {0}",
  "Вопрос · {0}": "Сұрақ · {0}",
  "Справка": "Анықтама",
  "Вопрос из Справки": "Анықтамадағы сұрақ",
  "Подробнее из Справки": "Анықтамада толығырақ",
  "Назад по таблице": "Кестені артқа жылжыту",
  "Вперёд по таблице": "Кестені алға жылжыту",
  "Здравствуйте, {0}.": "Сәлеметсіз бе, {0}.",
  "Здравствуйте.": "Сәлеметсіз бе.",
  "Я ИИ-агент поддержки STEOS: подскажу про тарифы и Circle, инструменты и шаблоны, промокоды, STEOS ID и партнёрство. Спросите своими словами или выберите вопрос.": "Мен STEOS қолдау қызметінің AI-агентімін: тарифтер мен Circle, құралдар мен үлгілер, промокодтар, STEOS ID және серіктестік туралы айтып беремін. Өз сөзіңізбен сұраңыз немесе сұрақ таңдаңыз.",
  "ИИ-агент печатает": "AI-агент жазып жатыр",
  "ИИ-агент ещё отвечает": "AI-агент әлі жауап беріп жатыр",
  "Напишите вопрос": "Сұрақ жазыңыз",
  "Диалог с ИИ-агентом": "AI-агентпен диалог",
  "Распознаём…": "Танылуда…",
  "Слушаю": "Тыңдап тұрмын",
  "Спросите о STEOS": "STEOS туралы сұраңыз",
  "Вопрос ИИ-агенту": "AI-агентке сұрақ",
  "Остановить диктовку": "Диктовканы тоқтату",
  "Сказать голосом": "Дауыспен айту",
  "Отправить": "Жіберу",
  "Не удалось начать новый чат": "Жаңа чат бастау мүмкін болмады",
  "Спасибо, учтём": "Рақмет, ескереміз",
  "Спасибо, передадим команде": "Рақмет, командаға жеткіземіз",
  "Оценка не сохранилась": "Баға сақталмады",
  "Чат ещё загружается": "Чат әлі жүктелуде",
  "В чате уже {0} вопросов. Начните новый": "Чатта {0} сұрақ бар. Жаңасын бастаңыз",
  "Вопрос не сохранился. Попробуйте ещё раз": "Сұрақ сақталмады. Қайталап көріңіз",
  "Некоторые сервисы работают медленнее обычного": "Кейбір қызметтер әдеттегіден баяу жұмыс істеуде",
  "{0} не работают": "{0} жұмыс істемейді",
  "{0} не работает": "{0} жұмыс істемейді",
  "{0} медленнее обычного": "{0} әдеттегіден баяу",
  "{0} работают медленнее обычного": "{0} әдеттегіден баяу жұмыс істеуде",
  "{0} работает медленнее обычного": "{0} әдеттегіден баяу жұмыс істеуде",
  "Микрофон здесь недоступен": "Микрофон мұнда қолжетімсіз",
  "Нет доступа к микрофону": "Микрофонға рұқсат жоқ",
  "Нужна запись от 1 до 30 секунд": "1–30 секундтық жазба қажет",
  "Не удалось разобрать запись": "Жазбаны тану мүмкін болмады",
  "Диктовка не распозналась. Нажмите микрофон, чтобы проверить ещё раз": "Диктовка танылмады. Қайта тексеру үшін микрофонды басыңыз",
  "Вопрос не подошёл. Сформулируйте иначе": "Сұрақ сәйкес келмеді. Басқаша тұжырымдаңыз",
  "Ответ не подтвердился. Напишите в поддержку": "Жауап расталмады. Қолдау қызметіне жазыңыз",
  "Ответ не пришёл. Проверьте ещё раз": "Жауап келмеді. Қайта тексеріңіз",
  "Говорящий кружок, видео и фото говорят, повтори движения, свой аватар": "Сөйлейтін дөңгелек видео, Бейне сөйлейді, Фото сөйлейді, Қимылдарды қайталаңыз, жеке аватар",
  "Оживить фото, видео по описанию, рилсы и сцены": "Фотосуретті жандандыру, сипаттама бойынша бейне, рилстер мен сахналар",
  "Фото, фотосессии, товары, карусели": "Фото, фотосессиялар, тауарлар, карусельдер",
  "Голоса, клон, озвучка проектов, кавер": "Дауыстар, клон, жобаларды дыбыстау, кавер",
  "Звёзды Telegram и карты": "Telegram Stars және карталар",
  "Не работает": "Жұмыс істемейді",
  "Как сделать по шагам": "Қадам бойынша",
  "Полезный ответ": "Пайдалы жауап",
  "Ответ не помог": "Жауап көмектеспеді",
  "Проверьте связь и попробуйте ещё раз": "Байланысты тексеріп, қайталап көріңіз",
  "Не удалось проверить владельца чата": "Чат иесін тексеру мүмкін болмады",
  "Не удалось восстановить чат. Начните новый": "Чатты қалпына келтіру мүмкін болмады. Жаңасын бастаңыз",
  "Клоны для озвучки": "Дыбыстауға арналған клондар",
  "Создайте первый голос": "Алғашқы дауысты жасаңыз",
  "Люди и питомцы для фото": "Фотоға арналған адамдар мен үй жануарлары",
  "Добавьте близких для фото": "Фотоға жақындарыңызды қосыңыз",
  "Сохранённые работы": "Сақталған жұмыстар",
  "Отмечайте работы сердцем": "Жұмыстарды жүрекшемен белгілеңіз",
  "Ежедневная серия и бонусы": "Күнделікті серия және бонустар",
  "Частые вопросы и связь с нами": "Жиі қойылатын сұрақтар және байланыс",
  "Обучается": "Үйретілуде",
  "Аккаунт недоступен": "Аккаунт қолжетімсіз",
  "Эта неделя · {0}": "Осы апта · {0}",
  "Неделя с {0} · {1}": "{0} басталған апта · {1}",
  "ID скопирован": "ID көшірілді",
  "Скопировать ID": "ID көшіру",
  "Баланс временно недоступен": "Баланс уақытша қолжетімсіз",
  "Разбивка остатка временно недоступна": "Қалдықтың бөлінісі уақытша қолжетімсіз",
  "Из них {0} C сгорит {1}|Из них {0} C сгорят {1}|Из них {0} C сгорят {1}": "Оның ішінде {0} C {1} күйеді",
  "Ближайшие {0} C сгорят {1}": "Ең жақын {0} C {1} күйеді",
  "Circle каждый месяц от {0}": "Ай сайын Circle, {0} бастап",
  "Circle каждый месяц с подпиской": "Жазылыммен ай сайын Circle",
  "Тариф временно недоступен": "Тариф уақытша қолжетімсіз",
  "Аккаунт, подписка и баланс": "Аккаунт, жазылым және баланс",
  "Статистика и моё": "Статистика және Менікі",
  "{0} к прошлой неделе": "өткен аптаға {0}",
  "Работы по неделям: на этой неделе {0}": "Апталар бойынша жұмыстар: осы аптада {0}",
  "Работы по неделям: на этой неделе {0}, на прошлой {1}": "Апталар бойынша жұмыстар: осы аптада {0}, өткен аптада {1}",
  "Статистика пока недоступна": "Статистика әзірге қолжетімсіз",
  "Дата регистрации недоступна": "Тіркелу күні қолжетімсіз",
  "С {0}": "{0} бастап",
  "Создано": "Жасалды",
  "Серия": "Серия",
  "день подряд|дня подряд|дней подряд": "күн қатарынан",
  "Общий аккаунт STEOS": "Ортақ STEOS аккаунты",
  "Для вывода Circle": "Circle шығару үшін",
  "До {0}% с их покупок": "Олардың сатып алуларынан {0}%-ға дейін",
  "Обновлено {0}": "Жаңартылды: {0}",
  "Действия": "Әрекеттер",
  "Сохранить имя": "Атауды сақтау",
  "Новое имя": "Жаңа атау",
  "Больше голосов с подпиской": "Жазылыммен көбірек дауыс",
  "Создание голосов пока недоступно": "Дауыс жасау әзірге қолжетімсіз",
  "Свободных мест нет": "Бос орын жоқ",
  "с подпиской до {0}": "жазылыммен {0} дейін",
  "Пауза «{0}»": "«{0}» кідірту",
  "Прослушать «{0}»": "«{0}» тыңдау",
  "Переименовать": "Атын өзгерту",
  "Запишите от 2 секунд речи или загрузите файлы, и голос будет звучать как вы": "2 секундтық сөз жазыңыз не файл жүктеңіз, сонда дауыс сіз сияқты естіледі",
  "Свободных мест нет. Удалите голос, чтобы записать новый": "Бос орын жоқ. Жаңасын жазу үшін бір дауысты жойыңыз",
  "Выбрать за «Вы»": "«Сіз» ретінде таңдау",
  "голос по умолчанию": "әдепкі дауыс",
  "Сделать кружок с вариантом «{0}»": "«{0}» нұсқасымен дөңгелек видео жасау",
  "Выбраны": "Таңдалды",
  "{0} фото|{0} фото|{0} фото": "{0} фото",
  "{0} фото · для всех инструментов|{0} фото · для всех инструментов|{0} фото · для всех инструментов": "{0} фото · барлық құралға",
  "{0} вариант · кружки, фото и видео|{0} варианта · кружки, фото и видео|{0} вариантов · кружки, фото и видео": "{0} нұсқа · дөңгелек видео, фото, видео",
  "{0} вариант|{0} варианта|{0} вариантов": "{0} нұсқа",
  "Голос {0} удалён, у варианта {1} теперь голос по умолчанию.": "{0} дауысы жойылды, {1} нұсқасында енді әдепкі дауыс.",
  "Голоса удалены, у вариантов {0} теперь голос по умолчанию.": "Дауыстар жойылды, {0} нұсқаларында енді әдепкі дауыс.",
  "Другой голос можно выбрать у каждого кружка": "Әр дөңгелек видеоға басқа дауыс таңдауға болады",
  "Вариантов пока нет": "Әзірге нұсқа жоқ",
  "Загрузите свои фото, и вариант себя будет говорить вашим голосом в кружках, фото и видео": "Фотоларыңызды жүктеңіз, сонда нұсқаңыз дөңгелек видео, фото және видеода сіздің дауысыңызбен сөйлейді",
  "Вы: свои фото и варианты": "Сіз: фотоларыңыз бен нұсқаларыңыз",
  "добавьте фото": "фото қосыңыз",
  "Изменить «{0}»": "«{0}» өзгерту",
  "{0} близкий · для фото и видео|{0} близких · для фото и видео|{0} близких · для фото и видео": "{0} жақын · фото мен видеоға",
  "Люди и питомцы для фото и видео": "Фото мен видеоға арналған адамдар мен жануарлар",
  "Близких пока нет": "Әзірге жақындар жоқ",
  "Добавьте людей и питомцев с фото, и они появятся в кадре рядом с вами": "Адамдар мен жануарларды фотосымен қосыңыз, сонда олар кадрда қасыңызда пайда болады",
  "Открыть в «Истории»": "«Тарихта» ашу",
  "Вернуть в избранное": "Таңдаулыларға қайтару",
  "{0} работа с сердцем|{0} работы с сердцем|{0} работ с сердцем": "Жүрекшесі бар {0} жұмыс",
  "Отмеченные сердцем работы": "Жүрекшемен белгіленген жұмыстар",
  "Открыть «Историю»": "«Тарихты» ашу",
  "Не удалось загрузить избранное": "Таңдаулылар жүктелмеді",
  "Закройте лист и откройте его ещё раз": "Терезені жауып, қайта ашыңыз",
  "Отмечайте работы сердцем в «Истории», и они соберутся здесь": "«Тарихта» жұмыстарды жүрекшемен белгілеңіз, олар осында жиналады",
  "Не удалось обновить. Попробуйте позже": "Жаңарту мүмкін болмады. Кейінірек көріңіз",
  "Удалить голос «{0}»?": "«{0}» дауысын жою керек пе?",
  "Голос пропадёт из списка. Вернуть его не получится.": "Дауыс тізімнен жоғалады. Оны қайтару мүмкін болмайды.",
  "Удалить вариант «{0}»?": "«{0}» нұсқасын жою керек пе?",
  "За «Вы» снова встанут ваши фото.": "«Сіз» ретінде қайтадан фотоларыңыз тұрады.",
  "Готовые кружки и фото с ним останутся в «Истории». Вернуть вариант не получится.": "Онымен жасалған дөңгелек видео мен фото «Тарихта» қалады. Нұсқаны қайтару мүмкін болмайды.",
  "Не удалось удалить голос": "Дауысты жою мүмкін болмады",
  "Не удалось удалить вариант. Попробуйте ещё раз": "Нұсқаны жою мүмкін болмады. Қайталап көріңіз",
  "«{0}»": "«{0}»",
  "подписка: до {0}": "{0} дейін",
  "варианты «Вы»: Новый вариант": "Жаңа нұсқа",
  "в очереди": "кезекте",
  "идёт": "жүріп жатыр",
  "завершено": "аяқталды",
  "не удалось": "сәтсіз",
  "слово подтверждения: УДАЛИТЬ": "ЖОЮ",
  "Выгрузка: {0}": "Экспорт: {0}",
  "Удаление: {0}. STEOS ID и финансовые квитанции сохраняются.": "Жою: {0}. STEOS ID мен қаржылық түбіртектер сақталады.",
  "Введите {0}": "{0} деп жазыңыз",
  "Перенос ещё не подтверждён. Проверка продолжится, откройте лист позже": "Тасымалдау әлі расталмады. Тексеру жалғасады, терезені кейінірек ашыңыз",
  "Этот STEOS ID уже связан с другим Telegram": "Бұл STEOS ID басқа Telegram-мен байланыстырылған",
  "На обоих аккаунтах есть подписка. Для объединения напишите в поддержку": "Екі аккаунтта да жазылым бар. Біріктіру үшін қолдауға жазыңыз",
  "Слишком много попыток. Попробуйте позже": "Әрекет тым көп. Кейінірек көріңіз",
  "Подключение STEOS ID сейчас недоступно. Попробуйте позже": "STEOS ID қосу қазір қолжетімсіз. Кейінірек көріңіз",
  "Не удалось создать аккаунт. Попробуйте позже": "Аккаунт жасау мүмкін болмады. Кейінірек көріңіз",
  "Не удалось отправить письмо": "Хат жіберу мүмкін болмады",
  "Фото не подошло. Выберите другое": "Фото сәйкес келмеді. Басқасын таңдаңыз",
  "Загрузите фото заново": "Фотоны қайта жүктеңіз",
  "Данные изменились. Откройте заново": "Деректер өзгерді. Қайта ашыңыз",
  "подряд": "қатарынан",
  "Начните {0}": "{0} бастаңыз",
  "серию": "серияны",
  "Завтра +{0} C": "Ертең +{0} C",
  "Заходите каждый день: награда растёт, на седьмой день {0} C. Пропуск дня начинает серию заново.": "Күн сайын кіріңіз: сыйақы өседі, жетінші күні {0} C. Бір күн өткізіп алсаңыз, серия басынан басталады.",
  "Забрать {0} C": "{0} C алу",
  "Прогресс": "Үдеріс",
  "Заданий здесь пока нет": "Мұнда әзірге тапсырма жоқ",
  "Время обновления недоступно": "Жаңарту уақыты қолжетімсіз",
  "Новые через {0}": "Жаңалары {0} кейін",
  "Выполнено {0} из {1}": "{0}/{1} орындалды",
  "друг|друга|друзей": "дос",
  "{0} с вами": "{0} сізбен",
  "Прогресс друзей недоступен": "Достар үдерісі қолжетімсіз",
  "Пригласить": "Шақыру",
  "Засчитываются друзья, которые пришли по вашей ссылке или промокоду и создали первую работу": "Сілтемеңіз немесе промокодыңыз арқылы келіп, алғашқы жұмысын жасаған достар саналады",
  "Ещё {0} {1} до награды {2}": "{2} сыйақыға дейін тағы {0} {1}",
  "Все ступени пройдены": "Барлық сатылар өтілді",
  "Получено {0} из {1}": "{0}/{1} алынды",
  "Задания": "Тапсырмалар",
  "покупатель|покупателя|покупателей": "сатып алушы",
  "Партнёрская программа": "Серіктестік бағдарламасы",
  "Партнёрам": "Серіктестерге",
  "До {0}% {1}": "{1} {0}%-ға дейін",
  "с покупок друзей": "Достардың сатып алуынан",
  "Заработано {0} с покупок {1} {2}": "{1} {2} сатып алуынан {0} табылды",
  "друга|друзей|друзей": "достың",
  "Сами выбирайте: больше возможностей в STEOS или доход с рекомендаций.": "Өзіңіз таңдаңыз: STEOS-та көбірек мүмкіндік немесе ұсыныстан табыс.",
  "Ещё {0} до уровня {1}": "{1} деңгейіне дейін тағы {0}",
  "Максимальный уровень: вывод через STEOS ID": "Ең жоғары деңгей: STEOS ID арқылы шығару",
  "Статистика, материалы и вывод": "Статистика, материалдар және шығару",
  "Исход прежнего запроса награды нужно проверить. Новые начисления пока заблокированы": "Алдыңғы сыйақы сұрауының нәтижесін тексеру керек. Жаңа есептеулер әзірге бұғатталған",
  "Загружаем награды": "Марапаттар жүктелуде",
  "Награды не загрузились": "Марапаттар жүктелмеді",
  "Создайте 3 работы": "3 жұмыс жасаңыз",
  "Сделайте кружок": "Дөңгелек видео жасаңыз",
  "Персонаж или вы сами": "Кейіпкер не өзіңіз",
  "Озвучьте текст": "Мәтінді дыбыстаңыз",
  "Голосом героя или клона": "Кейіпкер не клон дауысымен",
  "Улучшите описание": "Сипаттаманы жақсартыңыз",
  "Бот допишет детали": "Бот егжей-тегжейін толықтырады",
  "Отправьте работу": "Жұмысты жіберіңіз",
  "Из «Истории» в любой чат": "«Тарихтан» кез келген чатқа",
  "Неделя кружков": "Дөңгелек видео аптасы",
  "Создайте 10 кружков за неделю": "Бір аптада 10 дөңгелек видео жасаңыз",
  "Исследователь": "Зерттеуші",
  "Попробуйте 5 разных инструментов студии": "Студияның 5 түрлі құралын байқап көріңіз",
  "Первый кружок": "Алғашқы дөңгелек видео",
  "Видеокружок для Telegram": "Telegram үшін дөңгелек видео",
  "Клон голоса": "Дауыс клоны",
  "Всего 2 секунды речи": "Небәрі 2 секунд сөйлеу",
  "Первое фото": "Алғашқы фото",
  "Портрет в любом стиле": "Кез келген стильдегі портрет",
  "Первый рилс с вами": "Сізбен алғашқы рилс",
  "Шаблон одной кнопкой": "Бір батырмамен шаблон",
  "Первый кавер": "Алғашқы кавер",
  "Песня другим голосом": "Басқа дауыспен ән",
  "Кружки и видео с вами": "Сізбен дөңгелек және қарапайым видео",
  "С вашей ссылкой": "Сілтемеңізбен",
  "Бот в чате": "Чаттағы бот",
  "Добавьте бота в группу": "Ботты топқа қосыңыз",
  "Вход в STEOS ID": "STEOS ID арқылы кіру",
  "Один аккаунт с сайтом": "Сайтпен ортақ бір аккаунт",
  "Первый друг": "Алғашқы дос",
  "3 друга": "3 дос",
  "10 друзей": "10 дос",
  "25 друзей": "25 дос",
  "Первый покупатель": "Алғашқы сатып алушы",
  "Первая оплата друга": "Достың алғашқы төлемі",
  "{0} мин": "{0} мин",
  "{0} ч": "{0} сағ",
  "Последний день": "Соңғы күн",
  "Ещё {0} {1}": "Тағы {0} {1}",
  "Это задание выполняется вне мини-приложения": "Бұл тапсырма Mini App-тан тыс орындалады",
  "Задание пока недоступно": "Тапсырма әзірге қолжетімсіз",
  "Прогресс временно недоступен": "Үдеріс уақытша қолжетімсіз",
  "Не удалось восстановить прежний запрос награды. Проверьте баланс и напишите в поддержку": "Алдыңғы сыйақы сұрауын қалпына келтіру мүмкін болмады. Балансты тексеріп, қолдау қызметіне жазыңыз",
  "Награды временно недоступны. Попробуйте обновить данные": "Марапаттар уақытша қолжетімсіз. Деректерді жаңартып көріңіз",
  "Награда подтверждена. Обновите данные: повторять начисление не нужно": "Сыйақы расталды. Деректерді жаңартыңыз: қайта алудың қажеті жоқ",
  "Задание ещё не выполнено. Обновите прогресс": "Тапсырма әлі орындалмады. Үдерісті жаңартыңыз",
  "Награда уже получена. Обновите данные": "Сыйақы алынып қойған. Деректерді жаңартыңыз",
  "Начисление не подтверждено. Проверьте прежний запрос: новая награда пока заблокирована": "Есептеу расталмады. Алдыңғы сұрауды тексеріңіз: жаңа сыйақы әзірге бұғатталған",
  "Сначала обновите данные наград": "Алдымен марапат деректерін жаңартыңыз",
  "Сначала проверьте прежний запрос награды": "Алдымен алдыңғы сыйақы сұрауын тексеріңіз",
  "Рассказчик": "Баяндаушы",
  "Встреча на тракте": "Жолдағы кездесу",
  "Геральт": "Геральт",
  "Цири": "Цири",
  "Дождь шёл третий день, и дорога к крепости почти исчезла под грязью.": "Жаңбыр үшінші күн жауып тұрды, бекініске апаратын жол балшық астында жоғалып кете жаздады.",
  "Ты опять ушла вперёд без меня. Я же просил ждать у моста.": "Сен тағы менсіз алға кетіп қалдың. Көпірдің жанында күт деп едім ғой.",
  "Я ждала. Целый час. Потом решила, что ты заблудился.": "Мен күттім. Тұтас бір сағат. Сосын сені адасып қалды деп ойладым.",
  "Ведьмаки не блуждают. Мы иногда выбираем длинную дорогу.": "Мыстандар адаспайды. Біз кейде ұзын жолды таңдаймыз.",
  "Тогда в следующий раз выбирай её быстрее. Я замёрзла.": "Онда келесі жолы оны тезірек таңда. Мен тоңып қалдым.",
  "Он молча снял плащ и накинул ей на плечи. Впереди уже виднелись огни крепости.": "Ол үнсіз плащын шешіп, қыздың иығына жапты. Алдан бекіністің оттары көрінді.",
  "Пойдём. Весемир наверняка уже поставил суп на огонь.": "Жүр. Весемир сорпаны отқа қойып қойған шығар.",
  "Опять ты?": "Тағы сен бе?",
  "Мне нужна помощь": "Маған көмек керек",
  "Вставьте сценарий или начните с нуля": "Сценарийді қойыңыз не нөлден бастаңыз",
  "Напишите хотя бы одну реплику": "Кемінде бір реплика жазыңыз",
  "Сократите реплику: до {0} знаков": "Репликаны қысқартыңыз: {0} таңбаға дейін",
  "Сократите проект: до {0} знаков": "Жобаны қысқартыңыз: {0} таңбаға дейін",
  "Озвучка проектов временно недоступна": "Жобаларды дыбыстау уақытша қолжетімсіз",
  "Выберите голос для каждой роли": "Әр рөлге дауыс таңдаңыз",
  "Озвучить · {0} C": "Дыбыстау · {0} C",
  "Без названия": "Атаусыз",
  "Роль": "Рөл",
  "вчера": "кеше",
  "Проекты": "Жобалар",
  "роль|роли|ролей": "рөл",
  "реплика|реплики|реплик": "реплика",
  "Нет реплик": "Реплика жоқ",
  "{0} знаков": "{0} таңба",
  "Строки «Имя: реплика» сами станут ролями и голосами": "«Аты: реплика» жолдары өздігінен рөл мен дауысқа айналады",
  "Начать с нуля": "Нөлден бастау",
  "Роли и реплики добавите сами": "Рөлдер мен репликаларды өзіңіз қосасыз",
  "Открыть пример": "Мысалды ашу",
  "Проекты сохраняются сами: вернуться к ним можно в любой момент": "Жобалар өздігінен сақталады: оларға кез келген уақытта орала аласыз",
  "Роль с именем персонажа сама получит его голос: Геральт, Цири, Йеннифэр": "Кейіпкер атымен аталған рөл оның дауысын өзі алады: Геральт, Цири, Йеннифэр",
  "Переименовать проект": "Жоба атауын өзгерту",
  "Загрузить свежую": "Жаңасын жүктеу",
  "{0}: голос {1}. Сменить голос": "{0}: дауыс {1}. Дауысты өзгерту",
  "Действия с ролью": "Рөл әрекеттері",
  "Озвучиваем": "Дыбысталуда",
  "Действия с репликой": "Реплика әрекеттері",
  "Реплика: {0}": "Реплика: {0}",
  "Реплик пока нет": "Әзірге реплика жоқ",
  "Нажмите «Реплика» внизу или вставьте готовый сценарий": "Төмендегі «Реплика» батырмасын басыңыз не дайын сценарийді қойыңыз",
  "Реплика": "Реплика",
  "за проект": "жоба үшін",
  "Цена — по числу знаков": "Баға таңба санына қарай",
  "Добавить реплику": "Реплика қосу",
  "проект|проекта|проектов": "жоба",
  "{0} {1} · сохраняются сами": "{0} {1} · өздігінен сақталады",
  "Пока ни одного": "Әзірге жоқ",
  "Новый проект": "Жаңа жоба",
  "Вставить сценарий или начать с нуля": "Сценарий қою не нөлден бастау",
  "Удаление проекта": "Жобаны жою",
  "Новая роль": "Жаңа рөл",
  "Это первая реплика": "Бұл бірінші реплика",
  "Это последняя реплика": "Бұл соңғы реплика",
  "Удалить роль": "Рөлді жою",
  "Вместе с её репликами": "Репликаларымен бірге",
  "В проекте нужна хотя бы одна роль": "Жобада кемінде бір рөл болуы керек",
  "Удалить роль «{0}»?": "«{0}» рөлін жою керек пе?",
  "Вместе с ней уйдут {0} {1}.": "Онымен бірге {0} {1} жойылады.",
  "Удалить проект?": "Жобаны жою керек пе?",
  "{0}. Роли и реплики удалятся, вернуть проект не получится.": "{0}. Рөлдер мен репликалар жойылады, жобаны қайтару мүмкін болмайды.",
  "Выбор голоса откроется в приложении": "Дауыс таңдау қолданбада ашылады",
  "Не удалось удалить проект: {0}": "Жобаны жою мүмкін болмады: {0}",
  "Не получилось открыть аудио": "Аудионы ашу мүмкін болмады",
  "Не получилось включить звук": "Дыбысты қосу мүмкін болмады",
  "Сначала напишите текст реплики": "Алдымен реплика мәтінін жазыңыз",
  "Аудио реплики пока недоступно": "Реплика аудиосы әзірге қолжетімсіз",
  "Готовим роли": "Рөлдерді дайындап жатырмыз",
  "Роли готовы": "Рөлдер дайын",
  "Озвучиваем реплики": "Репликаларды дыбыстап жатырмыз",
  "Реплики озвучены": "Репликалар дыбысталды",
  "Собираем дорожку": "Тректі құрастырып жатырмыз",
  "Дорожка собрана": "Трек құрастырылды",
  "дубль {0}": "{0}-дубль",
  "Время реплики пока недоступно": "Реплика уақыты әзірге қолжетімсіз",
  "Общий файл · {0}": "Ортақ файл · {0}",
  "Аудио пока недоступно": "Аудио әзірге қолжетімсіз",
  "Слушать дорожку": "Тректі тыңдау",
  "реплика {0} из {1}": "реплика {0}/{1}",
  "Проект не озвучен": "Жоба дыбысталмады",
  "Можно уйти с экрана: озвучка продолжится, дорожка появится здесь и в «Истории».": "Экраннан шыға беруге болады: дыбыстау жалғасады, трек осында және «Тарихта» пайда болады.",
  "Можно уйти с экрана: бот напишет, когда дорожка будет готова.": "Экраннан шыға беруге болады: трек дайын болғанда бот жазады.",
  "Отправьте общий файл в чат или скачайте его. Любую реплику можно переозвучить отдельно.": "Ортақ файлды чатқа жіберіңіз не жүктеп алыңыз. Кез келген репликаны бөлек қайта дыбыстауға болады.",
  "Бот уже прислал общий файл в чат, в отдельную тему. Любую реплику можно переозвучить отдельно.": "Бот ортақ файлды чаттағы бөлек тақырыпқа жіберіп қойды. Кез келген репликаны бөлек қайта дыбыстауға болады.",
  "Сценарий не прошёл проверку": "Сценарий тексеруден өтпеді",
  "проект не озвучен": "жоба дыбысталмады",
  "Не получилось собрать дорожку": "Тректі құрастыру мүмкін болмады",
  "К сценарию": "Сценарийге оралу",
  "Звук дорожки не загрузился: скачайте файл": "Трек дыбысы жүктелмеді: файлды жүктеп алыңыз",
  "Каждая реплика с новой строки: имя, двоеточие, текст. Строка без имени достаётся предыдущей роли": "Әр реплика жаңа жолдан: аты, қос нүкте, мәтін. Атсыз жол алдыңғы рөлге тиесілі",
  "голос персонажа": "кейіпкер дауысы",
  "Заменить сценарий": "Сценарийді ауыстыру",
  "Сейчас {0} {1}, они уйдут": "Қазір {0} {1}, олар жойылады",
  "реплику|реплики|реплик": "реплика",
  "Заменить на {0} {1}": "{0} {1} етіп ауыстыру",
  "Добавить {0} {1}": "{0} {1} қосу",
  "Заменить реплики": "Репликаларды ауыстыру",
  "Добавить реплики": "Реплика қосу",
  "Не нашли реплик: имя, двоеточие, текст": "Реплика табылмады: аты, қос нүкте, мәтін",
  "Вставьте сценарий в поле": "Сценарийді өріске қойыңыз",
  "Роли и голоса появятся сами": "Рөлдер мен дауыстар өздігінен шығады",
  "Геральт: Опять ты. Что на этот раз? Цири: Мне нужна твоя помощь.": "Геральт: Тағы сен бе. Бұл жолы не болды?\nЦири: Маған сенің көмегің керек.",
  "Сейчас нельзя": "Қазір болмайды",
  "Вставьте текст в поле": "Мәтінді өріске қойыңыз",
  "Загружаем проекты": "Жобалар жүктелуде",
  "Проекты не загрузились": "Жобалар жүктелмеді",
  "Не хватает Circle: пополните баланс": "Circle жеткіліксіз: балансты толтырыңыз",
  "Цена: {0} C. Нажмите ещё раз, чтобы озвучить": "Бағасы: {0} C. Дыбыстау үшін қайта басыңыз",
  "Не удалось посчитать цену. Попробуйте ещё раз": "Бағаны есептеу мүмкін болмады. Қайталап көріңіз",
  "Сценарий не прошёл проверку. Измените текст и попробуйте ещё раз.": "Сценарий тексеруден өтпеді. Мәтінді өзгертіп, қайталап көріңіз.",
  "Не получилось собрать дорожку. Если Circle списались, они вернутся на баланс.": "Тректі құрастыру мүмкін болмады. Circle есептен шықса, балансқа қайтарылады.",
  "Запуск не подтверждён": "Іске қосу расталмады",
  "Не получилось собрать дорожку.": "Тректі құрастыру мүмкін болмады.",
  "Повторная проверка не спишет Circle дважды.": "Қайта тексеру Circle-ды екі рет шығармайды.",
  "Отправили в чат": "Чатқа жіберілді",
  "Отправка принята: бот пришлёт дорожку в чат": "Жіберу қабылданды: бот тректі чатқа жібереді",
  "Прослушивание реплики пока недоступно": "Репликаны тыңдау әзірге қолжетімсіз",
  "Прослушать реплику: {0} C. Нажмите ещё раз": "Репликаны тыңдау: {0} C. Қайта басыңыз",
  "Переозвучка реплики пока недоступна": "Репликаны қайта дыбыстау әзірге қолжетімсіз",
  "Переозвучить реплику: {0} C. Нажмите ещё раз": "Репликаны қайта дыбыстау: {0} C. Қайта басыңыз",
  "Сохранение проектов сейчас недоступно. Обновите данные.": "Жобаларды сақтау қазір қолжетімсіз. Деректерді жаңартыңыз.",
  "Изменение проектов сейчас недоступно. Обновите данные.": "Жобаларды өзгерту қазір қолжетімсіз. Деректерді жаңартыңыз.",
  "Проект ещё сохраняется. Попробуйте через секунду.": "Жоба әлі сақталып жатыр. Бір секундтан соң көріңіз.",
  "Результат больше недоступен.": "Нәтиже енді қолжетімсіз.",
  "Не удалось проверить владельца проекта.": "Жоба иесін тексеру мүмкін болмады.",
  "Операция не найдена. Проверьте историю.": "Операция табылмады. Тарихты тексеріңіз.",
  "Проект ещё не сохранён.": "Жоба әлі сақталмады.",
  "Озвучка проектов сейчас недоступна. Обновите данные.": "Жобаларды дыбыстау қазір қолжетімсіз. Деректерді жаңартыңыз.",
  "Прослушивание реплики сейчас недоступно. Обновите данные.": "Репликаны тыңдау қазір қолжетімсіз. Деректерді жаңартыңыз.",
  "Переозвучка реплики сейчас недоступна. Обновите данные.": "Репликаны қайта дыбыстау қазір қолжетімсіз. Деректерді жаңартыңыз.",
  "Дорожка ещё не готова.": "Трек әлі дайын емес.",
  "Аккаунт сменился. Обновите страницу.": "Аккаунт ауысты. Бетті жаңартыңыз.",
  "Отправка пока не подтверждена. Нажмите ещё раз, чтобы проверить прежний запрос.": "Жіберу әлі расталмады. Алдыңғы сұрауды тексеру үшін қайта басыңыз.",
  "Результат проекта пока недоступен. Проверьте статус ещё раз.": "Жоба нәтижесі әзірге қолжетімсіз. Күйін қайта тексеріңіз.",
  "Не удалось открыть аудио проекта.": "Жоба аудиосын ашу мүмкін болмады.",
  "месяц|месяца|месяцев": "ай",
  "покупателя|покупателей|покупателей": "сатып алушы",
  "рабочий день|рабочих дня|рабочих дней": "жұмыс күні",
  "друг купит|друга купят|друзей купят": "дос",
  "покупателем|покупателями|покупателями": "сатып алушы",
  "Баннеры": "Баннерлер",
  "Постер": "Постер",
  "Голос героя": "Кейіпкердің дауысы",
  "Персонаж говорит": "Кейіпкер сөйлейді",
  "Было и стало": "Бұрын және қазір",
  "Подарок другу": "Досқа сыйлық",
  "Кружок, который говорит": "Сөйлейтін дөңгелек видео",
  "Персонаж читает ваш текст": "Кейіпкер мәтініңізді оқиды",
  "Рилс с вами одной кнопкой": "Бір батырмамен сізбен рилс",
  "Сюжет, монтаж и музыка в шаблоне": "Сюжет, монтаж және музыка үлгіде",
  "Герой говорит": "Кейіпкер сөйлейді",
  "Герой говорит вашим текстом": "Кейіпкер сіздің мәтініңізді айтады",
  "Голос и губы в такт": "Дауыс пен ерін үйлесімді",
  "Старое фото как новое": "Ескі фото жаңадай",
  "Цвет и резкость за минуту": "Бір минутта түс пен анықтық",
  "Кавер любым голосом": "Кез келген дауыспен кавер",
  "Рок, джаз или lo-fi": "Рок, джаз немесе lo-fi",
  "Фотосессия в любом образе": "Кез келген бейнеде фотосессия",
  "По паре своих фото": "Бірнеше фотоңыздан",
  "Друзьям": "Достарға",
  "Личное сообщение": "Жеке хабарлама",
  "Подписчикам": "Жазылушыларға",
  "Пост в канал": "Арнаға пост",
  "Семье": "Отбасыға",
  "Сообщение родным": "Туыстарға хабарлама",
  "Геймерам": "Геймерлерге",
  "Чат по интересам": "Қызығушылық чаты",
  "Для работы": "Жұмыс үшін",
  "Коллегам и в рабочий чат": "Әріптестерге және жұмыс чатына",
  "Авторам": "Авторларға",
  "Блогерам и создателям роликов": "Блогерлер мен видео авторларына",
  "Подарок по моему промокоду": "Менің промокодыммен сыйлық",
  "Кружки, фото и голос с ИИ прямо в Telegram": "Telegram-да ЖИ көмегімен дөңгелек видео, фото және дауыс",
  "Кружки с персонажами": "Кейіпкерлері бар дөңгелек видео",
  "Пишете текст, персонаж его говорит": "Мәтін жазасыз, кейіпкер айтады",
  "Озвучка любым голосом": "Кез келген дауыспен дыбыстау",
  "Из библиотеки или своим клоном": "Кітапханадан не өз клоныңызбен",
  "Фотосессия без студии": "Студиясыз фотосессия",
  "Пара своих фото, любой образ": "Бірнеше фото, кез келген бейне",
  "{0} с регистрации по вашей ссылке или с первой покупки по промокоду. Всё это время процент идёт со всех оплат друга. Промокод работает только до первой покупки друга, а если друг пришёл по ссылке, промокод привязку уже не меняет.": "Сілтемеңіз арқылы тіркелгеннен немесе промокодпен алғашқы сатып алудан бастап {0}. Осы уақыт бойы досыңыздың барлық төлемінен пайыз аласыз. Промокод тек досыңыздың алғашқы сатып алуына дейін жұмыс істейді, ал дос сілтеме арқылы келсе, промокод байланысты өзгертпейді.",
  "Что получает друг?": "Дос не алады?",
  "+{0} C сразу: они не выводятся и сгорают через {1}.": "+{0} C бірден: олар шығарылмайды, {1} ішінде жарамды.",
  "Скидка {0}% на первый пакет Circle действует {1} после оформления подписки, потому что пакеты Circle продаются только с подпиской. Подарок один на аккаунт: по ссылке или по промокоду.": "Алғашқы Circle пакетіне {0}% жеңілдік жазылымнан кейін {1} бойы жарамды, өйткені Circle пакеттері тек жазылыммен сатылады. Бір аккаунтқа бір сыйлық: сілтеме не промокод арқылы.",
  "Что считается оплатой?": "Төлем деп не саналады?",
  "Подписка и пакеты Circle, оплаченные звёздами или картой. Процент считается от суммы, которую друг заплатил, со скидкой. Бонусные монеты, награды за задания и возвраты не учитываются.": "Жұлдызбен не картамен төленген жазылым мен Circle пакеттері. Пайыз досыңыз жеңілдікпен төлеген сомадан есептеледі. Бонустық монеталар, тапсырма сыйақылары және қайтарымдар есептелмейді.",
  "Какие бывают промокоды?": "Қандай промокодтар бар?",
  "Ваш промокод партнёра даёт другу подарок и привязывает его к вам, работает только до его первой покупки. Промокоды STEOS публикует команда в канале и сообществе STEOS: они дают Circle со своим сроком и работают у всех, один раз на аккаунт.": "Серіктес промокодыңыз досқа сыйлық береді және оны сізге байлайды, тек оның алғашқы сатып алуына дейін жұмыс істейді. STEOS промокодтарын команда STEOS арнасы мен қауымдастығында жариялайды: олар өз мерзімі бар Circle береді және бәріне бір аккаунтқа бір рет жұмыс істейді.",
  "Когда приходят Circle?": "Circle қашан түседі?",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} их можно вывести.": "Досыңыз төлегеннен кейін бірден, тікелей теңгерімге. {0} деңгейінде оларды шығаруға болады.",
  "Сразу после оплаты друга, прямо на баланс. На уровнях {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Досыңыз төлегеннен кейін бірден, тікелей теңгерімге. {0} деңгейлерінде олар STEOS ішінде жұмсалады, {1} деңгейінде оларды шығаруға болады.",
  "Сразу после оплаты друга, прямо на баланс. На уровне {0} они работают внутри STEOS, на уровне {1} их можно вывести.": "Досыңыз төлегеннен кейін бірден, тікелей теңгерімге. {0} деңгейінде олар STEOS ішінде жұмсалады, {1} деңгейінде оларды шығаруға болады.",
  "Считаются ли друзья с истёкшей привязкой?": "Байланысы аяқталған достар есептеле ме?",
  "Да. Процент с их оплат больше не идёт, но в счёте уровня они остаются: уровень считается по всем покупателям за всё время.": "Иә. Олардың төлемдерінен пайыз енді түспейді, бірақ деңгей есебінде қалады: деңгей барлық уақыттағы сатып алушылар бойынша есептеледі.",
  "Кто может выводить?": "Кім шығара алады?",
  "Партнёры уровня {0} (от {1}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {2}.": "{0} деңгейіндегі серіктестер (кемінде {1}), ЖК, өзін-өзі жұмыспен қамтыған немесе шетелдік баламасы мәртебесімен, STEOS ID арқылы кіргеннен кейін. Шығару тек шотқа ақшамен: осында немесе {2} сайтында.",
  "Амбассадоры (от {0}) со статусом ИП, самозанятого или иностранного аналога, после входа через STEOS ID. Вывод только деньгами на счёт: здесь или на {1}.": "Амбассадорлар (кемінде {0}), ЖК, өзін-өзі жұмыспен қамтыған немесе шетелдік баламасы мәртебесімен, STEOS ID арқылы кіргеннен кейін. Шығару тек шотқа ақшамен: осында немесе {1} сайтында.",
  "Можно ли вывести монеты, заработанные до входа?": "Кірмей тұрып тапқан монеталарды шығаруға бола ма?",
  "Да. Монеты Circle, заработанные на уровне {0} до входа через STEOS ID, ждут на балансе и станут доступны для вывода после входа.": "Иә. {0} деңгейінде STEOS ID арқылы кірмей тұрып тапқан Circle теңгерімде күтеді және кіргеннен кейін шығаруға қолжетімді болады.",
  "Какие монеты тратятся первыми?": "Алдымен қай монеталар жұмсалады?",
  "Можно пригласить самого себя?": "Өзімді шақыра аламын ба?",
  "Нет. Покупки с вашего аккаунта и с повторных аккаунтов не учитываются.": "Жоқ. Өз аккаунтыңыздан және қайталама аккаунттардан жасалған сатып алулар есептелмейді.",
  "Международный": "Халықаралық",
  "Self-employed, sole trader или компания вне РФ": "Self-employed, sole trader немесе РФ-тан тыс компания",
  "Самозанятый в РФ": "РФ-тағы өзін-өзі жұмыспен қамтыған",
  "Налог на профессиональный доход": "Кәсіби табысқа салық",
  "ИП в РФ": "РФ-тағы ЖК",
  "Индивидуальный предприниматель": "Жеке кәсіпкер",
  "Имя или компания": "Аты не компания",
  "Как в документах": "Құжаттағыдай",
  "TIN или номер в вашей стране": "TIN немесе еліңіздегі нөмір",
  "ФИО": "Аты-жөні",
  "Как в паспорте": "Төлқұжаттағыдай",
  "ИНН": "ИНН",
  "12 цифр": "12 цифр",
  "Название ИП": "ЖК атауы",
  "Как в выписке": "Үзіндідегідей",
  "ИНН или ОГРНИП": "ИНН не ОГРНИП",
  "От 10 до 15 цифр": "10–15 цифр",
  "НДС": "ҚҚС",
  "Плательщик НДС": "ҚҚС төлеушісі",
  "Адрес": "Мекенжай",
  "КПП": "КПП",
  "ОГРН": "ОГРН",
  "Основной офис STEOS": "STEOS бас кеңсесі",
  "Платёжный агент STEOS в России": "STEOS-тың Ресейдегі төлем агенті",
  "Тут откроется выбор чата Telegram с этим текстом, ссылкой и промокодом": "Мұнда осы мәтін, сілтеме және промокодпен Telegram чатын таңдау ашылады",
  "Тут откроется выбор чата Telegram: баннер уйдёт с подписью и кнопкой «Открыть STEOS»": "Мұнда Telegram чатын таңдау ашылады: баннер жазуымен және «STEOS ашу» батырмасымен жіберіледі",
  "Ещё <b>{0} {1}</b> до уровня {2}": "{2} деңгейіне дейін тағы <b>{0} {1}</b>",
  "Максимальный уровень": "Ең жоғары деңгей",
  "До следующего уровня": "Келесі деңгейге дейін",
  "Получайте до&nbsp;{0}% <span>с&nbsp;покупок друзей</span>": "{0}%-ға&nbsp;дейін алыңыз <span>достардың сатып алуынан</span>",
  "Период": "Кезең",
  "Кого показать": "Кімді көрсету",
  "Перешли": "Өтті",
  "Зарегистрировались": "Тіркелді",
  "Купили": "Сатып алды",
  "Пока нет данных": "Әзірге дерек жоқ",
  "{0} к прошлому периоду": "өткен кезеңге {0}",
  "за {0} {1}": "{0} {1} ішінде",
  "Пока не считаем": "Әзірге есептемейміз",
  "нет начислений": "есептеу жоқ",
  "Пик <b>{0} C</b>": "Шың <b>{0} C</b>",
  "Начисления по месяцам": "Айлар бойынша есептеу",
  "Начисления по дням": "Күндер бойынша есептеу",
  "Здесь появятся начисления": "Есептеулер осында шығады",
  "Подписка Про": "Про жазылымы",
  "Купила Circle": "Circle сатып алды",
  "Купил Circle": "Circle сатып алды",
  "Покупатель": "Сатып алушы",
  "по промокоду": "промокодпен",
  "привязка истекла": "байланыс аяқталды",
  "Это весь список · {0}": "Бар тізім осы · {0}",
  "Друг привязан к вам {0}: с регистрации по ссылке или с первой покупки по промокоду. Промокод работает только до первой покупки друга.": "Дос сізге {0} бойы байланған: сілтеме арқылы тіркелгеннен немесе промокодпен алғашқы сатып алудан бастап. Промокод тек досыңыздың алғашқы сатып алуына дейін жұмыс істейді.",
  "Покупатели с истёкшей привязкой остаются в счёте уровня.": "Байланысы аяқталған сатып алушылар деңгей есебінде қалады.",
  "Пока никого": "Әзірге ешкім жоқ",
  "Поделитесь ссылкой или промокодом, первые друзья появятся здесь": "Сілтемемен не промокодпен бөлісіңіз, алғашқы достар осында шығады",
  "Картинка": "Сурет",
  "Ссылка и промокод уже на картинке. Нажмите на шаблон, чтобы поправить подпись и опубликовать.": "Сілтеме мен промокод суретте бар. Жазуды түзетіп, жариялау үшін үлгіні басыңыз.",
  "{0}, открыть и опубликовать": "{0}, ашу және жариялау",
  "Для Reels, Shorts, TikTok и VK Клипов. Промокод и ссылка уже в кадре, бот пришлёт ролик в чат.": "Reels, Shorts, TikTok және VK Клиптер үшін. Промокод пен сілтеме кадрда бар, бот роликті чатқа жібереді.",
  "{0}, открыть": "{0}, ашу",
  "Ссылка и промокод уже в тексте. Скопируйте его или отправьте в чат.": "Сілтеме мен промокод мәтінде бар. Көшіріңіз немесе чатқа жіберіңіз.",
  "Картинка уйдёт в чат с подписью и кнопкой «Открыть STEOS». Подойдёт для групп, каналов и личных сообщений.": "Сурет чатқа жазуымен және «STEOS ашу» батырмасымен кетеді. Топтар, арналар және жеке хабарламалар үшін жарайды.",
  "Баннер «{0}» с вашим промокодом": "Промокодыңыз бар «{0}» баннері",
  "QR-постер: код ведёт на вашу ссылку, промокод {0}": "QR-постер: код сілтемеңізге апарады, промокод {0}",
  "Кружки, фото и голос с ИИ": "ЖИ көмегімен дөңгелек видео, фото және дауыс",
  "+{0}&nbsp;C на старт по промокоду": "Промокодпен бастауға +{0}&nbsp;C",
  "Начните по ссылке или промокоду": "Сілтеме не промокод арқылы бастаңыз",
  "Наведите камеру телефона": "Телефон камерасын бағыттаңыз",
  "A4 для печати: стойки, витрины, визитки. Код ведёт на вашу ссылку, а промокод под ним можно ввести и без камеры.": "Басып шығаруға A4: тұғырлар, витриналар, визиткалар. Код сілтемеңізге апарады, ал астындағы промокодты камерасыз да енгізуге болады.",
  "Цвет постера": "Постер түсі",
  "Прислать PDF в чат": "PDF-ті чатқа жіберу",
  "Вывести": "Шығару",
  "Заявка на {0} C не подтверждена": "{0} C өтінімі расталмады",
  "Вывод сейчас недоступен": "Шығару қазір қолжетімсіз",
  "Вывод недоступен": "Қолжетімсіз",
  "Деньгами на ваш счёт за {0}": "{0} ішінде шотыңызға",
  "Вывод от {0} C": "Кемінде {0} C шығаруға болады",
  "Вывод заработает после входа через STEOS ID": "Шығару STEOS ID арқылы кіргеннен кейін іске қосылады",
  "Войдите через STEOS ID": "STEOS ID арқылы кіріңіз",
  "Вывод доступен на уровне {0}, от {1}": "Шығару {0} деңгейінде, кемінде {1}",
  "Нужен уровень {0}": "{0} деңгейі керек",
  "Вывод откроется на уровне {0}, от {1}. Пока Circle работают внутри STEOS": "Шығару {0} деңгейінде ашылады, кемінде {1}. Әзірге Circle STEOS ішінде жұмсалады",
  "Не подключён": "Қосылмаған",
  "Вход свяжет аккаунт бота с общим аккаунтом STEOS: баланс станет общим, а вывод заработает здесь и на сайте STEOS ID.": "Кіру бот аккаунтын ортақ STEOS аккаунтымен байланыстырады: теңгерім ортақ болады, ал шығару осында және STEOS ID сайтында жұмыс істейді.",
  "Выплачено": "Төленді",
  "В обработке": "Өңделуде",
  "Отклонено": "Қабылданбады",
  "Не удалось загрузить историю выводов": "Шығару тарихы жүктелмеді",
  "Выводов пока не было": "Әзірге шығару болмады",
  "за всё время": "барлық уақытта",
  "Можно вывести": "Шығаруға болады",
  "Тестовая программа: настоящих выплат нет": "Сынақ бағдарлама: нақты төлем жоқ",
  "Баланс и выводы есть и на {0}.": "Теңгерім мен шығару {0} сайтында да бар.",
  "Вопрос о выводе?": "Шығару туралы сұрақ бар ма?",
  "Напишите в поддержку": "Қолдау қызметіне жазыңыз",
  "Поделитесь ссылкой или промокодом": "Сілтемемен не промокодпен бөлісіңіз",
  "Друг привязывается к вам на {0}": "Дос сізге {0} бойы байланады",
  "Друг получает подарок": "Дос сыйлық алады",
  "+{0} C сразу и −{1}% на первый пакет Circle после подписки": "Бірден +{0} C және жазылымнан кейін алғашқы Circle пакетіне −{1}%",
  "Друг платит в STEOS": "Дос STEOS-та төлейді",
  "Подписка и пакеты Circle звёздами или картой": "Жазылым мен Circle пакеттері жұлдызбен не картамен",
  "Вам приходит процент": "Сізге пайыз түседі",
  "{0}% с каждой оплаты, сразу на баланс": "Әр төлемнен {0}%, бірден теңгерімге",
  "Шаг {0}": "{0}-қадам",
  "От {0}": "Кемінде {0}",
  "С первого дня": "Бірінші күннен",
  "Если {0} {1} {2}": "{0} {1} {2} сатып алса",
  "{0} C за {1}": "{1} ішінде {0} C",
  "Хватит на {0} в месяц": "Айына {0} жетеді",
  "Кружок стоит {0} C": "Дөңгелек видео {0} C тұрады",
  "Считаем по подписке {0}: {1} в месяц, это {2}&nbsp;C. Процент идёт с каждой оплаты друга {3} привязки.": "{0} жазылымы бойынша есептейміз: айына {1}, бұл {2}&nbsp;C. Пайыз байланыстың {3} бойы досыңыздың әр төлемінен түседі.",
  "Уровень считается вместе с вашими {0}.": "Деңгей қазіргі сатып алушыларыңызбен бірге есептеледі: {0}.",
  "Калькулятор дохода": "Табыс калькуляторы",
  "Тариф друзей": "Достардың тарифі",
  "Сколько друзей купят подписку": "Неше дос жазылым алады",
  "Вы получите": "Сіз аласыз",
  "C в месяц": "C айына",
  "Проценты, сроки и ограничения": "Пайыздар, мерзімдер және шектеулер",
  "Circle можно вывести": "Circle шығаруға болады",
  "Circle работают внутри STEOS": "Circle STEOS ішінде жұмсалады",
  "Привязка на {0}": "{0} байланыс",
  "Процент идёт со всех оплат друга: с регистрации по ссылке или с первой покупки по промокоду": "Пайыз досыңыздың барлық төлемінен түседі: сілтеме арқылы тіркелгеннен немесе промокодпен алғашқы сатып алудан бастап",
  "Ссылка главнее промокода": "Сілтеме промокодтан басым",
  "Если друг пришёл по ссылке, промокод привязку уже не меняет": "Дос сілтеме арқылы келсе, промокод байланысты өзгертпейді",
  "Промокод только до первой покупки": "Промокод тек алғашқы сатып алуға дейін",
  "После первой оплаты друга ваш промокод партнёра у него не работает": "Досыңыздың алғашқы төлемінен кейін серіктес промокодыңыз ол үшін жұмыс істемейді",
  "{0} C сразу, сгорят через {1}. {2} на первый пакет Circle {3} после подписки": "Бірден {0} C, {1} ішінде жарамды. Жазылымнан кейін {3} бойы алғашқы Circle пакетіне {2}",
  "Только уровень {0}": "Тек {0} деңгейі",
  "От {0} {1}, после входа через STEOS ID. Для ИП, самозанятых и их аналогов в других странах": "Кемінде {0} {1}, STEOS ID арқылы кіргеннен кейін. ЖК, өзін-өзі жұмыспен қамтығандар және басқа елдердегі баламалары үшін",
  "Счёт на компанию STEOS": "STEOS компаниясына шот",
  "Плательщик появится, когда вывод откроется": "Төлеуші шығару ашылғанда көрінеді",
  "В РФ: {0}, в рублях. Международный статус: {1}, в евро": "РФ-та: {0}, рубльмен. Халықаралық мәртебе: {1}, еуромен",
  "Выплата за {0}": "{0} ішінде төлем",
  "После проверки счёта, от {0} C": "Шот тексерілгеннен кейін, кемінде {0} C",
  "Коротко о главном": "Басты нәрсе қысқаша",
  "Здесь краткое изложение. Полный текст условий на {0}": "Мұнда қысқаша мазмұны. Шарттардың толық мәтіні {0} сайтында",
  "Понятно": "Түсінікті",
  "У вас {0}.": "Сізде {0} бар.",
  "Покупателей пока нет.": "Әзірге сатып алушы жоқ.",
  "Уровень считается по всем покупателям за всё время, с истёкшей привязкой тоже.": "Деңгей барлық уақыттағы сатып алушылар бойынша, байланысы аяқталғандарды қоса есептеледі.",
  "Введите сумму": "Соманы енгізіңіз",
  "Можно вывести не больше {0} C": "Ең көбі {0} C шығаруға болады",
  "Заполните реквизиты": "Деректемелерді толтырыңыз",
  "Загрузите счёт на оплату": "Төлем шотын жүктеңіз",
  "Счёт ещё проверяется": "Шот әлі тексерілуде",
  "Выплата в {0} · 1 C = {1} {0}": "{0} валютасында төлем · 1 C = {1} {0}",
  "Вывести {0} C": "{0} C шығару",
  "Счёт выставьте в {0}. Проверим его, и деньги придут за {1}.": "Шотты {0} валютасында жазыңыз. Тексереміз, ақша {1} ішінде түседі.",
  "Счёт выставьте в евро. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Шотты еуромен жазыңыз. Тексереміз, ақша {0} ішінде түседі. Деректемелер STEOS ID-де сақталады.",
  "Счёт выставьте в рублях. Проверим его, и деньги придут за {0}. Реквизиты сохранятся в STEOS ID.": "Шотты рубльмен жазыңыз. Тексереміз, ақша {0} ішінде түседі. Деректемелер STEOS ID-де сақталады.",
  "Скопировать {0}": "{0} көшіру",
  "юридический адрес": "заңды мекенжай",
  "Скопировать название компании": "Компания атауын көшіру",
  "Скопировать все реквизиты": "Барлық деректемені көшіру",
  "Реквизиты для счёта": "Шотқа арналған деректемелер",
  "Проверяем счёт…": "Шот тексерілуде…",
  "PDF, JPG или PNG, до 10 МБ": "PDF, JPG не PNG, 10 МБ-қа дейін",
  "Можно вывести {0} C": "{0} C шығаруға болады",
  "Сумма, C": "Сома, C",
  "Сумма вывода, C": "Шығару сомасы, C",
  "Всё": "Барлығы",
  "Придёт на счёт": "Шотқа түседі",
  "Реквизиты": "Деректемелер",
  "Счёт на оплату": "Төлем шоты",
  "Заявка на вывод принята": "Шығару өтінімі қабылданды",
  "{0} придут за {1} после проверки счёта": "{0} шот тексерілгеннен кейін {1} ішінде түседі",
  "Ролик принят в обработку": "Ролик өңдеуге қабылданды",
  "Ролик в чате с ботом": "Ролик ботпен чатта",
  "Бот пришлёт его после подготовки. Доставка пока не подтверждена.": "Бот дайын болғанда жібереді. Жеткізу әлі расталмады.",
  "Сохраните его и выложите в Reels, Shorts, TikTok или VK Клипы": "Сақтап, Reels, Shorts, TikTok не VK Клиптерге салыңыз",
  "Промокод и ссылка уже в кадре. Бот пришлёт ролик в чат, оттуда его можно сохранить и выложить.": "Промокод пен сілтеме кадрда бар. Бот роликті чатқа жібереді, сол жерден сақтап, жариялауға болады.",
  "Прислать в чат": "Чатқа жіберу",
  "Текст выделен: скопируйте его вручную": "Мәтін белгіленді: оны қолмен көшіріңіз",
  "Баннер готов: отправить его в чат можно из Telegram": "Баннер дайын: оны Telegram-нан чатқа жіберуге болады",
  "PDF принят в очередь": "PDF кезекке қойылды",
  "PDF в чате": "PDF чатта",
  "Не удалось загрузить период. Попробуйте ещё раз": "Кезең жүктелмеді. Қайталап көріңіз",
  "Без начислений": "Есептеусіз",
  "Значение выделено: скопируйте его вручную": "Мән белгіленді: қолмен көшіріңіз",
  "Реквизиты выделены: скопируйте их вручную": "Деректемелер белгіленді: қолмен көшіріңіз",
  "Нужен файл PDF, JPG или PNG": "PDF, JPG не PNG файлы керек",
  "Файл {0}, можно до 10 МБ": "Файл {0}, 10 МБ-қа дейін болады",
  "Партнёрство не загрузилось": "Серіктестік жүктелмеді",
  "Загружаем партнёрскую программу": "Серіктестік бағдарламасы жүктелуде",
  "за неделю": "апта ішінде",
  "за месяц": "ай ішінде",
  "Для вывода войдите через STEOS ID": "Шығару үшін STEOS ID арқылы кіріңіз",
  "Вывод недоступен на текущем уровне": "Ағымдағы деңгейде шығару қолжетімсіз",
  "Сумма больше доступной": "Сома қолжетімдіден көп",
  "Сумма меньше минимальной": "Сома ең төменгіден аз",
  "Проверьте реквизиты и счёт": "Деректемелер мен шотты тексеріңіз",
  "Счёт ещё не проверен. Загрузите его заново": "Шот әлі тексерілмеді. Қайта жүктеңіз",
  "Ответ не получен. Проверьте ту же заявку: её данные и ключ сохранены": "Жауап алынбады. Сол өтінімді тексеріңіз: деректері мен кілті сақталған",
  "Не удалось загрузить список друзей": "Достар тізімі жүктелмеді",
  "Не удалось восстановить прежнюю заявку. Напишите в поддержку перед новой": "Алдыңғы өтінім қалпына келмеді. Жаңасының алдында қолдау қызметіне жазыңыз",
  "Партнёрская программа временно недоступна": "Серіктестік бағдарламасы уақытша қолжетімсіз",
  "Не удалось загрузить следующую страницу": "Келесі бет жүктелмеді",
  "Не удалось подготовить баннер. Попробуйте ещё раз": "Баннер дайындалмады. Қайталап көріңіз",
  "Бот не может подготовить материал: откройте чат с ботом и попробуйте ещё раз": "Бот материалды дайындай алмайды: ботпен чатты ашып, қайталап көріңіз",
  "Материал сейчас недоступен": "Материал қазір қолжетімсіз",
  "Отправка не подтверждена. Нажмите ещё раз: повтор проверит прежний запрос": "Жіберу расталмады. Қайта басыңыз: қайталау алдыңғы сұрауды тексереді",
  "Прежняя отправка не восстановлена. Напишите в поддержку": "Алдыңғы жіберу қалпына келмеді. Қолдау қызметіне жазыңыз",
  "Прежняя отправка подтверждена. Нажмите ещё раз": "Алдыңғы жіберу расталды. Қайта басыңыз",
  "Отправка не подтверждена": "Жіберу расталмады",
  "Счёт не прошёл проверку. Выберите PDF, JPG или PNG до 10 МБ": "Шот тексеруден өтпеді. 10 МБ-қа дейінгі PDF, JPG не PNG таңдаңыз",
  "Не удалось безопасно сохранить заявку. Отправка не выполнена": "Өтінім қауіпсіз сақталмады. Жіберілмеді",
  "Тут откроется инструмент «{0}»": "Мұнда «{0}» құралы ашылады",
  "Геральт, Цири и ещё 2 400 голосов скажут всё, что напишете": "Геральт, Цири және тағы 2 400 дауыс жазғаныңыздың бәрін айтады",
  "Снимите себя, и персонаж повторит ваши движения": "Өзіңізді түсіріңіз, кейіпкер қимылдарыңызды қайталайды",
  "Выберите образ, и через минуту готовы 3 кадра из одного селфи": "Бейнені таңдаңыз, бір минутта бір селфиден 3 кадр дайын",
  "Сделать": "Жасау",
  "2 400 голосов, 19 языков": "2 400 дауыс, 19 тіл",
  "Текст в речь голосом персонажа или своим клоном": "Мәтінді кейіпкер даусымен не өз клоныңызбен сөйлетіңіз",
  "Ваш голос за две минуты": "Екі минутта өз даусыңыз",
  "Запишите образец, и клон появится во всех инструментах с озвучкой": "Үлгі жазыңыз, клон дыбыстауы бар барлық құралда пайда болады",
  "Движения": "Қимылдар",
  "бесплатно": "тегін",
  "/сек": "/сек",
  "готов": "дайын",
  "Клон · готов": "Клон · дайын",
  "студия: Мой голос": "Менің даусым",
  "Сейчас в тренде": "Қазір трендте",
  "Популярное за неделю": "Аптаның танымалдары",
  "Геральт скажет ваш текст": "Геральт мәтініңізді айтады",
  "Вы в знаменитых сценах": "Атақты сахналарда сіз",
  "3 кадра в любом образе": "Кез келген бейнеде 3 кадр",
  "Готовый сюжет с вами": "Сізбен дайын сюжет",
  "Вы повторите любой танец": "Кез келген биді қайталайсыз",
  "Ваш снимок в движении": "Суретіңіз қозғалыста",
  "Фото скажет ваш текст": "Фото мәтініңізді айтады",
  "Легенды замка": "Қамал аңыздары",
  "Город инков": "Инктер қаласы",
  "Неоновый дождь": "Неон жаңбыр",
  "Утренний бег": "Таңғы жүгіру",
  "Танец теней": "Көлеңкелер биі",
  "Дорога домой": "Үйге жол",
  "Ночной рейв": "Түнгі рейв",
  "Снежный пик": "Қарлы шың",
  "Тайны Хейвена": "Хейвен құпиялары",
  "Магия рун": "Руна сиқыры",
  "Странные дела": "Оғаш істер",
  "Ночной рынок": "Түнгі базар",
  "Ретро-кадр": "Ретро кадр",
  "Утро в горах": "Таудағы таң",
  "Золотой час": "Алтын сағат",
  "Студийный свет": "Студия жарығы",
  "Полароид": "Полароид",
  "Киберпанк": "Киберпанк",
  "Старый маяк": "Ескі маяк",
  "Шторм в заливе": "Шығанақтағы дауыл",
  "Кинотрейлер": "Кинотрейлер",
  "Город в движении": "Қозғалыстағы қала",
  "Интервью": "Сұхбат",
  "Пустыня на закате": "Күн батқандағы шөл",
  "Подводный мир": "Су асты әлемі",
  "Кружок «Привет»": "«Сәлем» дөңгелек бейнесі",
  "Спокойной ночи": "Қайырлы түн",
  "Поздравляю": "Құттықтаймын",
  "Скучаю": "Сағындым",
  "Новости дня": "Күн жаңалықтары",
  "Нос корабля": "Кеме тұмсығы",
  "Двое на носу корабля, руки раскинуты навстречу ветру": "Кеме тұмсығында екеуі, қолдары желге жайылған",
  "Героиня": "Кейіпкер қыз",
  "роль: Герой": "Кейіпкер",
  "Уклонение от пуль": "Оқтан жалтару",
  "Время замирает, вы прогибаетесь назад, и пули проходят мимо": "Уақыт тоқтайды, сіз шалқайып, оқтар жаныңыздан өтеді",
  "Танец в закусочной": "Асханадағы би",
  "Пара танцует твист у стойки придорожной закусочной": "Жұп жол бойындағы асхана сөресінің жанында твист билейді",
  "Танцор": "Биші",
  "Танцовщица": "Биші қыз",
  "Свидание под дождём": "Жаңбыр астындағы кездесу",
  "Ливень, старый дом и встреча, которую оба ждали годами": "Нөсер, ескі үй және екеуі жылдар бойы күткен кездесу",
  "Он": "Жігіт",
  "Она": "Қыз",
  "Речь перед битвой": "Шайқас алдындағы сөз",
  "Вождь проезжает вдоль строя, и войско отвечает рёвом": "Көсем сапты бойлай өтеді, әскер айқаймен жауап береді",
  "Вождь": "Көсем",
  "Знаменосец": "Ту ұстаушы",
  "Погоня по крышам": "Шатырлардағы қуғын",
  "Прыжки между крышами ночного города, погоня не отстаёт": "Түнгі қала шатырлары арасында секіру, қуғыншылар қалмай келеді",
  "Беглец": "Қашқын",
  "Преследователь": "Қуғыншы",
  "Ограбление казино": "Казино тонау",
  "Команда в смокингах проходит через зал, сейф уже открыт": "Смокинг киген топ залдан өтеді, сейф ашылып қойған",
  "Главарь": "Бастық",
  "Напарник": "Серіктес",
  "Напарница": "Серіктес қыз",
  "Прощание на вокзале": "Вокзалдағы қоштасу",
  "Поезд трогается, двое держатся за руки до последнего": "Пойыз қозғалады, екеуі соңына дейін қол ұстасып тұр",
  "Пассажир": "Жолаушы",
  "Провожающий": "Шығарып салушы",
  "Дуэль на закате": "Күн батардағы жекпе-жек",
  "Пустая улица, два стрелка и последние секунды тишины": "Бос көше, екі атқыш және тыныштықтың соңғы секундтары",
  "Шериф": "Шериф",
  "Злодей": "Зұлым",
  "Танец на лестнице": "Баспалдақтағы би",
  "Злодей в ярком костюме танцует на длинной уличной лестнице": "Ашық түсті костюмді зұлым ұзын көше баспалдағында билейді",
  "Выход в открытый космос": "Ашық ғарышқа шығу",
  "Астронавт парит над Землёй, трос уходит к станции": "Ғарышкер Жер үстінде қалықтайды, трос станцияға тартылған",
  "Астронавт": "Ғарышкер",
  "Рассвет над саванной": "Саваннадағы таң",
  "Питомца поднимают над скалой, и вся саванна смотрит на него": "Үй жануарын жартас үстіне көтереді, бүкіл саванна оған қарайды",
  "Главная роль": "Басты рөл",
  "Хранитель": "Қамқоршы",
  "Полёт под луной": "Ай астындағы ұшу",
  "Велосипед отрывается от земли и летит на фоне луны": "Велосипед жерден көтеріліп, ай аясында ұшады",
  "Финальная поддержка": "Соңғы көтеру",
  "Разбег, прыжок и поддержка над головой под аплодисменты зала": "Екпін, секіру және зал қошеметімен бас үстіне көтеру",
  "Партнёрша": "Серіктес қыз",
  "Партнёр": "Серіктес",
  "Песня на холме": "Төбедегі ән",
  "Альпийский луг и ветер: вы кружитесь с песней, а дети бегут к вам навстречу": "Альпі шабындығы мен жел: сіз әнмен айналасыз, балалар сізге қарай жүгіреді",
  "Бледная кожа": "Бозғылт тері",
  "Хвойный лес": "Қылқан жапырақты орман",
  "Первый взгляд": "Алғашқы көзқарас",
  "Туман над рекой": "Өзен үстіндегі тұман",
  "Полночь в школе": "Мектептегі түн ортасы",
  "Двое на поляне": "Алаңқайдағы екеуі",
  "Луч пробивается сквозь хвою, и двое замирают посреди лесной поляны": "Сәуле қылқан арасынан өтіп, екеуі орман алаңқайының ортасында қатып қалады",
  "Глаза цвета янтаря": "Кәріптас түсті көздер",
  "Бал выпускников": "Түлектер балы",
  "Клятва": "Ант",
  "Игра в грозу": "Найзағайдағы ойын",
  "Гром над лесной поляной, и каждый удар битой звучит как раскат": "Орман алаңқайында күн күркірейді, әр соққы найзағайдай естіледі",
  "Отбивающий": "Соғушы",
  "Подающая": "Лақтырушы қыз",
  "Ловец": "Қағушы",
  "К вершине сосны": "Қарағай ұшына",
  "Он уносит её на спине к вершине сосны, внизу туман и весь лес": "Ол қызды арқасына көтеріп қарағай ұшына шығарады, төменде тұман мен бүкіл орман",
  "Примерка брони": "Сауыт кию",
  "Броня защёлкивается на вас деталь за деталью, и шлем закрывает лицо": "Сауыт бөлшек-бөлшегімен киіліп, дулыға бетіңізді жабады",
  "Полёт над городом": "Қала үстіндегі ұшу",
  "Разгон над ночным городом, вираж между башнями и посадка на крышу": "Түнгі қала үстінде екпін, мұнаралар арасында бұрылыс және шатырға қону",
  "Пилот брони": "Сауыт ұшқышы",
  "Ночь в мастерской": "Шеберханадағы түн",
  "Искры сварки, чертежи прямо в воздухе и первый удачный запуск": "Дәнекерлеу ұшқындары, ауадағы сызбалар және алғашқы сәтті іске қосу",
  "Изобретатель": "Өнертапқыш",
  "Последний заряд": "Соңғы заряд",
  "Заряд брони на исходе, команда встаёт спина к спине, и всё решает последний залп": "Сауыт заряды таусылуда, топ арқа тіресіп тұрады, бәрін соңғы оқ шешеді",
  "Герой в броне": "Сауытты кейіпкер",
  "Качели на паутине": "Өрмекшітордағы әткеншек",
  "Прыжок с карниза, паутина натягивается, и улица проносится под ногами": "Карниздан секіру, тор керіліп, көше аяқ астынан зулап өтеді",
  "Герой в маске": "Маскалы кейіпкер",
  "Поцелуй под дождём": "Жаңбыр астындағы сүйіс",
  "Ночной переулок и ливень: он висит вниз головой, она приподнимает край маски": "Түнгі тар көше мен нөсер: ол төңкеріліп ілулі, қыз масканың шетін көтереді",
  "Крыша на закате": "Күн батардағы шатыр",
  "Двое сидят на краю крыши, внизу шумит город, солнце уходит за башни": "Екеуі шатыр шетінде отыр, төменде қала гуілдейді, күн мұнаралар артына батады",
  "Бой в поезде": "Пойыздағы шайқас",
  "Схватка на крыше несущегося поезда, а потом герой останавливает вагон руками": "Зымыраған пойыз төбесіндегі шайқас, кейін кейіпкер вагонды қолымен тоқтатады",
  "Пассажирка": "Жолаушы қыз",
  "Для маркетплейса": "Маркетплейс үшін",
  "Праздники": "Мерекелер",
  "Поздравления, кружки и посты к праздникам: 1 апреля, Пасха, 8 марта": "Мерекелерге құттықтау, дөңгелек бейнелер мен жазбалар: 1 сәуір, Пасха, 8 наурыз",
  "1 апреля": "1 сәуір",
  "Пасха": "Пасха",
  "8 марта": "8 наурыз",
  "Мода": "Сән",
  "Аватарки": "Аватарлар",
  "Фильмы": "Фильмдер",
  "Игры": "Ойындар",
  "Путешествия": "Саяхат",
  "Сумерки": "Ымырт",
  "Железный человек": "Темір адам",
  "Человек-паук": "Өрмекші адам",
  "Романтика": "Романтика",
  "Погони": "Қуғындар",
  "Всей семьёй": "Бүкіл отбасымен",
  "Особая подборка": "Ерекше топтама",
  "Особая подборка {0}, {1}": "Ерекше топтама {0}, {1}",
  "Подборка {0}, {1}": "Топтама {0}, {1}",
  "{0} в подборке": "Топтамада {0}",
  "шаблон|шаблона|шаблонов": "үлгі",
  "шаблона|шаблонов|шаблонов": "үлгі",
  "сцена|сцены|сцен": "сахна",
  "инструмент|инструмента|инструментов": "құрал",
  "инструмента|инструментов|инструментов": "құрал",
  "стиль|стиля|стилей": "стиль",
  "кадра|кадров|кадров": "кадр",
  "ребёнок|ребёнка|детей": "бала",
  "питомец|питомца|питомцев": "үй жануары",
  "кружки": "дөңгелек бейнелер",
  "голос": "дауыс",
  "текст": "мәтін",
  "для бизнеса": "бизнес үшін",
  "Кружок из видео": "Видеодан бейнехабар",
  "Фото в новом стиле": "Жаңа стильдегі фото",
  "Фото по описанию": "Сипаттама бойынша фото",
  "Семейный портрет": "Отбасылық портрет",
  "Видео в новом стиле": "Жаңа стильдегі видео",
  "Видео по описанию": "Сипаттама бойынша видео",
  "Видео другим голосом": "Басқа дауыспен видео",
  "Объёмное фото": "Көлемді фото",
  "Анимация из серии": "Сериядан анимация",
  "Видео из поездки": "Сапардан видео",
  "Фильм из фотографий": "Фотолардан фильм",
  "Изменить видео": "Видеоны өзгерту",
  "текст или запись": "мәтін не жазба",
  "видео до 1 минуты": "1 минутқа дейін видео",
  "1 фото и текст": "1 фото және мәтін",
  "запись или аудиофайл": "жазба не аудиофайл",
  "5 фото лица": "5 бет фотосы",
  "1 селфи": "1 селфи",
  "описание словами": "сөзбен сипаттама",
  "фото или описание": "фото не сипаттама",
  "старое фото": "ескі фото",
  "чёрно-белое фото": "ақ-қара фото",
  "фото близких": "жақындардың фотосы",
  "от 2 до 9 фото": "2–9 фото",
  "тема поста": "жазба тақырыбы",
  "1 фото или видео": "1 фото не видео",
  "ваше фото": "сіздің фотоңыз",
  "фото тех, кто сыграет": "ойнайтындардың фотосы",
  "1 видео": "1 видео",
  "видео и новый текст": "видео және жаңа мәтін",
  "видео с речью": "сөйлеуі бар видео",
  "текст поздравления": "құттықтау мәтіні",
  "от 3 фото": "3 фотодан бастап",
  "фото из поездки": "сапар фотолары",
  "семейные фото": "отбасылық фотолар",
  "сценарий": "сценарий",
  "запись голоса": "дауыс жазбасы",
  "песня": "ән",
  "файл или ссылка": "файл не сілтеме",
  "название товара": "тауар атауы",
  "от 1 до 5 фото товара": "1–5 тауар фотосы",
  "фото товара": "тауар фотосы",
  "1 видео с вами": "сізбен 1 видео",
  "ваше видео": "сіздің видеоңыз",
  "картинка": "сурет",
  "идея словами": "сөзбен идея",
  "ваш промпт": "сіздің промптыңыз",
  "нужно: 1 фото": "1 фото",
  "нужно: Текст": "Мәтін",
  "нужно: Тема": "Тақырып",
  "нужно: Запись": "Жазба",
  "формат: Reels": "рилс",
  "формат: фото": "фото",
  "формат: видео": "видео",
  "формат: кружков": "дөңгелек бейне",
  "формат: шаблонов": "үлгі",
  "любое, где хорошо видно лицо": "беті анық көрінетін кез келгені",
  "лицо крупно и при хорошем свете": "бет ірі және жақсы жарықта",
  "селфи, лицо крупно": "селфи, бет ірі",
  "снимок оживёт в ролике": "сурет роликте жанданады",
  "что скажет герой": "кейіпкер не айтады",
  "или фото, из которых сделаем слайды": "не слайд жасайтын фотолар",
  "Сколько стоит одна генерация": "Бір генерация қанша тұрады",
  "Фото стоит {0} C, фотосессия {1} C за 3 кадра, видео {2} C за 5 секунд. Помощники для текста, например описание товара, стоят {3} C. Цена всегда видна на кнопке «Создать» до списания.": "Фото {0} C тұрады, фотосессия 3 кадр үшін {1} C, видео 5 секунд үшін {2} C. Тауар сипаттамасы сияқты мәтін көмекшілері {3} C тұрады. Баға төлемге дейін «Жасау» батырмасында әрдайым көрінеді.",
  "Что такое C и как пополнить баланс": "C деген не және теңгерімді қалай толтыруға болады",
  "C это монеты Circle, ими платят за создание. Пакеты и подписка покупаются на вкладке «Баланс», там же виден остаток.": "C — Circle тиындары, олармен жасау үшін төлейсіз. Пакеттер мен жазылым «Теңгерім» қойындысында сатылады, қалдық та сонда көрінеді.",
  "Какие файлы можно загружать": "Қандай файлдарды жүктеуге болады",
  "Видео до 1 минуты и 15 МБ, фото в JPG или PNG, аудио в MP3, WAV или M4A. Ограничения показываются в самом инструменте.": "1 минутқа және 15 МБ-қа дейін видео, JPG не PNG фото, MP3, WAV не M4A аудио. Шектеулер құралдың өзінде көрсетіледі.",
  "Как сделать дешевле": "Қалай арзанырақ жасауға болады",
  "Если Circle на работу не хватает, кнопка внизу экрана откроет лист «Не хватает Circle»: в нём есть «Сделать дешевле». Скидка {0}%, на результате появится водяной знак.": "Жұмысқа Circle жетпесе, экран төменгі жағындағы батырма «Circle жеткіліксіз» парағын ашады: онда «Арзанырақ жасау» бар. Жеңілдік {0}%, нәтижеде су таңбасы болады.",
  "Где найти готовые результаты": "Дайын нәтижелерді қайдан табуға болады",
  "В разделе «История» в меню «Ещё». Там же можно скачать файл повторно или отправить в чат.": "«Тағы» мәзіріндегі «Тарих» бөлімінде. Сонда файлды қайта жүктеп алуға не чатқа жіберуге болады.",
  "Можно ли использовать свой голос": "Өз даусымды қолдануға бола ма",
  "Да. Клонируйте голос на вкладке «Клон», и он появится в списке голосов во всех инструментах с озвучкой.": "Иә. «Клон» қойындысында даусыңызды клондаңыз, ол дыбыстауы бар барлық құралдың дауыстар тізімінде пайда болады.",
  "Фотосессия из {0} в стиле шаблона": "Үлгі стиліндегі {0} фотосессия",
  "По желанию: {0}": "Қаласаңыз: {0}",
  "Тут откроется шаблон «{0}»": "Мұнда «{0}» үлгісі ашылады",
  "Только до": "Тек дейін",
  "Только после": "Тек кейін",
  "До: {0} %": "Дейін: {0} %",
  "подборка": "топтама",
  "Все форматы": "Барлық формат",
  "Состав": "Құрам",
  "Вкладки каталога": "Каталог қойындылары",
  "Найти подборку": "Топтама табу",
  "Найти шаблон": "Үлгі табу",
  "Поиск среди {0}": "{0} ішінен іздеу",
  "По запросу «{0}» подборок нет. Поищите среди всех шаблонов": "«{0}» бойынша топтама жоқ. Барлық үлгі ішінен іздеңіз",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех шаблонах": "«{1}» топтамасында «{0}» бойынша ештеңе жоқ. Барлық үлгіден іздеңіз",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех шаблонах": "«Сізге» ішінде «{0}» бойынша ештеңе жоқ. Барлық үлгіден іздеңіз",
  "В подборке «{0}» нет сцен «{1}»": "«{0}» топтамасында «{1}» сахнасы жоқ",
  "Посмотрите все сцены подборки": "Топтаманың барлық сахнасын қараңыз",
  "В подборке «{0}» нет {1}": "«{0}» топтамасында {1} жоқ",
  "Посмотрите во всех форматах": "Барлық форматтан қараңыз",
  "В «Рекомендуем» нет {0}": "«Сізге» ішінде {0} жоқ",
  "Пока ничего нет": "Әзірге ештеңе жоқ",
  "Шаблоны этого формата появятся совсем скоро": "Бұл форматтағы үлгілер жақында шығады",
  "По запросу «{0}» среди {1} ничего нет. Поищите во всех форматах": "{1} ішінде «{0}» бойынша ештеңе жоқ. Барлық форматтан іздеңіз",
  "Искать во всех форматах": "Барлық форматтан іздеу",
  "По запросу «{0}» среди шаблонов ничего нет. Попробуйте другое слово": "«{0}» бойынша үлгі жоқ. Басқа сөз жазып көріңіз",
  "Загружаем ещё": "Тағы жүктелуде",
  "Это все шаблоны": "Барлық үлгі осы",
  "Тренды": "Трендтер",
  "Вкладки страницы": "Бет қойындылары",
  "Найти сцену": "Сахна табу",
  "Найти в подборке": "Топтамадан табу",
  "Искать во всех сценах": "Барлық сахнадан іздеу",
  "По запросу «{0}» подборок нет. Поищите среди всех сцен": "«{0}» бойынша топтама жоқ. Барлық сахнадан іздеңіз",
  "По запросу «{0}» в подборке «{1}» ничего нет. Поищите во всех сценах": "«{1}» топтамасында «{0}» бойынша ештеңе жоқ. Барлық сахнадан іздеңіз",
  "По запросу «{0}» в «Трендах» ничего нет. Поищите во всех сценах": "«Трендтер» ішінде «{0}» бойынша ештеңе жоқ. Барлық сахнадан іздеңіз",
  "По запросу «{0}» в «Рекомендуем» ничего нет. Поищите во всех сценах": "«Сізге» ішінде «{0}» бойынша ештеңе жоқ. Барлық сахнадан іздеңіз",
  "В «Трендах» нет сцен «{0}»": "«Трендтер» ішінде «{0}» сахнасы жоқ",
  "В «Рекомендуем» нет сцен «{0}»": "«Сізге» ішінде «{0}» сахнасы жоқ",
  "Посмотрите все сцены этой вкладки": "Осы қойындының барлық сахнасын қараңыз",
  "В подборке «{0}» ничего по запросу «{1}». Поищите во всех шаблонах": "«{0}» топтамасында «{1}» бойынша ештеңе жоқ. Барлық үлгіден іздеңіз",
  "В этой подборке пока нет таких шаблонов. Посмотрите её целиком или выберите другую вкладку": "Бұл топтамада әзірге мұндай үлгі жоқ. Толық қараңыз не басқа қойынды таңдаңыз",
  "Поиск в подборке «{0}»: {1}": "«{0}» топтамасынан іздеу: {1}",
  "Вкладки подборки": "Топтама қойындылары",
  "Нужно: {0}": "Қажет: {0}",
  "Нужно": "Қажет",
  "По запросу «{0}» нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "«{0}» бойынша құрал да, үлгі де жоқ. Басқа сөз жазыңыз не барлық құралды қараңыз",
  "По запросу «{0}» в разделе «{1}» ничего нет. Поищите во всех инструментах": "«{1}» бөлімінде «{0}» бойынша ештеңе жоқ. Барлық құралдан іздеңіз",
  "Искать во всех": "Барлығынан іздеу",
  "По запросу «{0}» инструментов нет. Попробуйте другое слово": "«{0}» бойынша құрал жоқ. Басқа сөз жазып көріңіз",
  "Найти инструмент": "Құрал табу",
  "Не удалось открыть инструмент. Обновите каталог и попробуйте снова.": "Құрал ашылмады. Каталогты жаңартып, қайталап көріңіз.",
  "Не удалось открыть инструмент за 30 секунд. Обновите запрос или вернитесь назад.": "Құрал 30 секундта ашылмады. Қайталаңыз не артқа оралыңыз.",
  "Карточка товара": "Тауар карточкасы",
  "Рилс готов": "Рилс дайын",
  "Кавер не создан": "Кавер жасалмады",
  "Фотосессия не создана": "Фотосессия жасалмады",
  "Рилс не создан": "Рилс жасалмады",
  "Карточка не создана": "Карточка жасалмады",
  "Слайды не созданы": "Слайдтар жасалмады",
  "Запись не обработана": "Жазба өңделмеді",
  "Коллаж не создан": "Коллаж жасалмады",
  "· остаток {0} C": "· қалдық {0} C",
  "Вернули {0} C": "{0} C қайтарылды",
  "Списано {0} C со скидкой, {1} водяной знак": "Жеңілдікпен {0} C алынды, {1} су таңбасы",
  "Списано {0} C": "{0} C алынды",
  "Рисованному стилю камера не нужна": "Сурет стиліне камера керек емес",
  "У этой камеры объектив встроенный": "Бұл камераның объективі кіріктірілген",
  "У этой камеры резкость не настраивается": "Бұл камерада анықтық реттелмейді",
  "У этого объектива диафрагма постоянная": "Бұл объективтің диафрагмасы тұрақты",
  "Встроенный": "Кіріктірілген",
  "Как у камеры": "Камерадағыдай",
  "до {0} МБ": "{0} МБ-қа дейін",
  "По запросу {0} нет ни инструментов, ни шаблонов. Попробуйте другое слово или посмотрите все инструменты": "{0} бойынша құрал да, үлгі де жоқ. Басқа сөз жазыңыз не барлық құралды қараңыз",
  "По запросу {0} в разделе {1} ничего нет. Поищите во всех инструментах": "{1} бөлімінде {0} бойынша ештеңе жоқ. Барлық құралдан іздеңіз",
  "По запросу {0} инструментов нет. Попробуйте другое слово": "{0} бойынша құрал жоқ. Басқа сөз жазып көріңіз",
  "в «Трендах»": "«Трендтер» ішінде",
  "в «Рекомендуем»": "«Сізге» ішінде",
  "в подборке {0}": "{0} топтамасында",
  "По запросу {0} {1} ничего нет. Поищите во всех сценах": "{1} {0} бойынша ештеңе жоқ. Барлық сахнадан іздеңіз",
  "В подборке {0} ничего по запросу {1}. Поищите во всех шаблонах": "{0} топтамасында {1} бойынша ештеңе жоқ. Барлық үлгіден іздеңіз",
  "сцен {0}": "{0} сахнасы",
  "В подборке {0} нет {1}": "{0} топтамасында {1} жоқ",
  "В подборке {0} нет таких шаблонов": "{0} топтамасында мұндай үлгі жоқ",
  "Посмотрите её целиком или выберите другую вкладку": "Толық қараңыз не басқа қойынды таңдаңыз",
  "По запросу {0} в этом формате ничего нет. Поищите во всех форматах": "Бұл форматта {0} бойынша ештеңе жоқ. Барлық форматтан іздеңіз",
  "По запросу {0} среди шаблонов ничего нет. Попробуйте другое слово": "{0} бойынша үлгі жоқ. Басқа сөз жазып көріңіз",
  "Здесь нет шаблонов": "Мұнда үлгі жоқ",
  "Заказ принят": "Тапсырыс қабылданды",
  "Бот пришлёт результат в чат, в отдельную тему.": "Бот нәтижені чатқа, бөлек тақырыпқа жібереді.",
  "Измените запрос и попробуйте снова. Circle за проверенный заказ не возвращаются.": "Сұрауды өзгертіп, қайталап көріңіз. Тексерілген тапсырыс үшін Circle қайтарылмайды.",
  "Сбой на нашей стороне. Circle вернулись на баланс.": "Біз жақта ақау болды. Circle теңгерімге қайтарылды.",
  "Инструмент ещё подключается: заказ стоит в очереди и начнётся сам, бот пришлёт результат в чат.": "Құрал әлі қосылып жатыр: тапсырыс кезекте тұр және өзі басталады, бот нәтижені чатқа жібереді.",
  "Сначала отметьте согласие ниже": "Алдымен төмендегі келісімді белгілеңіз",
  "Главное фото: {0}": "Басты фото: {0}",
  "Загружаем превью…": "Алдын ала көрініс жүктелуде…",
  "Фото не подошло": "Фото сәйкес келмеді",
  "Проверить загрузку": "Жүктеуді тексеру",
  "Опишите, что хотите увидеть": "Не көргіңіз келетінін сипаттаңыз",
  "Не помещается: до {0} знаков": "Сыймайды: {0} таңбаға дейін",
  "{0} во весь экран": "{0} толық экранда",
  "Загрузить картинку": "Сурет жүктеу",
  "Ваша": "Сіздікі",
  "Убрать картинку": "Суретті алып тастау",
  "Этот инструмент пока недоступен": "Бұл құрал әзірге қолжетімсіз",
  "Выберите другой инструмент или вернитесь к шаблонам.": "Басқа құрал таңдаңыз не үлгілерге оралыңыз.",
  "Вернуться": "Оралу",
  "Образ": "Бейне",
  "Ваши селфи": "Сіздің селфилеріңіз",
  "Три разных кадра: лицо крупно, при хорошем свете": "Үш түрлі кадр: бет ірі, жақсы жарықта",
  "Подтверждаю согласие людей на фото": "Фотодағы адамдардың келісімін растаймын",
  "От одного до пяти ракурсов, первый — главный": "Бірден беске дейін ракурс, біріншісі — басты",
  "Категория": "Санат",
  "Набор сцен": "Сахналар жинағы",
  "Загрузите фото: нужно {0}": "Фото жүктеңіз: {0} қажет",
  "Выберите: {0}": "Таңдаңыз: {0}",
  "Не удалось загрузить экран.": "Экран жүктелмеді.",
  "Сцен: {0}": "Сахна: {0}",
  "Заказ создан, следите за ним в «Истории».": "Тапсырыс жасалды, оны «Тарих» бөлімінен қадағалаңыз.",
  "Старые": "Ескілер",
  "Длинные": "Ұзындар",
  "Стиль уже задаёт свет и цвет. Выберите другой, если хотите поменять": "Стиль жарық пен түсті өзі анықтайды. Өзгерту үшін басқасын таңдаңыз",
  "{0} открывается только до f/{1}": "{0} тек f/{1} дейін ашылады",
  "Объектив не задаёт светосилу": "Объектив жарық күшін анықтамайды",
  "Этот объектив открывается только до f/{0}": "Бұл объектив тек f/{0} дейін ашылады",
  "Назад к настройкам": "Баптауларға оралу",
  "Группа": "Топ",
  "Нашли {0}": "{0} табылды",
  "Ничего не нашлось. Попробуйте другое слово или сбросьте группу.": "Ештеңе табылмады. Басқа сөз жазыңыз не топты тазартыңыз.",
  "Выбор сразу вернёт к настройкам. Цена не меняется": "Таңдау бірден баптауларға қайтарады. Баға өзгермейді",
  "Сравнить: было и стало": "Салыстыру: бұрын және кейін",
  "Берём стиль: цвет, свет, обработку. Саму картинку и лица с неё не переносим": "Стильді аламыз: түс, жарық, өңдеу. Суреттің өзін және ондағы беттерді көшірмейміз",
  "Берём сцену: фон, свет и подачу. Саму картинку и лица с неё не переносим": "Сахнаны аламыз: фон, жарық және көрініс. Суреттің өзін және ондағы беттерді көшірмейміз",
  "Берём образ: одежду, позу, фон и свет. В кадре будете вы, лица с картинки не переносим": "Бейнені аламыз: киім, поза, фон және жарық. Кадрда сіз боласыз, суреттегі беттерді көшірмейміз",
  "Картинка не подошла: не открывается, попробуйте JPG или PNG": "Сурет сәйкес келмеді: ашылмайды, JPG не PNG қолданып көріңіз",
  "Картинка не подошла: больше {0} МБ": "Сурет сәйкес келмеді: {0} МБ-тан үлкен",
  "Картинка не подошла: слишком маленькая, нужна от {0} px": "Сурет сәйкес келмеді: тым кішкентай, кемінде {0} px керек",
  "Картинка не подошла: на ней защищённое или запрещённое содержимое": "Сурет сәйкес келмеді: онда қорғалған не тыйым салынған мазмұн бар",
  "Загрузить картинку-референс": "Референс суретін жүктеу",
  "Озвучка текста": "Мәтінді дыбыстау",
  "Запишите от 2 секунд речи, и бот заговорит вашим голосом": "2 секунд сөйлеуді жазыңыз, сонда бот сіздің дауысыңызбен сөйлейді",
  "Готовые голоса стоят на вкладке «Мои» в разделе «Озвучка»": "Дайын дауыстар «Дауыстар» бөліміндегі «Менікі» қойындысында",
  "Под этим именем голос стоит в вашем списке. Описание видите только вы": "Дауыс тізіміңізде осы атпен тұрады. Сипаттаманы тек сіз көресіз",
  "Голос появится на вкладке «Мои»": "Дауыс «Менікі» қойындысында пайда болады",
  "Имя в списке голосов": "Дауыстар тізіміндегі аты",
  "Уже в «Озвучке»": "«Дауыстар» бөлімінде тұр",
  "Голос стоит на вкладке «Мои» с меткой «Мой голос»": "Дауыс «Менікі» қойындысында «Менікі» белгісімен тұр",
  "Карточка голоса": "Дауыс картасы",
  "Нажмите на голос в списке, чтобы переименовать или удалить": "Атын өзгерту не жою үшін тізімдегі дауысты басыңыз",
  "Так голос выглядит в списке": "Дауыс тізімде осылай көрінеді",
  "Голос уже стоит на вкладке «Мои». Послушайте, как он звучит": "Дауыс «Менікі» қойындысында тұр. Қалай естілетінін тыңдап көріңіз",
  "Идёт проверка и обучение, обычно 1–3 минуты. Голос появится на вкладке «Мои» сам": "Тексеру және үйрету жүріп жатыр, әдетте 1–3 минут. Дауыс «Менікі» қойындысында өзі пайда болады",
  "Голос пропадёт с вкладки «Мои». Вернуть его не получится.": "Дауыс «Менікі» қойындысынан жоғалады. Оны қайтару мүмкін емес.",
  "Обычно 1–3 минуты. Можно закрыть приложение, голос появится в списке": "Әдетте 1–3 минут. Қолданбаны жаба беруге болады, дауыс тізімде пайда болады",
  "Можно закрыть приложение": "Қолданбаны жабуға болады",
  "Запишите речь или загрузите файлы: от 0:02 до 1:30. Подойдут MP3, WAV, M4A, OGG и WEBM, до 10 файлов по 20 МБ": "Сөйлеуді жазыңыз не файл жүктеңіз: барлығы 0:02–1:30. MP3, WAV, M4A, OGG және WEBM, әрқайсысы 20 МБ-қа дейін, 10 файлға дейін",
  "Создано {n} клонов из {n}. Удалите один, чтобы добавить новый": "{n}/{n} клон жасалды. Жаңасын қосу үшін біреуін жойыңыз",
  "Без подписки можно создать {n} клона. С подпиской их будет {0}": "Жазылымсыз {n} клон жасауға болады. Жазылыммен — {0} дейін",
  "До {0} клонов": "{0} клонға дейін",
  "Три клона бесплатно": "Үш клон тегін",
  "Запишите ещё один, другим тоном или настроением": "Басқа үнмен не көңіл күймен тағы біреуін жазыңыз",
  "С подпиской можно создать до {0}": "Жазылыммен {0} дейін жасауға болады",
  "Привет! Это запись для моего голоса. Я говорю спокойно и в обычном темпе, как в разговоре с другом. Чем естественнее получится сейчас, тем точнее будет звучать клон.": "Сәлем! Бұл менің дауысыма арналған жазба. Досыммен сөйлескендей, сабырлы әрі әдеттегі қарқынмен сөйлеп тұрмын. Қазір неғұрлым табиғи шықса, клон соғұрлым дәл естіледі.",
  "Знаете, что самое странное в готовке по видео? Смотришь, как человек за минуту режет лук, и думаешь: это же просто. А потом лук почему-то везде, кроме сковородки.": "Видео бойынша тамақ әзірлеудің ең оғаш жері не екенін білесіз бе? Біреудің бір минутта пияз турағанын көріп, бұл оп-оңай деп ойлайсыз. Ал кейін пияз неге екені белгісіз, табадан басқа жердің бәрінде жатады.",
  "Вчера наконец разобрал коробки после переезда. Нашёл старый плеер, три зарядки от телефонов, которых уже нет, и тетрадь с планами на лето. Плеер до сих пор работает.": "Кеше көшкеннен кейінгі қораптарды ақыры ашып шықтым. Ескі плеер, қазір жоқ телефондардың үш зарядтағышын және жазғы жоспарлар жазылған дәптер таптым. Плеер әлі жұмыс істейді.",
  "Погода сегодня странная: утром светило солнце, к обеду пошёл дождь, а к вечеру обещают снег. Самое время заварить что-нибудь горячее и никуда не торопиться.": "Бүгін ауа райы біртүрлі: таңертең күн шуақты еді, түске қарай жаңбыр жауды, ал кешке қар болады дейді. Ыстық бірдеңе демдеп, ешқайда асықпайтын кез.",
  "Раз, два, три, проверка. Меня хорошо слышно? Сейчас я прочитаю несколько фраз разным тоном: сначала спокойно, потом чуть громче, а в конце совсем тихо, почти шёпотом.": "Бір, екі, үш, тексеру. Мені жақсы естіп тұрсыз ба? Қазір бірнеше сөйлемді әр түрлі үнмен оқимын: алдымен сабырлы, сосын сәл қаттырақ, ал соңында мүлдем ақырын, сыбырлағандай.",
  "Мой кот считает, что клавиатура создана для сна, а монитор нужен, чтобы закрывать его хвостом. Поэтому если в записи что-то зашуршит, знайте: это была командная работа.": "Менің мысығым пернетақта ұйықтауға, ал монитор оны құйрығымен жабуға арналған деп ойлайды. Сондықтан жазбада бірдеңе сыбдырласа, біліңіз: бұл командалық жұмыс еді.",
  "Есть простое правило: если что-то не получается с третьей попытки, надо встать, налить чаю и вернуться через пять минут. Обычно после этого всё получается само.": "Қарапайым ереже бар: бір нәрсе үшінші әрекеттен де шықпаса, орныңыздан тұрып, шай құйып, бес минуттан кейін оралыңыз. Әдетте содан кейін бәрі өзінен-өзі шығады.",
  "Тихо, слышите? Где-то рядом шаги. Сейчас аккуратно выглянем за угол, и если там никого нет, перебежим к двери. Только не шумите, пожалуйста, я серьёзно.": "Ақырын, естисіз бе? Жақын жерде аяқ дыбысы. Қазір бұрыштан абайлап сығалап қараймыз, ешкім болмаса, есікке қарай жүгіреміз. Тек шулай көрмеңіз, өтінемін, шын айтамын.",
  "Проверено": "Тексерілді",
  "Создание новых голосов пока недоступно": "Жаңа дауыс жасау әзірге қолжетімсіз",
  "От 2 секунд речи: запись в браузере или готовые файлы": "2 секунд сөйлеу: осында жазыңыз не файл жүктеңіз",
  "Внутренняя ошибка, попробуйте позже": "Ішкі қате, кейінірек қайталап көріңіз",
  "образцов: {n}": "үлгі: {n}",
  "Образец короче 2 секунд": "Үлгі 2 секундтан қысқа",
  "Образец длиннее 1,5 минуты": "Үлгі 1,5 минуттан ұзын",
  "Слишком шумная запись — попробуйте в тихом месте": "Жазба тым шулы — тыныш жерде жазып көріңіз",
  "В записи слышно несколько голосов": "Жазбада бірнеше дауыс естіледі",
  "Проверка не пройдена: голос не совпадает с образцами": "Тексеруден өтпеді: дауыс үлгілерге сәйкес келмейді",
  "Голос не прошёл правила площадки": "Дауыс платформа ережелеріне сай емес",
  "Проверка не пройдена: запишите образец без музыки и других людей": "Тексеруден өтпеді: музыкасыз әрі басқа адамдарсыз үлгі жазыңыз",
  "Нужно от 2 секунд до 1,5 минуты речи в сумме": "Барлығы 2 секундтан 1,5 минутқа дейін сөйлеу керек",
  "Результат обработки уточняется, загляните чуть позже": "Өңдеу нәтижесі нақтылануда, сәл кейінірек қараңыз",
  "Удалить голос «{n}»?": "«{n}» дауысын жою керек пе?",
  "Навсегда, вместе с образцами": "Мүлдем, үлгілерімен бірге",
  "Например, спокойный, низкий": "Мысалы, сабырлы, жуан",
  "Образец": "Үлгі",
  "Запись или файлы, от 2 секунд": "Жазба не файлдар, 2 секундтан бастап",
  "Имя, описание и согласие": "Аты, сипаттамасы және келісім",
  "Проверка и обучение": "Тексеру және үйрету",
  "Модель STEOS · 1–3 минуты": "STEOS моделі · 1–3 мин",
  "Тихое место без эха": "Жаңғырықсыз тыныш жер",
  "Фоновый шум и музыка попадут в голос": "Фондық шу мен музыка дауысқа енеді",
  "Хороший микрофон": "Жақсы микрофон",
  "Гарнитура или настольный микрофон лучше встроенного": "Гарнитура не үстел микрофоны кіріктірілгенінен жақсы",
  "То же оборудование": "Сол құрылғы",
  "Не меняйте микрофон между записями": "Жазбалар арасында микрофонды ауыстырмаңыз",
  "Под ним голос стоит в списке выбора": "Дауыс таңдау тізімінде осы атпен тұрады",
  "Шумоподавление": "Шуды басу",
  "Включайте, только если в записи слышен шум": "Жазбада шу естілсе ғана қосыңыз",
  "Согласие обязательно": "Келісім міндетті",
  "Клонировать можно свой голос или с согласия владельца": "Өз дауысыңызды не иесінің келісімімен ғана клондауға болады",
  "Проверка образца": "Үлгіні тексеру",
  "Один говорящий, без музыки и шума": "Бір адам сөйлейді, музыкасыз әрі шусыз",
  "Обучение": "Үйрету",
  "Модель STEOS, обычно 1–3 минуты": "STEOS моделі, әдетте 1–3 минут",
  "Голос появится в списке сам": "Дауыс тізімде өзі пайда болады",
  "Проверьте запись": "Жазбаны тексеріңіз",
  "Один голос, без музыки и шума на фоне": "Бір дауыс, фонда музыка мен шу жоқ",
  "Длина образца": "Үлгі ұзақтығы",
  "Нужно не меньше 2 секунд чистой речи": "Кемінде 2 секунд таза сөйлеу керек",
  "Образцы сохранены": "Үлгілер сақталды",
  "Можно попробовать снова с теми же файлами": "Сол файлдармен қайталап көруге болады",
  "Не получилось — попробуйте снова": "Болмады — қайталап көріңіз",
  "Шаг {a} из {b}": "{a}/{b} қадам",
  "Персональный": "Жеке",
  "Дальше": "Әрі қарай",
  "Продолжить": "Жалғастыру",
  "К списку голосов": "Тізімге өту",
  "Результат уточняется": "Нақтылануда",
  "Попробовать снова": "Қайталау",
  "Голос готов": "Дауыс дайын",
  "Опишите голос": "Дауысты сипаттаңыз",
  "Например, Мой голос": "Мысалы, Менің дауысым",
  "Это мой голос или у меня есть согласие его владельца. Я не буду использовать клон для обмана, оскорблений и запрещённого контента": "Бұл менің дауысым немесе иесінің келісімі бар. Клонды алдау, қорлау және тыйым салынған контент үшін қолданбаймын",
  "Загружаем {a} из {b}": "{a}/{b} жүктелуде",
  "Обрабатываем голос": "Дауысты өңдеудеміз",
  "Не получилось создать голос": "Дауыс жасалмады",
  "Результат обработки ещё уточняется. Повтор пока недоступен.": "Өңдеу нәтижесі әлі нақтылануда. Қайталау әзірге қолжетімсіз.",
  "Образцы сохранены — можно попробовать снова с теми же файлами": "Үлгілер сақталды — сол файлдармен қайталап көруге болады",
  "Загруженные файлы": "Жүктелген файлдар",
  "Читаем аудио…": "Аудио оқылуда…",
  "Записать ещё": "Тағы жазу",
  "Ждём разрешение…": "Рұқсат күтілуде…",
  "Разрешите доступ в настройках браузера или загрузите файл": "Браузер баптауларында рұқсат беріңіз не файл жүктеңіз",
  "Другой текст": "Басқа мәтін",
  "Прочитайте вслух": "Дауыстап оқыңыз",
  "Микрофон по умолчанию": "Әдепкі микрофон",
  "Минимум": "Ең аз",
  "Хорошо": "Жақсы",
  "Отлично": "Тамаша",
  "Набрано {a} из {b}": "{a}/{b} жиналды",
  "из {t}": "/ {t}",
  "всё готово": "бәрі дайын",
  "Файлов с ошибкой: {n}": "Қатесі бар файл: {n}",
  "до «{n}» ещё {t}": "«{n}» деңгейіне дейін тағы {t}",
  "Ещё {t} до минимума": "Ең азға дейін тағы {t}",
  "Нужно не меньше 2 секунд": "Кемінде 2 секунд керек",
  "Загрузка образцов": "Үлгілерді жүктеу",
  "Образцы приняты сервером": "Сервер үлгілерді қабылдады",
  "Проверка голоса": "Дауысты тексеру",
  "Пройдена": "Өтті",
  "Не запрашивалась": "Сұралмаған",
  "Результат проверки пока недоступен": "Тексеру нәтижесі әзірге жоқ",
  "Обработка голоса": "Дауысты өңдеу",
  "Не удалось обработать": "Өңдеу мүмкін болмады",
  "Выполняется на сервере": "Серверде орындалуда",
  "Очистка шума": "Шуды тазарту",
  "Пропущено": "Өткізілді",
  "Модель STEOS · один говорящий, без музыки": "STEOS моделі · бір адам, музыкасыз",
  "Обучение голоса": "Дауысты үйрету",
  "Файл больше 20 МБ": "Файл 20 МБ-тан үлкен",
  "Запись {n}": "Жазба {n}",
  "Не удалось прочитать аудио": "Аудио оқылмады",
  "Неподдерживаемый формат": "Қолдау көрсетілмейтін формат",
  "Результат прошлого создания ещё уточняется. Вернитесь к прежнему запросу, чтобы не создать второй клон.": "Алдыңғы жасаудың нәтижесі әлі нақтылануда. Екінші клон жасамау үшін алдыңғы сұрауға оралыңыз.",
  "Проверить прошлое создание": "Алдыңғысын тексеру",
  "Остановить": "Тоқтату",
  "Ждём доступ": "Рұқсат күтілуде",
  "Ещё раз": "Қайталау",
  "Начать запись": "Жазуды бастау",
  "Нажмите на голос в списке, чтобы открыть его карточку: прослушать, переименовать или удалить.": "Картасын ашу үшін тізімдегі дауысты басыңыз: тыңдау, атын өзгерту не жою.",
  "Озвучек": "Дыбыстау",
  "Знаков": "Таңба",
  "Образцов": "Үлгі",
  "Доступна": "Қолжетімді",
  "Недоступна": "Қолжетімсіз",
  "После обучения": "Үйретуден кейін",
  "Голос обучен на ваших записях: образцов {n}, всего {d}": "Дауыс сіздің жазбаларыңызбен үйретілді: {n} үлгі, барлығы {d}",
  "Происхождение: ваши записи. Подробнее": "Шығу тегі: сіздің жазбаларыңыз. Толығырақ",
  "Происхождение": "Шығу тегі",
  "Ваши записи": "Сіздің жазбаларыңыз",
  "Проверка": "Тексеру",
  "Не пройдена": "Өтпеді",
  "Идёт": "Жүріп жатыр",
  "Переозвучка аудио": "Аудионы қайта дыбыстау",
  "Создан": "Жасалды",
  "Доступ": "Қолжетімділік",
  "Только вы": "Тек сіз",
  "Голос пока недоступен для выбора. Обновите список.": "Дауысты әзірге таңдауға болмайды. Тізімді жаңартыңыз.",
  "Голос ещё учится, обычно 1–3 минуты": "Дауыс әлі үйретілуде, әдетте 1–3 минут",
  "Коротко о голосе": "Дауыс туралы қысқаша",
  "О голосе": "Дауыс туралы",
  "Голос не создан": "Дауыс жасалмады",
  "Обработка дольше обычного": "Өңдеу әдеттегіден ұзаққа созылды",
  "Сервер ещё обрабатывает голос. Можно закрыть приложение и вернуться позже.": "Сервер дауысты әлі өңдеп жатыр. Қолданбаны жауып, кейінірек оралуға болады.",
  "Аватар {n} останется без голоса, в кружках зазвучит голос по умолчанию.": "{n} аватары дауыссыз қалады, дөңгелек видеоларда әдепкі дауыс естіледі.",
  "Аватары {n} останутся без голоса, в кружках зазвучит голос по умолчанию.": "{n} аватарлары дауыссыз қалады, дөңгелек видеоларда әдепкі дауыс естіледі.",
  "Записать первый голос": "Алғашқы дауысты жазу",
  "клон|клона|клонов": "клон",
  "в месяц": "айына",
  "{n} C в месяц": "Айына {n} C",
  "{n} своих голосов": "{n} өз дауысыңыз",
  "Оформить": "Рәсімдеу",
  "Подписка активна": "Жазылым белсенді",
  "Подписка «{n}»": "«{n}» жазылымы",
  "{n} голосов ваши": "{n} дауыс сіздікі",
  "Доступно — своих голосов": "Өз дауыстарыңыз қолжетімді",
  "{n} голосов мало?": "{n} дауыс аз ба?",
  "Возьмите {n}": "{n} алыңыз",
  "Нужно больше голосов?": "Көбірек дауыс керек пе?",
  "До {n} с подпиской": "Жазылыммен {n} дейін",
  "Посмотрите доступные подписки": "Қолжетімді жазылымдарды қараңыз",
  "Занято {a} из {b}. Записывайте голоса под разные задачи и настроения": "{a}/{b} пайдаланылды. Түрлі міндет пен көңіл күйге арнап дауыс жазыңыз",
  "Без подписки можно создать {a} {w}. С любой подпиской их будет {b}": "Жазылымсыз {a} {w} жасауға болады. Кез келген жазылыммен — {b} дейін",
  "Без подписки: {n}. Лимит зависит от выбранной подписки.": "Жазылымсыз: {n}. Шектеу таңдалған жазылымға байланысты.",
  "Занято {a} из {b}": "{a}/{b} пайдаланылды",
  "Без подписки · {n}": "Жазылымсыз · {n}",
  "С подпиской · {n}": "Жазылыммен · {n}",
  "Смотреть все подписки": "Барлық жазылымдар",
  "Повторить сохранение": "Қайта сақтау",
  "Сохраняем изменения…": "Өзгерістер сақталуда…",
  "Управление голосами временно недоступно": "Дауыстарды басқару уақытша қолжетімсіз",
  "клон: Мой голос": "Менің дауысым",
  "Свои голоса временно недоступны. Попробуйте обновить список позже.": "Өз дауыстарыңыз уақытша қолжетімсіз. Тізімді кейінірек жаңартып көріңіз.",
  "Сервис голосов временно недоступен. Попробуйте ещё раз позже.": "Дауыс қызметі уақытша қолжетімсіз. Кейінірек қайталап көріңіз.",
  "Не удалось подтвердить лимит голосов. Обновите список позже.": "Дауыс шектеуін растау мүмкін болмады. Тізімді кейінірек жаңартыңыз.",
  "Не удалось подтвердить аккаунт. Попробуйте ещё раз позже.": "Аккаунтты растау мүмкін болмады. Кейінірек қайталап көріңіз.",
  "Имя голоса должно содержать от 2 до 32 символов.": "Дауыс аты 2–32 таңбадан тұруы керек.",
  "Описание должно содержать не больше 120 символов.": "Сипаттама 120 таңбадан аспауы керек.",
  "Добавьте от 1 до 10 подходящих образцов.": "1-ден 10-ға дейін жарамды үлгі қосыңыз.",
  "Превью этого голоса пока недоступно.": "Бұл дауыстың алдын ала тыңдауы әзірге қолжетімсіз.",
  "Не удалось загрузить превью. Попробуйте позже.": "Алдын ала тыңдауды жүктеу мүмкін болмады. Кейінірек көріңіз.",
  "Слишком шумная запись. Попробуйте записать голос в тихом месте.": "Жазба тым шулы. Дауысты тыныш жерде жазып көріңіз.",
  "В записи слышно несколько голосов. Добавьте речь одного человека.": "Жазбада бірнеше дауыс естіледі. Бір адамның сөзін қосыңыз.",
  "Голос не прошёл правила площадки.": "Дауыс платформа ережелеріне сай емес.",
  "Сервис не смог обработать голос. Проверьте статус перед повтором.": "Қызмет дауысты өңдей алмады. Қайталамас бұрын күйін тексеріңіз.",
  "Согласие изменилось или недоступно. Обновите список и подтвердите актуальную версию перед повтором.": "Келісім өзгерді не қолжетімсіз. Қайталамас бұрын тізімді жаңартып, өзекті нұсқаны растаңыз.",
  "Загрузка отклонена. Нажмите кнопку ещё раз, чтобы загрузить образец заново.": "Жүктеуден бас тартылды. Үлгіні қайта жүктеу үшін түймені тағы басыңыз.",
  "Загрузка ещё не подтверждена. Нажмите кнопку ещё раз: сначала проверим прежнюю загрузку.": "Жүктеу әлі расталмады. Түймені тағы басыңыз: алдымен алдыңғы жүктеуді тексереміз.",
  "Выберите аудиофайл MP3, WAV, M4A, OGG или WebM.": "MP3, WAV, M4A, OGG не WebM аудиофайлын таңдаңыз.",
  "Не удалось прочитать аудио. Попробуйте ещё раз или загрузите файл.": "Аудио оқылмады. Қайталап көріңіз не файл жүктеңіз.",
  "Пример звучания": "Дыбыс үлгісі",
  "Пример звучания пока недоступен": "Дыбыс үлгісі әзірге қолжетімсіз",
  "Превью голоса": "Дауыс үлгісі",
  "Прослушать пример": "Үлгіні тыңдау",
  "Скидка {0}% на первый пакет Circle действует {1} {2} после оформления подписки": "Бірінші Circle пакетіне {0}% жеңілдік жазылым рәсімделгеннен кейін {1} {2} жарамды",
  "Вы уже пришли по ссылке партнёра": "Сіз серіктес сілтемесі арқылы келгенсіз",
  "Промокод партнёра уже применён": "Серіктес промокоды қолданылған",
  "Тут откроется тема чата, куда бот прислал {0}": "Мұнда бот нәтижені жіберген чат тақырыбы ашылады: {0}",
  "можно вывести": "шығаруға болады",
  "только в STEOS": "тек STEOS ішінде",
  "Не короче {0} знаков": "Кемінде {0} таңба",
  "Введите почту и пароль": "Пошта мен құпиясөзді енгізіңіз",
  "от {0} знаков": "кемінде {0} таңба",
  "После входа Circle станут общими для бота и аккаунта STEOS. Баланс и вывод есть и на {0}.": "Кіргеннен кейін Circle бот пен STEOS аккаунтына ортақ болады. Теңгерім мен қаражатты шығару {0} сайтында да бар.",
  "Вход или новый аккаунт": "Кіру немесе жаңа аккаунт",
  "Придумайте пароль": "Құпиясөз ойлап табыңыз",
  "Ваш пароль": "Құпиясөзіңіз",
  "Принимаю {0} и {1} STEOS": "STEOS {0} және {1} қабылдаймын",
  "согласие: условия": "шарттарын",
  "согласие: политику конфиденциальности": "құпиялылық саясатын",
  "Пришлём ссылку на почту": "Поштаға сілтеме жібереміз",
  "Откройте ссылку из письма и задайте новый пароль на {0}. Потом войдите здесь с новым паролем.": "Хаттағы сілтемені ашып, {0} сайтында жаңа құпиясөз орнатыңыз. Содан кейін осында жаңа құпиясөзбен кіріңіз.",
  "Ссылка для нового пароля ушла на {0}": "Жаңа құпиясөз сілтемесі {0} поштасына жіберілді",
  "Письма нет? Проверьте папку «Спам».": "Хат келмеді ме? «Спам» қалтасын тексеріңіз.",
  "Аккаунт создан и подключён": "Аккаунт жасалды және қосылды",
  "Баланс бота теперь общий с аккаунтом STEOS.": "Бот теңгерімі енді STEOS аккаунтымен ортақ.",
  "Подтвердите почту по ссылке из письма.": "Поштаны хаттағы сілтеме арқылы растаңыз.",
  "Вывод работает здесь и на {0}.": "Қаражатты шығару осында және {0} сайтында жұмыс істейді.",
  "Открыть {0}": "{0} ашу",
  "Ссылка ушла на {0}. Откройте её, затем проверьте подключение здесь.": "Сілтеме {0} поштасына жіберілді. Оны ашып, қосылуды осында тексеріңіз.",
  "Проверить подключение": "Қосылуды тексеру",
  "Почти готово": "Аз қалды",
  "Почта ещё не подтверждена": "Пошта әлі расталмаған",
  "Не удалось проверить. Попробуйте позже": "Тексеру мүмкін болмады. Кейінірек көріңіз",
  "Озвучиваю тексты голосом героя": "Мәтіндерді кейіпкер даусымен айтамын",
  "Любой голос из библиотеки или свой": "Кітапханадағы кез келген дауыс немесе өзіңіздікі",
  "Озвучиваю тексты голосами героев в STEOS. Попробуйте по моей ссылке, промокод {0}": "STEOS-та мәтіндерді кейіпкерлер даусымен айтамын. Менің сілтемеммен көріңіз, промокод {0}",
  "Пишу текст, персонаж говорит": "Мен жазамын, кейіпкер сөйлейді",
  "Делаю кружки с персонажами в STEOS: пишу текст, а персонаж его говорит. Промокод {0}": "STEOS-та кейіпкерлері бар дөңгелек видео жасаймын: мәтінді жазамын, кейіпкер айтады. Промокод {0}",
  "Свои фото в любом образе": "Өз фотоңыз кез келген бейнеде",
  "Фотосессия в любом образе по паре моих фото, без студии. STEOS, промокод {0}": "Бірнеше фотомнан кез келген бейнеде фотосессия, студиясыз. STEOS, промокод {0}",
  "Вы в кадре, монтаж и музыка сами": "Сіз кадрдасыз, монтаж бен музыка өзі",
  "Снимаюсь в рилсах одной кнопкой в STEOS: сюжет, монтаж и музыка уже в шаблоне. Промокод {0}": "STEOS-та бір батырмамен рилстерге түсемін: сюжет, монтаж және музыка шаблонда дайын. Промокод {0}",
  "Персонаж оживает": "Кейіпкер жанданады",
  "Говорит вашим текстом": "Сіздің мәтініңізді айтады",
  "Персонаж говорит моим текстом и своим голосом. Попробуйте STEOS, промокод {0}": "Кейіпкер менің мәтінімді өз даусымен айтады. STEOS-ты көріңіз, промокод {0}",
  "Клон голоса за минуту": "Бір минутта дауыс клоны",
  "Запишите от 2 секунд, дальше говорит клон": "2 секунд жазыңыз, әрі қарай клон сөйлейді",
  "Клон моего голоса за минуту в STEOS: теперь он озвучивает всё сам. Промокод {0}": "STEOS-та бір минутта дауысымның клоны: енді бәрін өзі айтады. Промокод {0}",
  "Старому фото цвет и резкость": "Ескі фотоға түс пен анықтық",
  "Восстановление за минуту": "Бір минутта қалпына келтіру",
  "Возвращаю старым фото цвет и резкость в STEOS. Промокод {0}": "STEOS-та ескі фотоларға түс пен анықтықты қайтарамын. Промокод {0}",
  "По ссылке или промокоду": "Сілтеме немесе промокод арқылы",
  "Дарю +{0} C и скидку {1}% на первый пакет в STEOS по моему промокоду {2}": "Менің {2} промокодыммен STEOS-та +{0} C және бірінші пакетке {1}% жеңілдік сыйлаймын",
  "Кавер на любую песню": "Кез келген әнге кавер",
  "Рок, джаз, lo-fi любым голосом": "Рок, джаз, lo-fi кез келген дауыспен",
  "Кавер на любую песню любым голосом в STEOS. Промокод {0}": "STEOS-та кез келген әнге кез келген дауыспен кавер. Промокод {0}",
  "Мой аватар в любом образе": "Менің аватарым кез келген бейнеде",
  "Свой аватар из 10 фото": "10 фотодан өз аватарыңыз",
  "Мой аватар в любом образе: собран из 10 фото в STEOS. Промокод {0}": "Менің аватарым кез келген бейнеде: STEOS-та 10 фотодан жасалған. Промокод {0}",
  "Это я, только говорю вашим текстом": "Бұл мен, тек сіздің мәтініңізді айтамын",
  "сторис: Мой голос": "Менің даусым",
  "на баланс сразу": "теңгерімге бірден",
  "на первый пакет Circle": "бірінші Circle пакетіне",
  "Сторис открыта в Telegram": "Сторис Telegram-да ашылды",
  "Сторис готова": "Сторис дайын",
  "Осталось нажать «Опубликовать» в редакторе Telegram": "Telegram редакторында «Жариялау» батырмасын басу қалды",
  "Тут откроется редактор сторис Telegram с этой картинкой и подписью": "Мұнда осы сурет пен жазуы бар Telegram сторис редакторы ашылады",
  "Подпись к сторис": "Сторис жазуы",
  "Кнопка-ссылка на сторис в Telegram есть только с Premium. Промокод на картинке видят все.": "Telegram сторисіндегі сілтеме батырмасы тек Premium-мен бар. Суреттегі промокодты бәрі көреді.",
  "Опубликовать в сторис": "Сториске жариялау",
  "Попробовать STEOS": "STEOS-ты байқап көру",
  "Не удалось подготовить сторис. Попробуйте ещё раз": "Стористі дайындау мүмкін болмады. Қайта көріңіз",
  "Сторис отправляет Telegram: откройте мини-приложение в Telegram": "Стористі Telegram жібереді: Mini App-ты Telegram-да ашыңыз",
  "Ссылка и промокод уже на картинке": "Сілтеме мен промокод суретте бар",
  "Попробуйте STEOS по моей ссылке. Промокод {0}": "STEOS-ты менің сілтемеммен байқап көріңіз. Промокод {0}",
  "Попробуйте STEOS по моей ссылке: +{0} C и скидка {1}% на первый пакет. Промокод {2}": "STEOS-ты менің сілтемеммен байқап көріңіз: +{0} C және бірінші пакетке {1}% жеңілдік. Промокод {2}",
  "Ссылка": "Сілтеме",
  "Скопировать ссылку": "Сілтемені көшіру",
  "Друзьям {0} и {1} на первый пакет": "Достарға {0} және бірінші пакетке {1}",
  "Промокод выделен: скопируйте вручную": "Промокод белгіленді: қолмен көшіріңіз",
  "Ссылка выделена: скопируйте вручную": "Сілтеме белгіленді: қолмен көшіріңіз",
  "Ссылка скопирована": "Сілтеме көшірілді",
  "Ссылка выделена: скопируйте её вручную": "Сілтеме белгіленді: қолмен көшіріңіз",
  "Ссылка выделена": "Сілтеме белгіленді",
  "Вы пришли по приглашению": "Сіз шақырумен келдіңіз",
  "{0} C на баланс": "Теңгерімге {0} C",
  "Сгорят через {0} {1}": "{0} {1} өткен соң күйеді",
  "{0} на первый пакет Circle": "Бірінші Circle пакетіне {0}",
  "{0} {1} после оформления подписки": "Жазылымнан кейін {0} {1}",
  "Пакеты Circle можно купить с любой подпиской. Скидка начнёт действовать, как только вы её оформите.": "Circle пакеттерін кез келген жазылыммен сатып алуға болады. Жеңілдік жазылымды рәсімдеген сәттен басталады.",
  "Выбрать тариф": "Тариф таңдау",
  "QR-код ссылки приглашения, промокод {0}": "Шақыру сілтемесінің QR-коды, промокод {0}",
  "Друг наведёт камеру и откроет бота": "Досыңыз камераны бағыттап, ботты ашады",
  "Цвет карточки": "Карточка түсі",
  "Скачать картинку": "Суретті жүктеу",
  "Аврора": "Аврора",
  "Закат": "Шапақ",
  "Океан": "Мұхит",
  "Графит": "Графит",
  "Партнёры": "Серіктестер",
  "Нашёл бота, где любой персонаж скажет в кружке твой текст. Там же фото, видео и озвучка любым голосом, всё прямо в Telegram.": "Кез келген кейіпкер сенің мәтініңді бейнехабарда айтатын бот таптым. Сонымен қатар фото, бейне және кез келген дауыспен дыбыстау бар, бәрі тікелей Telegram-да.",
  "Делюсь находкой: STEOS, бот в Telegram, где я делаю кружки с персонажами, озвучку и фото. Пишете текст, выбираете голос, и через минуту готово.": "Бір олжаммен бөлісемін: STEOS — Telegram-дағы бот, онда мен кейіпкерлермен бейнехабарлар, дыбыстау және фото жасаймын. Мәтін жазасыз, дауыс таңдайсыз, бір минутта дайын.",
  "Восстанавливаю наши старые семейные фото в STEOS: за минуту возвращает цвет и резкость. Пришлите мне снимки, которые хотите обновить, или попробуйте сами.": "Ескі отбасылық фотоларымызды STEOS-та қалпына келтіріп жүрмін: бір минутта түсі мен анықтығын қайтарады. Жаңартқыңыз келетін суреттерді маған жіберіңіз немесе өзіңіз байқап көріңіз.",
  "Кто хотел кружок голосом любимого героя? В STEOS пишешь текст, и персонаж из игры или сериала его произносит. Это бот в Telegram.": "Сүйікті кейіпкеріңнің дауысымен бейнехабар кім қалады? STEOS-та мәтін жазасың, ал ойын не сериал кейіпкері оны айтады. Бұл Telegram-дағы бот.",
  "Фото товара, карточки с преимуществами и описания для маркетплейсов делаю в STEOS за пару минут, без студии и дизайнера. Может, и вам пригодится.": "Тауар фотоларын, артықшылықтар карточкаларын және маркетплейске сипаттамаларды STEOS-та бірнеше минутта, студиясыз әрі дизайнерсіз жасаймын. Сізге де пайдасы тиюі мүмкін.",
  "Озвучиваю ролики своим клоном голоса, снимаюсь в рилсах по готовым шаблонам и записываю каверы. Всё в одном боте STEOS в Telegram.": "Роликтерді өз дауыс клонымен дыбыстаймын, дайын үлгілер бойынша рилстерге түсемін және каверлер жазамын. Бәрі Telegram-дағы бір STEOS ботында.",
  "По моей ссылке +{0} C на старт.": "Менің сілтемем арқылы бастауға +{0} C.",
  "По моей ссылке +{0} C и −{1}% на первый пакет.": "Менің сілтемем арқылы: +{0} C және бірінші пакетке −{1}%.",
  "Попробуй сам.": "Өзің байқап көр.",
  "Попробуйте сами.": "Өзіңіз байқап көріңіз.",
  "Актёры": "Актерлер",
  "Персонажи и актёры": "Кейіпкерлер мен актерлер",
  "По запросу «{q}» голосов нет. Попробуйте другое слово или загляните в подборки": "«{q}» сұрауы бойынша дауыс жоқ. Басқа сөзді байқап көріңіз немесе топтамаларды қараңыз",
  "Здесь пока нет голосов. Загляните в другие вкладки или подборки": "Мұнда әзірге дауыс жоқ. Басқа қойындыларды немесе топтамаларды қараңыз",
  "Голос вернётся на экран создания": "Дауыс жасау экранына оралады",
  "После выбора пишите текст для озвучки в чат бота": "Сосын дыбыстайтын мәтінді бот чатына жазыңыз",
  "От Я до А": "Я-дан А-ға дейін",
  "Сортировка и фильтры": "Сұрыптау және сүзгілер",
  "Сбросить": "Тастау",
  "Чаще всего выбирают": "Жиі таңдалатындар",
  "Сначала свежие": "Алдымен жаңалары",
  "Сначала давние": "Алдымен ескілері",
  "Сначала недорогие": "Алдымен арзандары",
  "Сначала короткие ролики": "Алдымен қысқа бейнелер",
  "По названию": "Атауы бойынша",
  "По названию, с конца алфавита": "Атауы бойынша, әліпбидің соңынан",
  "Вертикальные ролики": "Тік бейнелер",
  "Картинки и посты": "Суреттер мен посттар",
  "Горизонтальные ролики": "Көлденең бейнелер",
  "Видеосообщения Telegram": "Telegram бейнехабарлары",
  "Один человек в кадре": "Кадрда бір адам",
  "Трое и больше": "Үш және одан көп",
  "С ребёнком": "Баламен",
  "С питомцем": "Үй жануарымен",
  "Двое человек в кадре": "Кадрда екі адам",
  "О разделе": "Бөлім туралы",
  "Превращает текст в речь: голос из каталога или ваш клон, настройки интонации и скорости.": "Мәтінді сөзге айналдырады: каталогтағы дауыс немесе сіздің клоныңыз, интонация мен жылдамдық баптаулары.",
  "Копия вашего голоса по записи: ею можно озвучивать любые тексты.": "Жазба бойынша жасалған дауысыңыздың көшірмесі: онымен кез келген мәтінді дыбыстауға болады.",
  "AI-студия: ролики, фото, кружки и другие шаблоны с вами, близкими и персонажами.": "AI-студия: сізбен, жақындарыңызбен және кейіпкерлермен роликтер, фото, дөңгелек бейнелер және басқа үлгілер.",
  "Кредиты (C) на счёте и пополнение. Кредиты списываются за озвучку и заказы студии.": "Шоттағы кредиттер (C) және толтыру. Кредиттер дыбыстау мен студия тапсырыстарына жұмсалады.",
  "Задания и награды: выполняйте задания и получайте кредиты.": "Тапсырмалар мен марапаттар: тапсырмаларды орындап, кредит алыңыз.",
  "Все ваши озвучки и заказы студии: послушать, скачать или повторить.": "Барлық дыбыстауларыңыз бен студия тапсырыстарыңыз: тыңдау, жүктеп алу немесе қайталау.",
  "Ваш профиль и данные аккаунта.": "Профиліңіз және аккаунт деректері.",
  "Настройки приложения: язык, валюта и уведомления.": "Қолданба баптаулары: тіл, валюта және хабарландырулар.",
  "Ответы на частые вопросы и связь с поддержкой.": "Жиі қойылатын сұрақтарға жауаптар және қолдау қызметімен байланыс.",
  "Партнёрская программа: приглашайте друзей и получайте процент с их пополнений.": "Серіктестік бағдарлама: достарыңызды шақырып, олардың толтыруларынан пайыз алыңыз.",
  "Озвучка больших текстов и сценариев по ролям.": "Ұзын мәтіндер мен сценарийлерді рөлдер бойынша дыбыстау.",
  "Вы или один близкий": "Сіз немесе бір жақыныңыз",
  "Вы и близкий": "Сіз және жақыныңыз",
  "Товары и места": "Тауарлар мен орындар",
  "Фото товара, блюда или места": "Тауар, тағам немесе орын фотосы",
  "В избранном": "Таңдаулыларда",
  "Голоса и персонажи, которые вы отметили сердцем": "Жүрекшемен белгілеген дауыстар мен кейіпкерлер",
  "Нажмите — выбрать голос": "Дауысты таңдау үшін басыңыз",
  "Удерживайте — карточка голоса": "Дауыс карточкасы үшін ұстап тұрыңыз",
  "Карточка голоса или персонажа": "Дауыс немесе кейіпкер карточкасы",
  "Нажмите на голос, чтобы выбрать его": "Таңдау үшін дауысты басыңыз",
  "Удерживайте, чтобы открыть карточку голоса": "Дауыс карточкасын ашу үшін басып тұрыңыз",
  "Удаление голоса": "Дауысты жою",
  "Подсказка": "Кеңес",
  "Пример звучания пока недоступен. Попробуйте позже.": "Үлгі әзірге қолжетімсіз. Кейінірек қайталаңыз.",
  "Языков: {0}": "Тілдер: {0}",
  "Ещё языков: {0}": "Тағы тілдер: {0}",
  "Ход примера": "Үлгінің барысы",
  "Голос говорит на {0} языках": "Дауыс {0} тілде сөйлейді",
  "Все голоса мультиязычные и озвучат текст на любом языке системы.": "Барлық дауыстар көптілді, мәтінді жүйенің кез келген тілінде дыбыстайды.",
  "Голоса подборки": "Топтама дауыстары",
  "Удерживайте голос, чтобы открыть его": "Ашу үшін дауысты басып тұрыңыз",
  "Назад к голосу": "Дауысқа оралу",
  "Оригинал голоса говорил на {0} языке": "Дауыстың түпнұсқасы {0} тілінде сөйлеген",
  "Происхождение: {0}. Подробнее": "Шығу тегі: {0}. Толығырақ",
  "Новый": "Жаңа",
  "Официальный": "Ресми",
  "Актёр": "Актёр",
  "Удерживайте, чтобы послушать": "Тыңдау үшін басып тұрыңыз",
  "Удерживайте строку голоса или нажмите её правой кнопкой мыши, чтобы открыть карточку голоса. Персонаж открывается обычным нажатием.": "Дауыс карточкасын ашу үшін дауыс жолын басып тұрыңыз немесе тінтуірдің оң жақ батырмасымен басыңыз. Кейіпкер қарапайым басумен ашылады.",
  "Подборка · Голосов: {0}": "Топтама · Дауыстар: {0}",
  "Доступные голоса появятся в каталоге. Здесь можно будет прослушать пример и выбрать голос для бота.": "Қолжетімді дауыстар каталогта пайда болады. Мұнда үлгіні тыңдап, бот үшін дауыс таңдауға болады.",
  "Зажмите голос": "Дауысты басып тұрыңыз",
  "Удерживайте строку голоса, чтобы открыть его карточку: прослушать и посмотреть подборки. Короткое нажатие выбирает голос.": "Дауыс жолын басып тұрсаңыз, оның карточкасы ашылады: тыңдап, топтамаларын көруге болады. Қысқа басу дауысты таңдайды.",
  "Нажмите на аватарку": "Аватарды басыңыз",
  "Круглая аватарка в строке проигрывает пример голоса. Нажмите ещё раз, чтобы остановить. Нажатие на саму строку выбирает голос.": "Жолдағы дөңгелек аватар дауыс үлгісін ойнатады. Тоқтату үшін қайта басыңыз. Жолдың өзін басу дауысты таңдайды.",
  "Сохраняйте в избранное": "Таңдаулыларға сақтаңыз",
  "Нажмите сердце в карточке голоса или персонажа — они соберутся в подборке «Избранное», первой в «Подборках» и на «Рекомендуем». Нажмите ещё раз, чтобы убрать.": "Дауыс немесе кейіпкер карточкасындағы жүректі басыңыз — олар «Таңдаулылар» топтамасына жиналады, ол «Топтамаларда» және «Ұсынамыз» бөлімінде бірінші тұрады. Алып тастау үшін қайта басыңыз.",
  "Запишите свой голос": "Өз дауысыңызды жазыңыз",
  "30 секунд речи или пара файлов, и через две минуты ваш голос появится во всех инструментах с озвучкой. Нажмите «Записать» и читайте текст с экрана.": "30 секунд сөз немесе бірнеше файл — екі минуттан кейін дауысыңыз дыбыстау құралдарының бәрінде пайда болады. «Жазу» батырмасын басып, экрандағы мәтінді оқыңыз.",
  "Читать полностью": "Толық оқу",
  "Голос STEOS": "STEOS дауысы",
  "Назад к персонажу": "Кейіпкерге оралу",
  "Назад к списку": "Тізімге оралу",
  "Актёр STEOS": "STEOS актёры",
  "Персонаж STEOS": "STEOS кейіпкері",
  "Об актёре": "Актёр туралы",
  "О персонаже": "Кейіпкер туралы",
  "Голоса актёра": "Актёр дауыстары",
  "Голоса персонажа": "Кейіпкер дауыстары",
  "шапка: Мой голос": "Менің дауысым",
  "Пример голоса «{0}»": "«{0}» дауысының үлгісі",
  "Ещё языки": "Басқа тілдер",
  "Юзеры": "Пайдаланушылар",
  "Лайки": "Лайктар",
  "Пол": "Жынысы",
  "В каталоге с": "Каталогта",
  "Автор": "Авторы",
  "Откуда": "Қайдан",
  "Характер": "Мінезі",
  "Голосов": "Дауыстар",
  "Мужской": "Ер",
  "Женский": "Әйел",
  "Детский": "Балалар",
  "Не указан": "Көрсетілмеген",
  "Голос персонажа": "Кейіпкер дауысы",
  "Выберите поддерживаемый аудиофайл до {0} МБ.": "{0} МБ-қа дейінгі қолдау көрсетілетін аудиофайлды таңдаңыз.",
  "пол: Детский": "Балалар",
  "Состав подборки": "Топтама құрамы",
  "Закрыть выбор голоса": "Дауыс таңдауын жабу",
  "Не удалось открыть запись для прослушивания.": "Жазбаны тыңдау үшін ашу мүмкін болмады.",
  "Использовать готовую запись": "Дайын жазбаны пайдалану",
  "Подтвердите права на материалы, чтобы взять запись.": "Жазбаны алу үшін материалдарға құқығыңызды растаңыз.",
  "Работа из доната": "Донаттан келген жұмыс",
  "Модель синтеза": "Синтез моделі",
  "Новая модель": "Жаңа модель",
  "Прежняя модель": "Бұрынғы модель",
  "Удерживайте — карточка голоса и модель синтеза": "Басып тұрыңыз — дауыс картасы және синтез моделі",
  "Модель для озвучки в чате": "Чаттағы дыбыстау моделі",
  "Новая модель: эмоции и живая интонация, вопросы, много языков, клоны голоса": "Жаңа модель: эмоциялар мен табиғи интонация, сұрақтар, көп тіл, дауыс клондары",
  "Прежняя модель: только пять языков, без эмоций и вопросительной интонации, без клонов": "Бұрынғы модель: тек бес тіл, эмоциясыз және сұрақ интонациясыз, клондарсыз",
  "Активная модель: STEOS Voice": "Белсенді модель: STEOS Voice",
  "Активная модель:": "Белсенді модель:",
  "Новая модель: 19 языков, естественное звучание с живыми интонациями — без металла и роботизированности, качественное клонирование голоса": "Жаңа модель: 19 тіл, жанды интонациясы бар табиғи дыбыс — металсыз және роботсыз, сапалы дауыс клондау",
  "Прежняя модель: только 5 языков, без эмоций и вопросительной интонации, без клонов голоса": "Бұрынғы модель: тек 5 тіл, эмоциясыз және сұрақ интонациясыз, дауыс клондарынсыз",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из этих языков.": "STEOS Voice {0} моделінде барлық дауыс көптілді және мәтінді осы тілдердің кез келгенінде дыбыстайды.",
  "На модели STEOS Voice {0} все голоса мультиязычные и озвучат текст на любом из {1}.": "STEOS Voice {0} моделінде барлық дауыс көптілді және мәтінді {1} кез келгенінде дыбыстайды.",
  "этих языков": "осы тілдердің",
  "Языки озвучки": "Дыбыстау тілдері",
  "Любой голос на модели STEOS Voice {0} озвучит текст на каждом из этих языков": "STEOS Voice {0} моделіндегі кез келген дауыс мәтінді осы тілдердің әрқайсысында дыбыстайды",
  "Все голоса": "Барлық дауыстар",
  "Озвучка текста и переозвучка": "Мәтінді дыбыстау және дауысты ауыстыру",
  "Переозвучка записи": "Жазбадағы дауысты ауыстыру",
  "Меняют голос в вашей записи": "Жазбаңыздағы дауысты ауыстырады",
  "Выберите голос для переозвучки записи": "Жазбадағы дауысты ауыстыру үшін дауыс таңдаңыз",
  "Голос выбран — вернитесь в чат и нажмите «Продолжить переозвучку»": "Дауыс таңдалды — чатқа оралып, «Дауысты ауыстыруды жалғастыру» түймесін басыңыз"
}
